var vi = Object.defineProperty;
var bi = (e, t, r) => t in e ? vi(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var Rt = (e, t, r) => bi(e, typeof t != "symbol" ? t + "" : t, r);
import * as re from "react";
import z, { isValidElement as _o, cloneElement as _n, useState as tr, useEffect as rn, useRef as Ei } from "react";
import * as Br from "react-dom";
import Ar, { createPortal as Ti } from "react-dom";
var Oi = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function sr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var nn = { exports: {} }, Ht = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Rn;
function wi() {
  if (Rn) return Ht;
  Rn = 1;
  var e = z, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), o = Object.prototype.hasOwnProperty, n = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(a, l, f) {
    var u, c = {}, h = null, m = null;
    f !== void 0 && (h = "" + f), l.key !== void 0 && (h = "" + l.key), l.ref !== void 0 && (m = l.ref);
    for (u in l) o.call(l, u) && !i.hasOwnProperty(u) && (c[u] = l[u]);
    if (a && a.defaultProps) for (u in l = a.defaultProps, l) c[u] === void 0 && (c[u] = l[u]);
    return { $$typeof: t, type: a, key: h, ref: m, props: c, _owner: n.current };
  }
  return Ht.Fragment = r, Ht.jsx = s, Ht.jsxs = s, Ht;
}
var zt = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Pn;
function Si() {
  return Pn || (Pn = 1, process.env.NODE_ENV !== "production" && function() {
    var e = z, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), o = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), a = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), f = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), c = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), y = Symbol.iterator, g = "@@iterator";
    function _(p) {
      if (p === null || typeof p != "object")
        return null;
      var T = y && p[y] || p[g];
      return typeof T == "function" ? T : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function E(p) {
      {
        for (var T = arguments.length, N = new Array(T > 1 ? T - 1 : 0), U = 1; U < T; U++)
          N[U - 1] = arguments[U];
        F("error", p, N);
      }
    }
    function F(p, T, N) {
      {
        var U = x.ReactDebugCurrentFrame, ne = U.getStackAddendum();
        ne !== "" && (T += "%s", N = N.concat([ne]));
        var ie = N.map(function(ee) {
          return String(ee);
        });
        ie.unshift("Warning: " + T), Function.prototype.apply.call(console[p], console, ie);
      }
    }
    var M = !1, O = !1, W = !1, q = !1, ve = !1, Se;
    Se = Symbol.for("react.module.reference");
    function he(p) {
      return !!(typeof p == "string" || typeof p == "function" || p === o || p === i || ve || p === n || p === f || p === u || q || p === m || M || O || W || typeof p == "object" && p !== null && (p.$$typeof === h || p.$$typeof === c || p.$$typeof === s || p.$$typeof === a || p.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      p.$$typeof === Se || p.getModuleId !== void 0));
    }
    function pe(p, T, N) {
      var U = p.displayName;
      if (U)
        return U;
      var ne = T.displayName || T.name || "";
      return ne !== "" ? N + "(" + ne + ")" : N;
    }
    function Ee(p) {
      return p.displayName || "Context";
    }
    function me(p) {
      if (p == null)
        return null;
      if (typeof p.tag == "number" && E("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof p == "function")
        return p.displayName || p.name || null;
      if (typeof p == "string")
        return p;
      switch (p) {
        case o:
          return "Fragment";
        case r:
          return "Portal";
        case i:
          return "Profiler";
        case n:
          return "StrictMode";
        case f:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof p == "object")
        switch (p.$$typeof) {
          case a:
            var T = p;
            return Ee(T) + ".Consumer";
          case s:
            var N = p;
            return Ee(N._context) + ".Provider";
          case l:
            return pe(p, p.render, "ForwardRef");
          case c:
            var U = p.displayName || null;
            return U !== null ? U : me(p.type) || "Memo";
          case h: {
            var ne = p, ie = ne._payload, ee = ne._init;
            try {
              return me(ee(ie));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var be = Object.assign, Fe = 0, _e, Me, Ge, it, S, P, Y;
    function D() {
    }
    D.__reactDisabledLog = !0;
    function $() {
      {
        if (Fe === 0) {
          _e = console.log, Me = console.info, Ge = console.warn, it = console.error, S = console.group, P = console.groupCollapsed, Y = console.groupEnd;
          var p = {
            configurable: !0,
            enumerable: !0,
            value: D,
            writable: !0
          };
          Object.defineProperties(console, {
            info: p,
            log: p,
            warn: p,
            error: p,
            group: p,
            groupCollapsed: p,
            groupEnd: p
          });
        }
        Fe++;
      }
    }
    function j() {
      {
        if (Fe--, Fe === 0) {
          var p = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: be({}, p, {
              value: _e
            }),
            info: be({}, p, {
              value: Me
            }),
            warn: be({}, p, {
              value: Ge
            }),
            error: be({}, p, {
              value: it
            }),
            group: be({}, p, {
              value: S
            }),
            groupCollapsed: be({}, p, {
              value: P
            }),
            groupEnd: be({}, p, {
              value: Y
            })
          });
        }
        Fe < 0 && E("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var B = x.ReactCurrentDispatcher, H;
    function V(p, T, N) {
      {
        if (H === void 0)
          try {
            throw Error();
          } catch (ne) {
            var U = ne.stack.trim().match(/\n( *(at )?)/);
            H = U && U[1] || "";
          }
        return `
` + H + p;
      }
    }
    var J = !1, K;
    {
      var ge = typeof WeakMap == "function" ? WeakMap : Map;
      K = new ge();
    }
    function A(p, T) {
      if (!p || J)
        return "";
      {
        var N = K.get(p);
        if (N !== void 0)
          return N;
      }
      var U;
      J = !0;
      var ne = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var ie;
      ie = B.current, B.current = null, $();
      try {
        if (T) {
          var ee = function() {
            throw Error();
          };
          if (Object.defineProperty(ee.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(ee, []);
            } catch (le) {
              U = le;
            }
            Reflect.construct(p, [], ee);
          } else {
            try {
              ee.call();
            } catch (le) {
              U = le;
            }
            p.call(ee.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (le) {
            U = le;
          }
          p();
        }
      } catch (le) {
        if (le && U && typeof le.stack == "string") {
          for (var w = le.stack.split(`
`), d = U.stack.split(`
`), b = w.length - 1, C = d.length - 1; b >= 1 && C >= 0 && w[b] !== d[C]; )
            C--;
          for (; b >= 1 && C >= 0; b--, C--)
            if (w[b] !== d[C]) {
              if (b !== 1 || C !== 1)
                do
                  if (b--, C--, C < 0 || w[b] !== d[C]) {
                    var Z = `
` + w[b].replace(" at new ", " at ");
                    return p.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", p.displayName)), typeof p == "function" && K.set(p, Z), Z;
                  }
                while (b >= 1 && C >= 0);
              break;
            }
        }
      } finally {
        J = !1, B.current = ie, j(), Error.prepareStackTrace = ne;
      }
      var de = p ? p.displayName || p.name : "", ce = de ? V(de) : "";
      return typeof p == "function" && K.set(p, ce), ce;
    }
    function Oe(p, T, N) {
      return A(p, !1);
    }
    function xe(p) {
      var T = p.prototype;
      return !!(T && T.isReactComponent);
    }
    function We(p, T, N) {
      if (p == null)
        return "";
      if (typeof p == "function")
        return A(p, xe(p));
      if (typeof p == "string")
        return V(p);
      switch (p) {
        case f:
          return V("Suspense");
        case u:
          return V("SuspenseList");
      }
      if (typeof p == "object")
        switch (p.$$typeof) {
          case l:
            return Oe(p.render);
          case c:
            return We(p.type, T, N);
          case h: {
            var U = p, ne = U._payload, ie = U._init;
            try {
              return We(ie(ne), T, N);
            } catch {
            }
          }
        }
      return "";
    }
    var Xe = Object.prototype.hasOwnProperty, Je = {}, dt = x.ReactDebugCurrentFrame;
    function Ze(p) {
      if (p) {
        var T = p._owner, N = We(p.type, p._source, T ? T.type : null);
        dt.setExtraStackFrame(N);
      } else
        dt.setExtraStackFrame(null);
    }
    function mr(p, T, N, U, ne) {
      {
        var ie = Function.call.bind(Xe);
        for (var ee in p)
          if (ie(p, ee)) {
            var w = void 0;
            try {
              if (typeof p[ee] != "function") {
                var d = Error((U || "React class") + ": " + N + " type `" + ee + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof p[ee] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw d.name = "Invariant Violation", d;
              }
              w = p[ee](T, ee, U, N, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (b) {
              w = b;
            }
            w && !(w instanceof Error) && (Ze(ne), E("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", U || "React class", N, ee, typeof w), Ze(null)), w instanceof Error && !(w.message in Je) && (Je[w.message] = !0, Ze(ne), E("Failed %s type: %s", N, w.message), Ze(null));
          }
      }
    }
    var yr = Array.isArray;
    function Dt(p) {
      return yr(p);
    }
    function jt(p) {
      {
        var T = typeof Symbol == "function" && Symbol.toStringTag, N = T && p[Symbol.toStringTag] || p.constructor.name || "Object";
        return N;
      }
    }
    function ht(p) {
      try {
        return Qe(p), !1;
      } catch {
        return !0;
      }
    }
    function Qe(p) {
      return "" + p;
    }
    function et(p) {
      if (ht(p))
        return E("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", jt(p)), Qe(p);
    }
    var st = x.ReactCurrentOwner, gr = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ft, Et, Tt;
    Tt = {};
    function Ot(p) {
      if (Xe.call(p, "ref")) {
        var T = Object.getOwnPropertyDescriptor(p, "ref").get;
        if (T && T.isReactWarning)
          return !1;
      }
      return p.ref !== void 0;
    }
    function wt(p) {
      if (Xe.call(p, "key")) {
        var T = Object.getOwnPropertyDescriptor(p, "key").get;
        if (T && T.isReactWarning)
          return !1;
      }
      return p.key !== void 0;
    }
    function Ue(p, T) {
      if (typeof p.ref == "string" && st.current && T && st.current.stateNode !== T) {
        var N = me(st.current.type);
        Tt[N] || (E('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', me(st.current.type), p.ref), Tt[N] = !0);
      }
    }
    function at(p, T) {
      {
        var N = function() {
          Ft || (Ft = !0, E("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", T));
        };
        N.isReactWarning = !0, Object.defineProperty(p, "key", {
          get: N,
          configurable: !0
        });
      }
    }
    function Wt(p, T) {
      {
        var N = function() {
          Et || (Et = !0, E("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", T));
        };
        N.isReactWarning = !0, Object.defineProperty(p, "ref", {
          get: N,
          configurable: !0
        });
      }
    }
    var Ut = function(p, T, N, U, ne, ie, ee) {
      var w = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: p,
        key: T,
        ref: N,
        props: ee,
        // Record the component responsible for creating this element.
        _owner: ie
      };
      return w._store = {}, Object.defineProperty(w._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(w, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: U
      }), Object.defineProperty(w, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ne
      }), Object.freeze && (Object.freeze(w.props), Object.freeze(w)), w;
    };
    function Wr(p, T, N, U, ne) {
      {
        var ie, ee = {}, w = null, d = null;
        N !== void 0 && (et(N), w = "" + N), wt(T) && (et(T.key), w = "" + T.key), Ot(T) && (d = T.ref, Ue(T, ne));
        for (ie in T)
          Xe.call(T, ie) && !gr.hasOwnProperty(ie) && (ee[ie] = T[ie]);
        if (p && p.defaultProps) {
          var b = p.defaultProps;
          for (ie in b)
            ee[ie] === void 0 && (ee[ie] = b[ie]);
        }
        if (w || d) {
          var C = typeof p == "function" ? p.displayName || p.name || "Unknown" : p;
          w && at(ee, C), d && Wt(ee, C);
        }
        return Ut(p, w, d, ne, U, st.current, ee);
      }
    }
    var lt = x.ReactCurrentOwner, mt = x.ReactDebugCurrentFrame;
    function ct(p) {
      if (p) {
        var T = p._owner, N = We(p.type, p._source, T ? T.type : null);
        mt.setExtraStackFrame(N);
      } else
        mt.setExtraStackFrame(null);
    }
    var tt;
    tt = !1;
    function Bt(p) {
      return typeof p == "object" && p !== null && p.$$typeof === t;
    }
    function vr() {
      {
        if (lt.current) {
          var p = me(lt.current.type);
          if (p)
            return `

Check the render method of \`` + p + "`.";
        }
        return "";
      }
    }
    function ye(p) {
      return "";
    }
    var rt = {};
    function Ur(p) {
      {
        var T = vr();
        if (!T) {
          var N = typeof p == "string" ? p : p.displayName || p.name;
          N && (T = `

Check the top-level render call using <` + N + ">.");
        }
        return T;
      }
    }
    function $t(p, T) {
      {
        if (!p._store || p._store.validated || p.key != null)
          return;
        p._store.validated = !0;
        var N = Ur(T);
        if (rt[N])
          return;
        rt[N] = !0;
        var U = "";
        p && p._owner && p._owner !== lt.current && (U = " It was passed a child from " + me(p._owner.type) + "."), ct(p), E('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', N, U), ct(null);
      }
    }
    function St(p, T) {
      {
        if (typeof p != "object")
          return;
        if (Dt(p))
          for (var N = 0; N < p.length; N++) {
            var U = p[N];
            Bt(U) && $t(U, T);
          }
        else if (Bt(p))
          p._store && (p._store.validated = !0);
        else if (p) {
          var ne = _(p);
          if (typeof ne == "function" && ne !== p.entries)
            for (var ie = ne.call(p), ee; !(ee = ie.next()).done; )
              Bt(ee.value) && $t(ee.value, T);
        }
      }
    }
    function br(p) {
      {
        var T = p.type;
        if (T == null || typeof T == "string")
          return;
        var N;
        if (typeof T == "function")
          N = T.propTypes;
        else if (typeof T == "object" && (T.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        T.$$typeof === c))
          N = T.propTypes;
        else
          return;
        if (N) {
          var U = me(T);
          mr(N, p.props, "prop", U, p);
        } else if (T.PropTypes !== void 0 && !tt) {
          tt = !0;
          var ne = me(T);
          E("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ne || "Unknown");
        }
        typeof T.getDefaultProps == "function" && !T.getDefaultProps.isReactClassApproved && E("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Er(p) {
      {
        for (var T = Object.keys(p.props), N = 0; N < T.length; N++) {
          var U = T[N];
          if (U !== "children" && U !== "key") {
            ct(p), E("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", U), ct(null);
            break;
          }
        }
        p.ref !== null && (ct(p), E("Invalid attribute `ref` supplied to `React.Fragment`."), ct(null));
      }
    }
    var Tr = {};
    function Ie(p, T, N, U, ne, ie) {
      {
        var ee = he(p);
        if (!ee) {
          var w = "";
          (p === void 0 || typeof p == "object" && p !== null && Object.keys(p).length === 0) && (w += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var d = ye();
          d ? w += d : w += vr();
          var b;
          p === null ? b = "null" : Dt(p) ? b = "array" : p !== void 0 && p.$$typeof === t ? (b = "<" + (me(p.type) || "Unknown") + " />", w = " Did you accidentally export a JSX literal instead of a component?") : b = typeof p, E("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", b, w);
        }
        var C = Wr(p, T, N, ne, ie);
        if (C == null)
          return C;
        if (ee) {
          var Z = T.children;
          if (Z !== void 0)
            if (U)
              if (Dt(Z)) {
                for (var de = 0; de < Z.length; de++)
                  St(Z[de], p);
                Object.freeze && Object.freeze(Z);
              } else
                E("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              St(Z, p);
        }
        if (Xe.call(T, "key")) {
          var ce = me(p), le = Object.keys(T).filter(function(Te) {
            return Te !== "key";
          }), Ae = le.length > 0 ? "{key: someKey, " + le.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Tr[ce + Ae]) {
            var yt = le.length > 0 ? "{" + le.join(": ..., ") + ": ...}" : "{}";
            E(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ae, ce, yt, ce), Tr[ce + Ae] = !0;
          }
        }
        return p === o ? Er(C) : br(C), C;
      }
    }
    function _t(p, T, N) {
      return Ie(p, T, N, !0);
    }
    function Or(p, T, N) {
      return Ie(p, T, N, !1);
    }
    var wr = Or, Sr = _t;
    zt.Fragment = o, zt.jsx = wr, zt.jsxs = Sr;
  }()), zt;
}
process.env.NODE_ENV === "production" ? nn.exports = wi() : nn.exports = Si();
var ue = nn.exports;
function Ro(e) {
  return (t) => typeof t === e;
}
var _i = Ro("function"), Ri = (e) => e === null, Cn = (e) => Object.prototype.toString.call(e).slice(8, -1) === "RegExp", xn = (e) => !Pi(e) && !Ri(e) && (_i(e) || typeof e == "object"), Pi = Ro("undefined");
function Ci(e, t) {
  const { length: r } = e;
  if (r !== t.length)
    return !1;
  for (let o = r; o-- !== 0; )
    if (!Pe(e[o], t[o]))
      return !1;
  return !0;
}
function xi(e, t) {
  if (e.byteLength !== t.byteLength)
    return !1;
  const r = new DataView(e.buffer), o = new DataView(t.buffer);
  let n = e.byteLength;
  for (; n--; )
    if (r.getUint8(n) !== o.getUint8(n))
      return !1;
  return !0;
}
function Ai(e, t) {
  if (e.size !== t.size)
    return !1;
  for (const r of e.entries())
    if (!t.has(r[0]))
      return !1;
  for (const r of e.entries())
    if (!Pe(r[1], t.get(r[0])))
      return !1;
  return !0;
}
function Ni(e, t) {
  if (e.size !== t.size)
    return !1;
  for (const r of e.entries())
    if (!t.has(r[0]))
      return !1;
  return !0;
}
function Pe(e, t) {
  if (e === t)
    return !0;
  if (e && xn(e) && t && xn(t)) {
    if (e.constructor !== t.constructor)
      return !1;
    if (Array.isArray(e) && Array.isArray(t))
      return Ci(e, t);
    if (e instanceof Map && t instanceof Map)
      return Ai(e, t);
    if (e instanceof Set && t instanceof Set)
      return Ni(e, t);
    if (ArrayBuffer.isView(e) && ArrayBuffer.isView(t))
      return xi(e, t);
    if (Cn(e) && Cn(t))
      return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf)
      return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString)
      return e.toString() === t.toString();
    const r = Object.keys(e), o = Object.keys(t);
    if (r.length !== o.length)
      return !1;
    for (let n = r.length; n-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, r[n]))
        return !1;
    for (let n = r.length; n-- !== 0; ) {
      const i = r[n];
      if (!(i === "_owner" && e.$$typeof) && !Pe(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return Number.isNaN(e) && Number.isNaN(t) ? !0 : e === t;
}
var Ii = [
  "Array",
  "ArrayBuffer",
  "AsyncFunction",
  "AsyncGenerator",
  "AsyncGeneratorFunction",
  "Date",
  "Error",
  "Function",
  "Generator",
  "GeneratorFunction",
  "HTMLElement",
  "Map",
  "Object",
  "Promise",
  "RegExp",
  "Set",
  "WeakMap",
  "WeakSet"
], ki = [
  "bigint",
  "boolean",
  "null",
  "number",
  "string",
  "symbol",
  "undefined"
];
function jr(e) {
  const t = Object.prototype.toString.call(e).slice(8, -1);
  if (/HTML\w+Element/.test(t))
    return "HTMLElement";
  if (Li(t))
    return t;
}
function He(e) {
  return (t) => jr(t) === e;
}
function Li(e) {
  return Ii.includes(e);
}
function kt(e) {
  return (t) => typeof t === e;
}
function Mi(e) {
  return ki.includes(e);
}
var Di = [
  "innerHTML",
  "ownerDocument",
  "style",
  "attributes",
  "nodeValue"
];
function I(e) {
  if (e === null)
    return "null";
  switch (typeof e) {
    case "bigint":
      return "bigint";
    case "boolean":
      return "boolean";
    case "number":
      return "number";
    case "string":
      return "string";
    case "symbol":
      return "symbol";
    case "undefined":
      return "undefined";
  }
  if (I.array(e))
    return "Array";
  if (I.plainFunction(e))
    return "Function";
  const t = jr(e);
  return t || "Object";
}
I.array = Array.isArray;
I.arrayOf = (e, t) => !I.array(e) && !I.function(t) ? !1 : e.every((r) => t(r));
I.asyncGeneratorFunction = (e) => jr(e) === "AsyncGeneratorFunction";
I.asyncFunction = He("AsyncFunction");
I.bigint = kt("bigint");
I.boolean = (e) => e === !0 || e === !1;
I.date = He("Date");
I.defined = (e) => !I.undefined(e);
I.domElement = (e) => I.object(e) && !I.plainObject(e) && e.nodeType === 1 && I.string(e.nodeName) && Di.every((t) => t in e);
I.empty = (e) => I.string(e) && e.length === 0 || I.array(e) && e.length === 0 || I.object(e) && !I.map(e) && !I.set(e) && Object.keys(e).length === 0 || I.set(e) && e.size === 0 || I.map(e) && e.size === 0;
I.error = He("Error");
I.function = kt("function");
I.generator = (e) => I.iterable(e) && I.function(e.next) && I.function(e.throw);
I.generatorFunction = He("GeneratorFunction");
I.instanceOf = (e, t) => !e || !t ? !1 : Object.getPrototypeOf(e) === t.prototype;
I.iterable = (e) => !I.nullOrUndefined(e) && I.function(e[Symbol.iterator]);
I.map = He("Map");
I.nan = (e) => Number.isNaN(e);
I.null = (e) => e === null;
I.nullOrUndefined = (e) => I.null(e) || I.undefined(e);
I.number = (e) => kt("number")(e) && !I.nan(e);
I.numericString = (e) => I.string(e) && e.length > 0 && !Number.isNaN(Number(e));
I.object = (e) => !I.nullOrUndefined(e) && (I.function(e) || typeof e == "object");
I.oneOf = (e, t) => I.array(e) ? e.indexOf(t) > -1 : !1;
I.plainFunction = He("Function");
I.plainObject = (e) => {
  if (jr(e) !== "Object")
    return !1;
  const t = Object.getPrototypeOf(e);
  return t === null || t === Object.getPrototypeOf({});
};
I.primitive = (e) => I.null(e) || Mi(typeof e);
I.promise = He("Promise");
I.propertyOf = (e, t, r) => {
  if (!I.object(e) || !t)
    return !1;
  const o = e[t];
  return I.function(r) ? r(o) : I.defined(o);
};
I.regexp = He("RegExp");
I.set = He("Set");
I.string = kt("string");
I.symbol = kt("symbol");
I.undefined = kt("undefined");
I.weakMap = He("WeakMap");
I.weakSet = He("WeakSet");
var k = I;
function ji(...e) {
  return e.every((t) => k.string(t) || k.array(t) || k.plainObject(t));
}
function Fi(e, t, r) {
  return Po(e, t) ? [e, t].every(k.array) ? !e.some(Ln(r)) && t.some(Ln(r)) : [e, t].every(k.plainObject) ? !Object.entries(e).some(kn(r)) && Object.entries(t).some(kn(r)) : t === r : !1;
}
function An(e, t, r) {
  const { actual: o, key: n, previous: i, type: s } = r, a = Ve(e, n), l = Ve(t, n);
  let f = [a, l].every(k.number) && (s === "increased" ? a < l : a > l);
  return k.undefined(o) || (f = f && l === o), k.undefined(i) || (f = f && a === i), f;
}
function Nn(e, t, r) {
  const { key: o, type: n, value: i } = r, s = Ve(e, o), a = Ve(t, o), l = n === "added" ? s : a, f = n === "added" ? a : s;
  if (!k.nullOrUndefined(i)) {
    if (k.defined(l)) {
      if (k.array(l) || k.plainObject(l))
        return Fi(l, f, i);
    } else
      return Pe(f, i);
    return !1;
  }
  return [s, a].every(k.array) ? !f.every(hn(l)) : [s, a].every(k.plainObject) ? Wi(Object.keys(l), Object.keys(f)) : ![s, a].every((u) => k.primitive(u) && k.defined(u)) && (n === "added" ? !k.defined(s) && k.defined(a) : k.defined(s) && !k.defined(a));
}
function In(e, t, { key: r } = {}) {
  let o = Ve(e, r), n = Ve(t, r);
  if (!Po(o, n))
    throw new TypeError("Inputs have different types");
  if (!ji(o, n))
    throw new TypeError("Inputs don't have length");
  return [o, n].every(k.plainObject) && (o = Object.keys(o), n = Object.keys(n)), [o, n];
}
function kn(e) {
  return ([t, r]) => k.array(e) ? Pe(e, r) || e.some((o) => Pe(o, r) || k.array(r) && hn(r)(o)) : k.plainObject(e) && e[t] ? !!e[t] && Pe(e[t], r) : Pe(e, r);
}
function Wi(e, t) {
  return t.some((r) => !e.includes(r));
}
function Ln(e) {
  return (t) => k.array(e) ? e.some((r) => Pe(r, t) || k.array(t) && hn(t)(r)) : Pe(e, t);
}
function Gt(e, t) {
  return k.array(e) ? e.some((r) => Pe(r, t)) : Pe(e, t);
}
function hn(e) {
  return (t) => e.some((r) => Pe(r, t));
}
function Po(...e) {
  return e.every(k.array) || e.every(k.number) || e.every(k.plainObject) || e.every(k.string);
}
function Ve(e, t) {
  return k.plainObject(e) || k.array(e) ? k.string(t) ? t.split(".").reduce((o, n) => o && o[n], e) : k.number(t) ? e[t] : e : e;
}
function kr(e, t) {
  if ([e, t].some(k.nullOrUndefined))
    throw new Error("Missing required parameters");
  if (![e, t].every((u) => k.plainObject(u) || k.array(u)))
    throw new Error("Expected plain objects or array");
  return { added: (u, c) => {
    try {
      return Nn(e, t, { key: u, type: "added", value: c });
    } catch {
      return !1;
    }
  }, changed: (u, c, h) => {
    try {
      const m = Ve(e, u), y = Ve(t, u), g = k.defined(c), _ = k.defined(h);
      if (g || _) {
        const x = _ ? Gt(h, m) : !Gt(c, m), E = Gt(c, y);
        return x && E;
      }
      return [m, y].every(k.array) || [m, y].every(k.plainObject) ? !Pe(m, y) : m !== y;
    } catch {
      return !1;
    }
  }, changedFrom: (u, c, h) => {
    if (!k.defined(u))
      return !1;
    try {
      const m = Ve(e, u), y = Ve(t, u), g = k.defined(h);
      return Gt(c, m) && (g ? Gt(h, y) : !g);
    } catch {
      return !1;
    }
  }, decreased: (u, c, h) => {
    if (!k.defined(u))
      return !1;
    try {
      return An(e, t, { key: u, actual: c, previous: h, type: "decreased" });
    } catch {
      return !1;
    }
  }, emptied: (u) => {
    try {
      const [c, h] = In(e, t, { key: u });
      return !!c.length && !h.length;
    } catch {
      return !1;
    }
  }, filled: (u) => {
    try {
      const [c, h] = In(e, t, { key: u });
      return !c.length && !!h.length;
    } catch {
      return !1;
    }
  }, increased: (u, c, h) => {
    if (!k.defined(u))
      return !1;
    try {
      return An(e, t, { key: u, actual: c, previous: h, type: "increased" });
    } catch {
      return !1;
    }
  }, removed: (u, c) => {
    try {
      return Nn(e, t, { key: u, type: "removed", value: c });
    } catch {
      return !1;
    }
  } };
}
var Ui = new Error("Element already at target scroll position"), Bi = new Error("Scroll cancelled"), $i = Math.min, Mn = Date.now, Hi = {
  left: Dn("scrollLeft"),
  top: Dn("scrollTop")
};
function Dn(e) {
  return function(r, o, n, i) {
    n = n || {}, typeof n == "function" && (i = n, n = {}), typeof i != "function" && (i = Gi);
    var s = Mn(), a = r[e], l = n.ease || zi, f = isNaN(n.duration) ? 350 : +n.duration, u = !1;
    return a === o ? i(Ui, r[e]) : requestAnimationFrame(h), c;
    function c() {
      u = !0;
    }
    function h(m) {
      if (u) return i(Bi, r[e]);
      var y = Mn(), g = $i(1, (y - s) / f), _ = l(g);
      r[e] = _ * (o - a) + a, g < 1 ? requestAnimationFrame(h) : requestAnimationFrame(function() {
        i(null, r[e]);
      });
    }
  };
}
function zi(e) {
  return 0.5 * (1 - Math.cos(Math.PI * e));
}
function Gi() {
}
const Yi = /* @__PURE__ */ sr(Hi);
var Co = { exports: {} };
(function(e) {
  (function(t, r) {
    e.exports ? e.exports = r() : t.Scrollparent = r();
  })(Oi, function() {
    function t(o) {
      var n = getComputedStyle(o, null).getPropertyValue("overflow");
      return n.indexOf("scroll") > -1 || n.indexOf("auto") > -1;
    }
    function r(o) {
      if (o instanceof HTMLElement || o instanceof SVGElement) {
        for (var n = o.parentNode; n.parentNode; ) {
          if (t(n))
            return n;
          n = n.parentNode;
        }
        return document.scrollingElement || document.documentElement;
      }
    }
    return r;
  });
})(Co);
var qi = Co.exports;
const xo = /* @__PURE__ */ sr(qi);
var Vi = function(e) {
  return Object.prototype.hasOwnProperty.call(e, "props");
}, Ki = function(e, t) {
  return e + rr(t);
}, rr = function(e) {
  return e === null || typeof e == "boolean" || typeof e > "u" ? "" : typeof e == "number" ? e.toString() : typeof e == "string" ? e : Array.isArray(e) ? e.reduce(Ki, "") : Vi(e) && Object.prototype.hasOwnProperty.call(e.props, "children") ? rr(e.props.children) : "";
};
rr.default = rr;
var Xi = rr;
const jn = /* @__PURE__ */ sr(Xi);
var Ji = function(t) {
  return Zi(t) && !Qi(t);
};
function Zi(e) {
  return !!e && typeof e == "object";
}
function Qi(e) {
  var t = Object.prototype.toString.call(e);
  return t === "[object RegExp]" || t === "[object Date]" || rs(e);
}
var es = typeof Symbol == "function" && Symbol.for, ts = es ? Symbol.for("react.element") : 60103;
function rs(e) {
  return e.$$typeof === ts;
}
function ns(e) {
  return Array.isArray(e) ? [] : {};
}
function nr(e, t) {
  return t.clone !== !1 && t.isMergeableObject(e) ? Ct(ns(e), e, t) : e;
}
function os(e, t, r) {
  return e.concat(t).map(function(o) {
    return nr(o, r);
  });
}
function is(e, t) {
  if (!t.customMerge)
    return Ct;
  var r = t.customMerge(e);
  return typeof r == "function" ? r : Ct;
}
function ss(e) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(e).filter(function(t) {
    return Object.propertyIsEnumerable.call(e, t);
  }) : [];
}
function Fn(e) {
  return Object.keys(e).concat(ss(e));
}
function Ao(e, t) {
  try {
    return t in e;
  } catch {
    return !1;
  }
}
function as(e, t) {
  return Ao(e, t) && !(Object.hasOwnProperty.call(e, t) && Object.propertyIsEnumerable.call(e, t));
}
function ls(e, t, r) {
  var o = {};
  return r.isMergeableObject(e) && Fn(e).forEach(function(n) {
    o[n] = nr(e[n], r);
  }), Fn(t).forEach(function(n) {
    as(e, n) || (Ao(e, n) && r.isMergeableObject(t[n]) ? o[n] = is(n, r)(e[n], t[n], r) : o[n] = nr(t[n], r));
  }), o;
}
function Ct(e, t, r) {
  r = r || {}, r.arrayMerge = r.arrayMerge || os, r.isMergeableObject = r.isMergeableObject || Ji, r.cloneUnlessOtherwiseSpecified = nr;
  var o = Array.isArray(t), n = Array.isArray(e), i = o === n;
  return i ? o ? r.arrayMerge(e, t, r) : ls(e, t, r) : nr(t, r);
}
Ct.all = function(t, r) {
  if (!Array.isArray(t))
    throw new Error("first argument should be an array");
  return t.reduce(function(o, n) {
    return Ct(o, n, r);
  }, {});
};
var cs = Ct, us = cs;
const $e = /* @__PURE__ */ sr(us);
var on = { exports: {} }, _r = { exports: {} }, se = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Wn;
function fs() {
  if (Wn) return se;
  Wn = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, n = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, f = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, c = e ? Symbol.for("react.suspense") : 60113, h = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, y = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, _ = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, E = e ? Symbol.for("react.scope") : 60119;
  function F(O) {
    if (typeof O == "object" && O !== null) {
      var W = O.$$typeof;
      switch (W) {
        case t:
          switch (O = O.type, O) {
            case l:
            case f:
            case o:
            case i:
            case n:
            case c:
              return O;
            default:
              switch (O = O && O.$$typeof, O) {
                case a:
                case u:
                case y:
                case m:
                case s:
                  return O;
                default:
                  return W;
              }
          }
        case r:
          return W;
      }
    }
  }
  function M(O) {
    return F(O) === f;
  }
  return se.AsyncMode = l, se.ConcurrentMode = f, se.ContextConsumer = a, se.ContextProvider = s, se.Element = t, se.ForwardRef = u, se.Fragment = o, se.Lazy = y, se.Memo = m, se.Portal = r, se.Profiler = i, se.StrictMode = n, se.Suspense = c, se.isAsyncMode = function(O) {
    return M(O) || F(O) === l;
  }, se.isConcurrentMode = M, se.isContextConsumer = function(O) {
    return F(O) === a;
  }, se.isContextProvider = function(O) {
    return F(O) === s;
  }, se.isElement = function(O) {
    return typeof O == "object" && O !== null && O.$$typeof === t;
  }, se.isForwardRef = function(O) {
    return F(O) === u;
  }, se.isFragment = function(O) {
    return F(O) === o;
  }, se.isLazy = function(O) {
    return F(O) === y;
  }, se.isMemo = function(O) {
    return F(O) === m;
  }, se.isPortal = function(O) {
    return F(O) === r;
  }, se.isProfiler = function(O) {
    return F(O) === i;
  }, se.isStrictMode = function(O) {
    return F(O) === n;
  }, se.isSuspense = function(O) {
    return F(O) === c;
  }, se.isValidElementType = function(O) {
    return typeof O == "string" || typeof O == "function" || O === o || O === f || O === i || O === n || O === c || O === h || typeof O == "object" && O !== null && (O.$$typeof === y || O.$$typeof === m || O.$$typeof === s || O.$$typeof === a || O.$$typeof === u || O.$$typeof === _ || O.$$typeof === x || O.$$typeof === E || O.$$typeof === g);
  }, se.typeOf = F, se;
}
var ae = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Un;
function ps() {
  return Un || (Un = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, n = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, f = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, c = e ? Symbol.for("react.suspense") : 60113, h = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, y = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, _ = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, E = e ? Symbol.for("react.scope") : 60119;
    function F(A) {
      return typeof A == "string" || typeof A == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      A === o || A === f || A === i || A === n || A === c || A === h || typeof A == "object" && A !== null && (A.$$typeof === y || A.$$typeof === m || A.$$typeof === s || A.$$typeof === a || A.$$typeof === u || A.$$typeof === _ || A.$$typeof === x || A.$$typeof === E || A.$$typeof === g);
    }
    function M(A) {
      if (typeof A == "object" && A !== null) {
        var Oe = A.$$typeof;
        switch (Oe) {
          case t:
            var xe = A.type;
            switch (xe) {
              case l:
              case f:
              case o:
              case i:
              case n:
              case c:
                return xe;
              default:
                var We = xe && xe.$$typeof;
                switch (We) {
                  case a:
                  case u:
                  case y:
                  case m:
                  case s:
                    return We;
                  default:
                    return Oe;
                }
            }
          case r:
            return Oe;
        }
      }
    }
    var O = l, W = f, q = a, ve = s, Se = t, he = u, pe = o, Ee = y, me = m, be = r, Fe = i, _e = n, Me = c, Ge = !1;
    function it(A) {
      return Ge || (Ge = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), S(A) || M(A) === l;
    }
    function S(A) {
      return M(A) === f;
    }
    function P(A) {
      return M(A) === a;
    }
    function Y(A) {
      return M(A) === s;
    }
    function D(A) {
      return typeof A == "object" && A !== null && A.$$typeof === t;
    }
    function $(A) {
      return M(A) === u;
    }
    function j(A) {
      return M(A) === o;
    }
    function B(A) {
      return M(A) === y;
    }
    function H(A) {
      return M(A) === m;
    }
    function V(A) {
      return M(A) === r;
    }
    function J(A) {
      return M(A) === i;
    }
    function K(A) {
      return M(A) === n;
    }
    function ge(A) {
      return M(A) === c;
    }
    ae.AsyncMode = O, ae.ConcurrentMode = W, ae.ContextConsumer = q, ae.ContextProvider = ve, ae.Element = Se, ae.ForwardRef = he, ae.Fragment = pe, ae.Lazy = Ee, ae.Memo = me, ae.Portal = be, ae.Profiler = Fe, ae.StrictMode = _e, ae.Suspense = Me, ae.isAsyncMode = it, ae.isConcurrentMode = S, ae.isContextConsumer = P, ae.isContextProvider = Y, ae.isElement = D, ae.isForwardRef = $, ae.isFragment = j, ae.isLazy = B, ae.isMemo = H, ae.isPortal = V, ae.isProfiler = J, ae.isStrictMode = K, ae.isSuspense = ge, ae.isValidElementType = F, ae.typeOf = M;
  }()), ae;
}
var Bn;
function No() {
  return Bn || (Bn = 1, process.env.NODE_ENV === "production" ? _r.exports = fs() : _r.exports = ps()), _r.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var $r, $n;
function ds() {
  if ($n) return $r;
  $n = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function o(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function n() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var s = {}, a = 0; a < 10; a++)
        s["_" + String.fromCharCode(a)] = a;
      var l = Object.getOwnPropertyNames(s).map(function(u) {
        return s[u];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var f = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        f[u] = u;
      }), Object.keys(Object.assign({}, f)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return $r = n() ? Object.assign : function(i, s) {
    for (var a, l = o(i), f, u = 1; u < arguments.length; u++) {
      a = Object(arguments[u]);
      for (var c in a)
        t.call(a, c) && (l[c] = a[c]);
      if (e) {
        f = e(a);
        for (var h = 0; h < f.length; h++)
          r.call(a, f[h]) && (l[f[h]] = a[f[h]]);
      }
    }
    return l;
  }, $r;
}
var Hr, Hn;
function mn() {
  if (Hn) return Hr;
  Hn = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Hr = e, Hr;
}
var zr, zn;
function Io() {
  return zn || (zn = 1, zr = Function.call.bind(Object.prototype.hasOwnProperty)), zr;
}
var Gr, Gn;
function hs() {
  if (Gn) return Gr;
  Gn = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = mn(), r = {}, o = Io();
    e = function(i) {
      var s = "Warning: " + i;
      typeof console < "u" && console.error(s);
      try {
        throw new Error(s);
      } catch {
      }
    };
  }
  function n(i, s, a, l, f) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in i)
        if (o(i, u)) {
          var c;
          try {
            if (typeof i[u] != "function") {
              var h = Error(
                (l || "React class") + ": " + a + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw h.name = "Invariant Violation", h;
            }
            c = i[u](s, u, l, a, null, t);
          } catch (y) {
            c = y;
          }
          if (c && !(c instanceof Error) && e(
            (l || "React class") + ": type specification of " + a + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof c + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), c instanceof Error && !(c.message in r)) {
            r[c.message] = !0;
            var m = f ? f() : "";
            e(
              "Failed " + a + " type: " + c.message + (m ?? "")
            );
          }
        }
    }
  }
  return n.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, Gr = n, Gr;
}
var Yr, Yn;
function ms() {
  if (Yn) return Yr;
  Yn = 1;
  var e = No(), t = ds(), r = mn(), o = Io(), n = hs(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(a) {
    var l = "Warning: " + a;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function s() {
    return null;
  }
  return Yr = function(a, l) {
    var f = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function c(S) {
      var P = S && (f && S[f] || S[u]);
      if (typeof P == "function")
        return P;
    }
    var h = "<<anonymous>>", m = {
      array: x("array"),
      bigint: x("bigint"),
      bool: x("boolean"),
      func: x("function"),
      number: x("number"),
      object: x("object"),
      string: x("string"),
      symbol: x("symbol"),
      any: E(),
      arrayOf: F,
      element: M(),
      elementType: O(),
      instanceOf: W,
      node: he(),
      objectOf: ve,
      oneOf: q,
      oneOfType: Se,
      shape: Ee,
      exact: me
    };
    function y(S, P) {
      return S === P ? S !== 0 || 1 / S === 1 / P : S !== S && P !== P;
    }
    function g(S, P) {
      this.message = S, this.data = P && typeof P == "object" ? P : {}, this.stack = "";
    }
    g.prototype = Error.prototype;
    function _(S) {
      if (process.env.NODE_ENV !== "production")
        var P = {}, Y = 0;
      function D(j, B, H, V, J, K, ge) {
        if (V = V || h, K = K || H, ge !== r) {
          if (l) {
            var A = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw A.name = "Invariant Violation", A;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Oe = V + ":" + H;
            !P[Oe] && // Avoid spamming the console because they are often not actionable except for lib authors
            Y < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + K + "` prop on `" + V + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), P[Oe] = !0, Y++);
          }
        }
        return B[H] == null ? j ? B[H] === null ? new g("The " + J + " `" + K + "` is marked as required " + ("in `" + V + "`, but its value is `null`.")) : new g("The " + J + " `" + K + "` is marked as required in " + ("`" + V + "`, but its value is `undefined`.")) : null : S(B, H, V, J, K);
      }
      var $ = D.bind(null, !1);
      return $.isRequired = D.bind(null, !0), $;
    }
    function x(S) {
      function P(Y, D, $, j, B, H) {
        var V = Y[D], J = _e(V);
        if (J !== S) {
          var K = Me(V);
          return new g(
            "Invalid " + j + " `" + B + "` of type " + ("`" + K + "` supplied to `" + $ + "`, expected ") + ("`" + S + "`."),
            { expectedType: S }
          );
        }
        return null;
      }
      return _(P);
    }
    function E() {
      return _(s);
    }
    function F(S) {
      function P(Y, D, $, j, B) {
        if (typeof S != "function")
          return new g("Property `" + B + "` of component `" + $ + "` has invalid PropType notation inside arrayOf.");
        var H = Y[D];
        if (!Array.isArray(H)) {
          var V = _e(H);
          return new g("Invalid " + j + " `" + B + "` of type " + ("`" + V + "` supplied to `" + $ + "`, expected an array."));
        }
        for (var J = 0; J < H.length; J++) {
          var K = S(H, J, $, j, B + "[" + J + "]", r);
          if (K instanceof Error)
            return K;
        }
        return null;
      }
      return _(P);
    }
    function M() {
      function S(P, Y, D, $, j) {
        var B = P[Y];
        if (!a(B)) {
          var H = _e(B);
          return new g("Invalid " + $ + " `" + j + "` of type " + ("`" + H + "` supplied to `" + D + "`, expected a single ReactElement."));
        }
        return null;
      }
      return _(S);
    }
    function O() {
      function S(P, Y, D, $, j) {
        var B = P[Y];
        if (!e.isValidElementType(B)) {
          var H = _e(B);
          return new g("Invalid " + $ + " `" + j + "` of type " + ("`" + H + "` supplied to `" + D + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return _(S);
    }
    function W(S) {
      function P(Y, D, $, j, B) {
        if (!(Y[D] instanceof S)) {
          var H = S.name || h, V = it(Y[D]);
          return new g("Invalid " + j + " `" + B + "` of type " + ("`" + V + "` supplied to `" + $ + "`, expected ") + ("instance of `" + H + "`."));
        }
        return null;
      }
      return _(P);
    }
    function q(S) {
      if (!Array.isArray(S))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), s;
      function P(Y, D, $, j, B) {
        for (var H = Y[D], V = 0; V < S.length; V++)
          if (y(H, S[V]))
            return null;
        var J = JSON.stringify(S, function(ge, A) {
          var Oe = Me(A);
          return Oe === "symbol" ? String(A) : A;
        });
        return new g("Invalid " + j + " `" + B + "` of value `" + String(H) + "` " + ("supplied to `" + $ + "`, expected one of " + J + "."));
      }
      return _(P);
    }
    function ve(S) {
      function P(Y, D, $, j, B) {
        if (typeof S != "function")
          return new g("Property `" + B + "` of component `" + $ + "` has invalid PropType notation inside objectOf.");
        var H = Y[D], V = _e(H);
        if (V !== "object")
          return new g("Invalid " + j + " `" + B + "` of type " + ("`" + V + "` supplied to `" + $ + "`, expected an object."));
        for (var J in H)
          if (o(H, J)) {
            var K = S(H, J, $, j, B + "." + J, r);
            if (K instanceof Error)
              return K;
          }
        return null;
      }
      return _(P);
    }
    function Se(S) {
      if (!Array.isArray(S))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var P = 0; P < S.length; P++) {
        var Y = S[P];
        if (typeof Y != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + Ge(Y) + " at index " + P + "."
          ), s;
      }
      function D($, j, B, H, V) {
        for (var J = [], K = 0; K < S.length; K++) {
          var ge = S[K], A = ge($, j, B, H, V, r);
          if (A == null)
            return null;
          A.data && o(A.data, "expectedType") && J.push(A.data.expectedType);
        }
        var Oe = J.length > 0 ? ", expected one of type [" + J.join(", ") + "]" : "";
        return new g("Invalid " + H + " `" + V + "` supplied to " + ("`" + B + "`" + Oe + "."));
      }
      return _(D);
    }
    function he() {
      function S(P, Y, D, $, j) {
        return be(P[Y]) ? null : new g("Invalid " + $ + " `" + j + "` supplied to " + ("`" + D + "`, expected a ReactNode."));
      }
      return _(S);
    }
    function pe(S, P, Y, D, $) {
      return new g(
        (S || "React class") + ": " + P + " type `" + Y + "." + D + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + $ + "`."
      );
    }
    function Ee(S) {
      function P(Y, D, $, j, B) {
        var H = Y[D], V = _e(H);
        if (V !== "object")
          return new g("Invalid " + j + " `" + B + "` of type `" + V + "` " + ("supplied to `" + $ + "`, expected `object`."));
        for (var J in S) {
          var K = S[J];
          if (typeof K != "function")
            return pe($, j, B, J, Me(K));
          var ge = K(H, J, $, j, B + "." + J, r);
          if (ge)
            return ge;
        }
        return null;
      }
      return _(P);
    }
    function me(S) {
      function P(Y, D, $, j, B) {
        var H = Y[D], V = _e(H);
        if (V !== "object")
          return new g("Invalid " + j + " `" + B + "` of type `" + V + "` " + ("supplied to `" + $ + "`, expected `object`."));
        var J = t({}, Y[D], S);
        for (var K in J) {
          var ge = S[K];
          if (o(S, K) && typeof ge != "function")
            return pe($, j, B, K, Me(ge));
          if (!ge)
            return new g(
              "Invalid " + j + " `" + B + "` key `" + K + "` supplied to `" + $ + "`.\nBad object: " + JSON.stringify(Y[D], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(S), null, "  ")
            );
          var A = ge(H, K, $, j, B + "." + K, r);
          if (A)
            return A;
        }
        return null;
      }
      return _(P);
    }
    function be(S) {
      switch (typeof S) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !S;
        case "object":
          if (Array.isArray(S))
            return S.every(be);
          if (S === null || a(S))
            return !0;
          var P = c(S);
          if (P) {
            var Y = P.call(S), D;
            if (P !== S.entries) {
              for (; !(D = Y.next()).done; )
                if (!be(D.value))
                  return !1;
            } else
              for (; !(D = Y.next()).done; ) {
                var $ = D.value;
                if ($ && !be($[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function Fe(S, P) {
      return S === "symbol" ? !0 : P ? P["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && P instanceof Symbol : !1;
    }
    function _e(S) {
      var P = typeof S;
      return Array.isArray(S) ? "array" : S instanceof RegExp ? "object" : Fe(P, S) ? "symbol" : P;
    }
    function Me(S) {
      if (typeof S > "u" || S === null)
        return "" + S;
      var P = _e(S);
      if (P === "object") {
        if (S instanceof Date)
          return "date";
        if (S instanceof RegExp)
          return "regexp";
      }
      return P;
    }
    function Ge(S) {
      var P = Me(S);
      switch (P) {
        case "array":
        case "object":
          return "an " + P;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + P;
        default:
          return P;
      }
    }
    function it(S) {
      return !S.constructor || !S.constructor.name ? h : S.constructor.name;
    }
    return m.checkPropTypes = n, m.resetWarningCache = n.resetWarningCache, m.PropTypes = m, m;
  }, Yr;
}
var qr, qn;
function ys() {
  if (qn) return qr;
  qn = 1;
  var e = mn();
  function t() {
  }
  function r() {
  }
  return r.resetWarningCache = t, qr = function() {
    function o(s, a, l, f, u, c) {
      if (c !== e) {
        var h = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw h.name = "Invariant Violation", h;
      }
    }
    o.isRequired = o;
    function n() {
      return o;
    }
    var i = {
      array: o,
      bigint: o,
      bool: o,
      func: o,
      number: o,
      object: o,
      string: o,
      symbol: o,
      any: o,
      arrayOf: n,
      element: o,
      elementType: o,
      instanceOf: n,
      node: o,
      objectOf: n,
      oneOf: n,
      oneOfType: n,
      shape: n,
      exact: n,
      checkPropTypes: r,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, qr;
}
if (process.env.NODE_ENV !== "production") {
  var gs = No(), vs = !0;
  on.exports = ms()(gs.isElement, vs);
} else
  on.exports = ys()();
var bs = on.exports;
const R = /* @__PURE__ */ sr(bs);
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var ar = typeof window < "u" && typeof document < "u" && typeof navigator < "u", Es = function() {
  for (var e = ["Edge", "Trident", "Firefox"], t = 0; t < e.length; t += 1)
    if (ar && navigator.userAgent.indexOf(e[t]) >= 0)
      return 1;
  return 0;
}();
function Ts(e) {
  var t = !1;
  return function() {
    t || (t = !0, window.Promise.resolve().then(function() {
      t = !1, e();
    }));
  };
}
function Os(e) {
  var t = !1;
  return function() {
    t || (t = !0, setTimeout(function() {
      t = !1, e();
    }, Es));
  };
}
var ws = ar && window.Promise, Ss = ws ? Ts : Os;
function ko(e) {
  var t = {};
  return e && t.toString.call(e) === "[object Function]";
}
function bt(e, t) {
  if (e.nodeType !== 1)
    return [];
  var r = e.ownerDocument.defaultView, o = r.getComputedStyle(e, null);
  return t ? o[t] : o;
}
function yn(e) {
  return e.nodeName === "HTML" ? e : e.parentNode || e.host;
}
function lr(e) {
  if (!e)
    return document.body;
  switch (e.nodeName) {
    case "HTML":
    case "BODY":
      return e.ownerDocument.body;
    case "#document":
      return e.body;
  }
  var t = bt(e), r = t.overflow, o = t.overflowX, n = t.overflowY;
  return /(auto|scroll|overlay)/.test(r + n + o) ? e : lr(yn(e));
}
function Lo(e) {
  return e && e.referenceNode ? e.referenceNode : e;
}
var Vn = ar && !!(window.MSInputMethodContext && document.documentMode), Kn = ar && /MSIE 10/.test(navigator.userAgent);
function Lt(e) {
  return e === 11 ? Vn : e === 10 ? Kn : Vn || Kn;
}
function xt(e) {
  if (!e)
    return document.documentElement;
  for (var t = Lt(10) ? document.body : null, r = e.offsetParent || null; r === t && e.nextElementSibling; )
    r = (e = e.nextElementSibling).offsetParent;
  var o = r && r.nodeName;
  return !o || o === "BODY" || o === "HTML" ? e ? e.ownerDocument.documentElement : document.documentElement : ["TH", "TD", "TABLE"].indexOf(r.nodeName) !== -1 && bt(r, "position") === "static" ? xt(r) : r;
}
function _s(e) {
  var t = e.nodeName;
  return t === "BODY" ? !1 : t === "HTML" || xt(e.firstElementChild) === e;
}
function sn(e) {
  return e.parentNode !== null ? sn(e.parentNode) : e;
}
function Lr(e, t) {
  if (!e || !e.nodeType || !t || !t.nodeType)
    return document.documentElement;
  var r = e.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_FOLLOWING, o = r ? e : t, n = r ? t : e, i = document.createRange();
  i.setStart(o, 0), i.setEnd(n, 0);
  var s = i.commonAncestorContainer;
  if (e !== s && t !== s || o.contains(n))
    return _s(s) ? s : xt(s);
  var a = sn(e);
  return a.host ? Lr(a.host, t) : Lr(e, sn(t).host);
}
function At(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "top", r = t === "top" ? "scrollTop" : "scrollLeft", o = e.nodeName;
  if (o === "BODY" || o === "HTML") {
    var n = e.ownerDocument.documentElement, i = e.ownerDocument.scrollingElement || n;
    return i[r];
  }
  return e[r];
}
function Rs(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, o = At(t, "top"), n = At(t, "left"), i = r ? -1 : 1;
  return e.top += o * i, e.bottom += o * i, e.left += n * i, e.right += n * i, e;
}
function Xn(e, t) {
  var r = t === "x" ? "Left" : "Top", o = r === "Left" ? "Right" : "Bottom";
  return parseFloat(e["border" + r + "Width"]) + parseFloat(e["border" + o + "Width"]);
}
function Jn(e, t, r, o) {
  return Math.max(t["offset" + e], t["scroll" + e], r["client" + e], r["offset" + e], r["scroll" + e], Lt(10) ? parseInt(r["offset" + e]) + parseInt(o["margin" + (e === "Height" ? "Top" : "Left")]) + parseInt(o["margin" + (e === "Height" ? "Bottom" : "Right")]) : 0);
}
function Mo(e) {
  var t = e.body, r = e.documentElement, o = Lt(10) && getComputedStyle(r);
  return {
    height: Jn("Height", t, r, o),
    width: Jn("Width", t, r, o)
  };
}
var Ps = function(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}, Cs = /* @__PURE__ */ function() {
  function e(t, r) {
    for (var o = 0; o < r.length; o++) {
      var n = r[o];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
    }
  }
  return function(t, r, o) {
    return r && e(t.prototype, r), o && e(t, o), t;
  };
}(), Nt = function(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}, De = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];
    for (var o in r)
      Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
  }
  return e;
};
function ft(e) {
  return De({}, e, {
    right: e.left + e.width,
    bottom: e.top + e.height
  });
}
function an(e) {
  var t = {};
  try {
    if (Lt(10)) {
      t = e.getBoundingClientRect();
      var r = At(e, "top"), o = At(e, "left");
      t.top += r, t.left += o, t.bottom += r, t.right += o;
    } else
      t = e.getBoundingClientRect();
  } catch {
  }
  var n = {
    left: t.left,
    top: t.top,
    width: t.right - t.left,
    height: t.bottom - t.top
  }, i = e.nodeName === "HTML" ? Mo(e.ownerDocument) : {}, s = i.width || e.clientWidth || n.width, a = i.height || e.clientHeight || n.height, l = e.offsetWidth - s, f = e.offsetHeight - a;
  if (l || f) {
    var u = bt(e);
    l -= Xn(u, "x"), f -= Xn(u, "y"), n.width -= l, n.height -= f;
  }
  return ft(n);
}
function gn(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, o = Lt(10), n = t.nodeName === "HTML", i = an(e), s = an(t), a = lr(e), l = bt(t), f = parseFloat(l.borderTopWidth), u = parseFloat(l.borderLeftWidth);
  r && n && (s.top = Math.max(s.top, 0), s.left = Math.max(s.left, 0));
  var c = ft({
    top: i.top - s.top - f,
    left: i.left - s.left - u,
    width: i.width,
    height: i.height
  });
  if (c.marginTop = 0, c.marginLeft = 0, !o && n) {
    var h = parseFloat(l.marginTop), m = parseFloat(l.marginLeft);
    c.top -= f - h, c.bottom -= f - h, c.left -= u - m, c.right -= u - m, c.marginTop = h, c.marginLeft = m;
  }
  return (o && !r ? t.contains(a) : t === a && a.nodeName !== "BODY") && (c = Rs(c, t)), c;
}
function xs(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r = e.ownerDocument.documentElement, o = gn(e, r), n = Math.max(r.clientWidth, window.innerWidth || 0), i = Math.max(r.clientHeight, window.innerHeight || 0), s = t ? 0 : At(r), a = t ? 0 : At(r, "left"), l = {
    top: s - o.top + o.marginTop,
    left: a - o.left + o.marginLeft,
    width: n,
    height: i
  };
  return ft(l);
}
function Do(e) {
  var t = e.nodeName;
  if (t === "BODY" || t === "HTML")
    return !1;
  if (bt(e, "position") === "fixed")
    return !0;
  var r = yn(e);
  return r ? Do(r) : !1;
}
function jo(e) {
  if (!e || !e.parentElement || Lt())
    return document.documentElement;
  for (var t = e.parentElement; t && bt(t, "transform") === "none"; )
    t = t.parentElement;
  return t || document.documentElement;
}
function vn(e, t, r, o) {
  var n = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1, i = { top: 0, left: 0 }, s = n ? jo(e) : Lr(e, Lo(t));
  if (o === "viewport")
    i = xs(s, n);
  else {
    var a = void 0;
    o === "scrollParent" ? (a = lr(yn(t)), a.nodeName === "BODY" && (a = e.ownerDocument.documentElement)) : o === "window" ? a = e.ownerDocument.documentElement : a = o;
    var l = gn(a, s, n);
    if (a.nodeName === "HTML" && !Do(s)) {
      var f = Mo(e.ownerDocument), u = f.height, c = f.width;
      i.top += l.top - l.marginTop, i.bottom = u + l.top, i.left += l.left - l.marginLeft, i.right = c + l.left;
    } else
      i = l;
  }
  r = r || 0;
  var h = typeof r == "number";
  return i.left += h ? r : r.left || 0, i.top += h ? r : r.top || 0, i.right -= h ? r : r.right || 0, i.bottom -= h ? r : r.bottom || 0, i;
}
function As(e) {
  var t = e.width, r = e.height;
  return t * r;
}
function Fo(e, t, r, o, n) {
  var i = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0;
  if (e.indexOf("auto") === -1)
    return e;
  var s = vn(r, o, i, n), a = {
    top: {
      width: s.width,
      height: t.top - s.top
    },
    right: {
      width: s.right - t.right,
      height: s.height
    },
    bottom: {
      width: s.width,
      height: s.bottom - t.bottom
    },
    left: {
      width: t.left - s.left,
      height: s.height
    }
  }, l = Object.keys(a).map(function(h) {
    return De({
      key: h
    }, a[h], {
      area: As(a[h])
    });
  }).sort(function(h, m) {
    return m.area - h.area;
  }), f = l.filter(function(h) {
    var m = h.width, y = h.height;
    return m >= r.clientWidth && y >= r.clientHeight;
  }), u = f.length > 0 ? f[0].key : l[0].key, c = e.split("-")[1];
  return u + (c ? "-" + c : "");
}
function Wo(e, t, r) {
  var o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, n = o ? jo(t) : Lr(t, Lo(r));
  return gn(r, n, o);
}
function Uo(e) {
  var t = e.ownerDocument.defaultView, r = t.getComputedStyle(e), o = parseFloat(r.marginTop || 0) + parseFloat(r.marginBottom || 0), n = parseFloat(r.marginLeft || 0) + parseFloat(r.marginRight || 0), i = {
    width: e.offsetWidth + n,
    height: e.offsetHeight + o
  };
  return i;
}
function Mr(e) {
  var t = { left: "right", right: "left", bottom: "top", top: "bottom" };
  return e.replace(/left|right|bottom|top/g, function(r) {
    return t[r];
  });
}
function Bo(e, t, r) {
  r = r.split("-")[0];
  var o = Uo(e), n = {
    width: o.width,
    height: o.height
  }, i = ["right", "left"].indexOf(r) !== -1, s = i ? "top" : "left", a = i ? "left" : "top", l = i ? "height" : "width", f = i ? "width" : "height";
  return n[s] = t[s] + t[l] / 2 - o[l] / 2, r === a ? n[a] = t[a] - o[f] : n[a] = t[Mr(a)], n;
}
function cr(e, t) {
  return Array.prototype.find ? e.find(t) : e.filter(t)[0];
}
function Ns(e, t, r) {
  if (Array.prototype.findIndex)
    return e.findIndex(function(n) {
      return n[t] === r;
    });
  var o = cr(e, function(n) {
    return n[t] === r;
  });
  return e.indexOf(o);
}
function $o(e, t, r) {
  var o = r === void 0 ? e : e.slice(0, Ns(e, "name", r));
  return o.forEach(function(n) {
    n.function && console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
    var i = n.function || n.fn;
    n.enabled && ko(i) && (t.offsets.popper = ft(t.offsets.popper), t.offsets.reference = ft(t.offsets.reference), t = i(t, n));
  }), t;
}
function Is() {
  if (!this.state.isDestroyed) {
    var e = {
      instance: this,
      styles: {},
      arrowStyles: {},
      attributes: {},
      flipped: !1,
      offsets: {}
    };
    e.offsets.reference = Wo(this.state, this.popper, this.reference, this.options.positionFixed), e.placement = Fo(this.options.placement, e.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding), e.originalPlacement = e.placement, e.positionFixed = this.options.positionFixed, e.offsets.popper = Bo(this.popper, e.offsets.reference, e.placement), e.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute", e = $o(this.modifiers, e), this.state.isCreated ? this.options.onUpdate(e) : (this.state.isCreated = !0, this.options.onCreate(e));
  }
}
function Ho(e, t) {
  return e.some(function(r) {
    var o = r.name, n = r.enabled;
    return n && o === t;
  });
}
function bn(e) {
  for (var t = [!1, "ms", "Webkit", "Moz", "O"], r = e.charAt(0).toUpperCase() + e.slice(1), o = 0; o < t.length; o++) {
    var n = t[o], i = n ? "" + n + r : e;
    if (typeof document.body.style[i] < "u")
      return i;
  }
  return null;
}
function ks() {
  return this.state.isDestroyed = !0, Ho(this.modifiers, "applyStyle") && (this.popper.removeAttribute("x-placement"), this.popper.style.position = "", this.popper.style.top = "", this.popper.style.left = "", this.popper.style.right = "", this.popper.style.bottom = "", this.popper.style.willChange = "", this.popper.style[bn("transform")] = ""), this.disableEventListeners(), this.options.removeOnDestroy && this.popper.parentNode.removeChild(this.popper), this;
}
function zo(e) {
  var t = e.ownerDocument;
  return t ? t.defaultView : window;
}
function Go(e, t, r, o) {
  var n = e.nodeName === "BODY", i = n ? e.ownerDocument.defaultView : e;
  i.addEventListener(t, r, { passive: !0 }), n || Go(lr(i.parentNode), t, r, o), o.push(i);
}
function Ls(e, t, r, o) {
  r.updateBound = o, zo(e).addEventListener("resize", r.updateBound, { passive: !0 });
  var n = lr(e);
  return Go(n, "scroll", r.updateBound, r.scrollParents), r.scrollElement = n, r.eventsEnabled = !0, r;
}
function Ms() {
  this.state.eventsEnabled || (this.state = Ls(this.reference, this.options, this.state, this.scheduleUpdate));
}
function Ds(e, t) {
  return zo(e).removeEventListener("resize", t.updateBound), t.scrollParents.forEach(function(r) {
    r.removeEventListener("scroll", t.updateBound);
  }), t.updateBound = null, t.scrollParents = [], t.scrollElement = null, t.eventsEnabled = !1, t;
}
function js() {
  this.state.eventsEnabled && (cancelAnimationFrame(this.scheduleUpdate), this.state = Ds(this.reference, this.state));
}
function En(e) {
  return e !== "" && !isNaN(parseFloat(e)) && isFinite(e);
}
function ln(e, t) {
  Object.keys(t).forEach(function(r) {
    var o = "";
    ["width", "height", "top", "right", "bottom", "left"].indexOf(r) !== -1 && En(t[r]) && (o = "px"), e.style[r] = t[r] + o;
  });
}
function Fs(e, t) {
  Object.keys(t).forEach(function(r) {
    var o = t[r];
    o !== !1 ? e.setAttribute(r, t[r]) : e.removeAttribute(r);
  });
}
function Ws(e) {
  return ln(e.instance.popper, e.styles), Fs(e.instance.popper, e.attributes), e.arrowElement && Object.keys(e.arrowStyles).length && ln(e.arrowElement, e.arrowStyles), e;
}
function Us(e, t, r, o, n) {
  var i = Wo(n, t, e, r.positionFixed), s = Fo(r.placement, i, t, e, r.modifiers.flip.boundariesElement, r.modifiers.flip.padding);
  return t.setAttribute("x-placement", s), ln(t, { position: r.positionFixed ? "fixed" : "absolute" }), r;
}
function Bs(e, t) {
  var r = e.offsets, o = r.popper, n = r.reference, i = Math.round, s = Math.floor, a = function(x) {
    return x;
  }, l = i(n.width), f = i(o.width), u = ["left", "right"].indexOf(e.placement) !== -1, c = e.placement.indexOf("-") !== -1, h = l % 2 === f % 2, m = l % 2 === 1 && f % 2 === 1, y = t ? u || c || h ? i : s : a, g = t ? i : a;
  return {
    left: y(m && !c && t ? o.left - 1 : o.left),
    top: g(o.top),
    bottom: g(o.bottom),
    right: y(o.right)
  };
}
var $s = ar && /Firefox/i.test(navigator.userAgent);
function Hs(e, t) {
  var r = t.x, o = t.y, n = e.offsets.popper, i = cr(e.instance.modifiers, function(F) {
    return F.name === "applyStyle";
  }).gpuAcceleration;
  i !== void 0 && console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");
  var s = i !== void 0 ? i : t.gpuAcceleration, a = xt(e.instance.popper), l = an(a), f = {
    position: n.position
  }, u = Bs(e, window.devicePixelRatio < 2 || !$s), c = r === "bottom" ? "top" : "bottom", h = o === "right" ? "left" : "right", m = bn("transform"), y = void 0, g = void 0;
  if (c === "bottom" ? a.nodeName === "HTML" ? g = -a.clientHeight + u.bottom : g = -l.height + u.bottom : g = u.top, h === "right" ? a.nodeName === "HTML" ? y = -a.clientWidth + u.right : y = -l.width + u.right : y = u.left, s && m)
    f[m] = "translate3d(" + y + "px, " + g + "px, 0)", f[c] = 0, f[h] = 0, f.willChange = "transform";
  else {
    var _ = c === "bottom" ? -1 : 1, x = h === "right" ? -1 : 1;
    f[c] = g * _, f[h] = y * x, f.willChange = c + ", " + h;
  }
  var E = {
    "x-placement": e.placement
  };
  return e.attributes = De({}, E, e.attributes), e.styles = De({}, f, e.styles), e.arrowStyles = De({}, e.offsets.arrow, e.arrowStyles), e;
}
function Yo(e, t, r) {
  var o = cr(e, function(a) {
    var l = a.name;
    return l === t;
  }), n = !!o && e.some(function(a) {
    return a.name === r && a.enabled && a.order < o.order;
  });
  if (!n) {
    var i = "`" + t + "`", s = "`" + r + "`";
    console.warn(s + " modifier is required by " + i + " modifier in order to work, be sure to include it before " + i + "!");
  }
  return n;
}
function zs(e, t) {
  var r;
  if (!Yo(e.instance.modifiers, "arrow", "keepTogether"))
    return e;
  var o = t.element;
  if (typeof o == "string") {
    if (o = e.instance.popper.querySelector(o), !o)
      return e;
  } else if (!e.instance.popper.contains(o))
    return console.warn("WARNING: `arrow.element` must be child of its popper element!"), e;
  var n = e.placement.split("-")[0], i = e.offsets, s = i.popper, a = i.reference, l = ["left", "right"].indexOf(n) !== -1, f = l ? "height" : "width", u = l ? "Top" : "Left", c = u.toLowerCase(), h = l ? "left" : "top", m = l ? "bottom" : "right", y = Uo(o)[f];
  a[m] - y < s[c] && (e.offsets.popper[c] -= s[c] - (a[m] - y)), a[c] + y > s[m] && (e.offsets.popper[c] += a[c] + y - s[m]), e.offsets.popper = ft(e.offsets.popper);
  var g = a[c] + a[f] / 2 - y / 2, _ = bt(e.instance.popper), x = parseFloat(_["margin" + u]), E = parseFloat(_["border" + u + "Width"]), F = g - e.offsets.popper[c] - x - E;
  return F = Math.max(Math.min(s[f] - y, F), 0), e.arrowElement = o, e.offsets.arrow = (r = {}, Nt(r, c, Math.round(F)), Nt(r, h, ""), r), e;
}
function Gs(e) {
  return e === "end" ? "start" : e === "start" ? "end" : e;
}
var qo = ["auto-start", "auto", "auto-end", "top-start", "top", "top-end", "right-start", "right", "right-end", "bottom-end", "bottom", "bottom-start", "left-end", "left", "left-start"], Vr = qo.slice(3);
function Zn(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r = Vr.indexOf(e), o = Vr.slice(r + 1).concat(Vr.slice(0, r));
  return t ? o.reverse() : o;
}
var Kr = {
  FLIP: "flip",
  CLOCKWISE: "clockwise",
  COUNTERCLOCKWISE: "counterclockwise"
};
function Ys(e, t) {
  if (Ho(e.instance.modifiers, "inner") || e.flipped && e.placement === e.originalPlacement)
    return e;
  var r = vn(e.instance.popper, e.instance.reference, t.padding, t.boundariesElement, e.positionFixed), o = e.placement.split("-")[0], n = Mr(o), i = e.placement.split("-")[1] || "", s = [];
  switch (t.behavior) {
    case Kr.FLIP:
      s = [o, n];
      break;
    case Kr.CLOCKWISE:
      s = Zn(o);
      break;
    case Kr.COUNTERCLOCKWISE:
      s = Zn(o, !0);
      break;
    default:
      s = t.behavior;
  }
  return s.forEach(function(a, l) {
    if (o !== a || s.length === l + 1)
      return e;
    o = e.placement.split("-")[0], n = Mr(o);
    var f = e.offsets.popper, u = e.offsets.reference, c = Math.floor, h = o === "left" && c(f.right) > c(u.left) || o === "right" && c(f.left) < c(u.right) || o === "top" && c(f.bottom) > c(u.top) || o === "bottom" && c(f.top) < c(u.bottom), m = c(f.left) < c(r.left), y = c(f.right) > c(r.right), g = c(f.top) < c(r.top), _ = c(f.bottom) > c(r.bottom), x = o === "left" && m || o === "right" && y || o === "top" && g || o === "bottom" && _, E = ["top", "bottom"].indexOf(o) !== -1, F = !!t.flipVariations && (E && i === "start" && m || E && i === "end" && y || !E && i === "start" && g || !E && i === "end" && _), M = !!t.flipVariationsByContent && (E && i === "start" && y || E && i === "end" && m || !E && i === "start" && _ || !E && i === "end" && g), O = F || M;
    (h || x || O) && (e.flipped = !0, (h || x) && (o = s[l + 1]), O && (i = Gs(i)), e.placement = o + (i ? "-" + i : ""), e.offsets.popper = De({}, e.offsets.popper, Bo(e.instance.popper, e.offsets.reference, e.placement)), e = $o(e.instance.modifiers, e, "flip"));
  }), e;
}
function qs(e) {
  var t = e.offsets, r = t.popper, o = t.reference, n = e.placement.split("-")[0], i = Math.floor, s = ["top", "bottom"].indexOf(n) !== -1, a = s ? "right" : "bottom", l = s ? "left" : "top", f = s ? "width" : "height";
  return r[a] < i(o[l]) && (e.offsets.popper[l] = i(o[l]) - r[f]), r[l] > i(o[a]) && (e.offsets.popper[l] = i(o[a])), e;
}
function Vs(e, t, r, o) {
  var n = e.match(/((?:\-|\+)?\d*\.?\d*)(.*)/), i = +n[1], s = n[2];
  if (!i)
    return e;
  if (s.indexOf("%") === 0) {
    var a = void 0;
    switch (s) {
      case "%p":
        a = r;
        break;
      case "%":
      case "%r":
      default:
        a = o;
    }
    var l = ft(a);
    return l[t] / 100 * i;
  } else if (s === "vh" || s === "vw") {
    var f = void 0;
    return s === "vh" ? f = Math.max(document.documentElement.clientHeight, window.innerHeight || 0) : f = Math.max(document.documentElement.clientWidth, window.innerWidth || 0), f / 100 * i;
  } else
    return i;
}
function Ks(e, t, r, o) {
  var n = [0, 0], i = ["right", "left"].indexOf(o) !== -1, s = e.split(/(\+|\-)/).map(function(u) {
    return u.trim();
  }), a = s.indexOf(cr(s, function(u) {
    return u.search(/,|\s/) !== -1;
  }));
  s[a] && s[a].indexOf(",") === -1 && console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
  var l = /\s*,\s*|\s+/, f = a !== -1 ? [s.slice(0, a).concat([s[a].split(l)[0]]), [s[a].split(l)[1]].concat(s.slice(a + 1))] : [s];
  return f = f.map(function(u, c) {
    var h = (c === 1 ? !i : i) ? "height" : "width", m = !1;
    return u.reduce(function(y, g) {
      return y[y.length - 1] === "" && ["+", "-"].indexOf(g) !== -1 ? (y[y.length - 1] = g, m = !0, y) : m ? (y[y.length - 1] += g, m = !1, y) : y.concat(g);
    }, []).map(function(y) {
      return Vs(y, h, t, r);
    });
  }), f.forEach(function(u, c) {
    u.forEach(function(h, m) {
      En(h) && (n[c] += h * (u[m - 1] === "-" ? -1 : 1));
    });
  }), n;
}
function Xs(e, t) {
  var r = t.offset, o = e.placement, n = e.offsets, i = n.popper, s = n.reference, a = o.split("-")[0], l = void 0;
  return En(+r) ? l = [+r, 0] : l = Ks(r, i, s, a), a === "left" ? (i.top += l[0], i.left -= l[1]) : a === "right" ? (i.top += l[0], i.left += l[1]) : a === "top" ? (i.left += l[0], i.top -= l[1]) : a === "bottom" && (i.left += l[0], i.top += l[1]), e.popper = i, e;
}
function Js(e, t) {
  var r = t.boundariesElement || xt(e.instance.popper);
  e.instance.reference === r && (r = xt(r));
  var o = bn("transform"), n = e.instance.popper.style, i = n.top, s = n.left, a = n[o];
  n.top = "", n.left = "", n[o] = "";
  var l = vn(e.instance.popper, e.instance.reference, t.padding, r, e.positionFixed);
  n.top = i, n.left = s, n[o] = a, t.boundaries = l;
  var f = t.priority, u = e.offsets.popper, c = {
    primary: function(m) {
      var y = u[m];
      return u[m] < l[m] && !t.escapeWithReference && (y = Math.max(u[m], l[m])), Nt({}, m, y);
    },
    secondary: function(m) {
      var y = m === "right" ? "left" : "top", g = u[y];
      return u[m] > l[m] && !t.escapeWithReference && (g = Math.min(u[y], l[m] - (m === "right" ? u.width : u.height))), Nt({}, y, g);
    }
  };
  return f.forEach(function(h) {
    var m = ["left", "top"].indexOf(h) !== -1 ? "primary" : "secondary";
    u = De({}, u, c[m](h));
  }), e.offsets.popper = u, e;
}
function Zs(e) {
  var t = e.placement, r = t.split("-")[0], o = t.split("-")[1];
  if (o) {
    var n = e.offsets, i = n.reference, s = n.popper, a = ["bottom", "top"].indexOf(r) !== -1, l = a ? "left" : "top", f = a ? "width" : "height", u = {
      start: Nt({}, l, i[l]),
      end: Nt({}, l, i[l] + i[f] - s[f])
    };
    e.offsets.popper = De({}, s, u[o]);
  }
  return e;
}
function Qs(e) {
  if (!Yo(e.instance.modifiers, "hide", "preventOverflow"))
    return e;
  var t = e.offsets.reference, r = cr(e.instance.modifiers, function(o) {
    return o.name === "preventOverflow";
  }).boundaries;
  if (t.bottom < r.top || t.left > r.right || t.top > r.bottom || t.right < r.left) {
    if (e.hide === !0)
      return e;
    e.hide = !0, e.attributes["x-out-of-boundaries"] = "";
  } else {
    if (e.hide === !1)
      return e;
    e.hide = !1, e.attributes["x-out-of-boundaries"] = !1;
  }
  return e;
}
function ea(e) {
  var t = e.placement, r = t.split("-")[0], o = e.offsets, n = o.popper, i = o.reference, s = ["left", "right"].indexOf(r) !== -1, a = ["top", "left"].indexOf(r) === -1;
  return n[s ? "left" : "top"] = i[r] - (a ? n[s ? "width" : "height"] : 0), e.placement = Mr(t), e.offsets.popper = ft(n), e;
}
var ta = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: Zs
  },
  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: Xs,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },
  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: Js,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ["left", "right", "top", "bottom"],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: "scrollParent"
  },
  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: qs
  },
  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: zs,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: "[x-arrow]"
  },
  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: Ys,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: "flip",
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: "viewport",
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: !1,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: !1
  },
  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: !1,
    /** @prop {ModifierFn} */
    fn: ea
  },
  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: Qs
  },
  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: Hs,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: !0,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: "bottom",
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: "right"
  },
  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: Ws,
    /** @prop {Function} */
    onLoad: Us,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: void 0
  }
}, ra = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: "bottom",
  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: !1,
  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: !0,
  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: !1,
  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function() {
  },
  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function() {
  },
  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: ta
}, or = function() {
  function e(t, r) {
    var o = this, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    Ps(this, e), this.scheduleUpdate = function() {
      return requestAnimationFrame(o.update);
    }, this.update = Ss(this.update.bind(this)), this.options = De({}, e.Defaults, n), this.state = {
      isDestroyed: !1,
      isCreated: !1,
      scrollParents: []
    }, this.reference = t && t.jquery ? t[0] : t, this.popper = r && r.jquery ? r[0] : r, this.options.modifiers = {}, Object.keys(De({}, e.Defaults.modifiers, n.modifiers)).forEach(function(s) {
      o.options.modifiers[s] = De({}, e.Defaults.modifiers[s] || {}, n.modifiers ? n.modifiers[s] : {});
    }), this.modifiers = Object.keys(this.options.modifiers).map(function(s) {
      return De({
        name: s
      }, o.options.modifiers[s]);
    }).sort(function(s, a) {
      return s.order - a.order;
    }), this.modifiers.forEach(function(s) {
      s.enabled && ko(s.onLoad) && s.onLoad(o.reference, o.popper, o.options, s, o.state);
    }), this.update();
    var i = this.options.eventsEnabled;
    i && this.enableEventListeners(), this.state.eventsEnabled = i;
  }
  return Cs(e, [{
    key: "update",
    value: function() {
      return Is.call(this);
    }
  }, {
    key: "destroy",
    value: function() {
      return ks.call(this);
    }
  }, {
    key: "enableEventListeners",
    value: function() {
      return Ms.call(this);
    }
  }, {
    key: "disableEventListeners",
    value: function() {
      return js.call(this);
    }
    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */
    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */
  }]), e;
}();
or.Utils = (typeof window < "u" ? window : global).PopperUtils;
or.placements = qo;
or.Defaults = ra;
var na = [
  "innerHTML",
  "ownerDocument",
  "style",
  "attributes",
  "nodeValue"
], oa = [
  "Array",
  "ArrayBuffer",
  "AsyncFunction",
  "AsyncGenerator",
  "AsyncGeneratorFunction",
  "Date",
  "Error",
  "Function",
  "Generator",
  "GeneratorFunction",
  "HTMLElement",
  "Map",
  "Object",
  "Promise",
  "RegExp",
  "Set",
  "WeakMap",
  "WeakSet"
], ia = [
  "bigint",
  "boolean",
  "null",
  "number",
  "string",
  "symbol",
  "undefined"
];
function Fr(e) {
  var t = Object.prototype.toString.call(e).slice(8, -1);
  if (/HTML\w+Element/.test(t))
    return "HTMLElement";
  if (sa(t))
    return t;
}
function ze(e) {
  return function(t) {
    return Fr(t) === e;
  };
}
function sa(e) {
  return oa.includes(e);
}
function Mt(e) {
  return function(t) {
    return typeof t === e;
  };
}
function aa(e) {
  return ia.includes(e);
}
function v(e) {
  if (e === null)
    return "null";
  switch (typeof e) {
    case "bigint":
      return "bigint";
    case "boolean":
      return "boolean";
    case "number":
      return "number";
    case "string":
      return "string";
    case "symbol":
      return "symbol";
    case "undefined":
      return "undefined";
  }
  if (v.array(e))
    return "Array";
  if (v.plainFunction(e))
    return "Function";
  var t = Fr(e);
  return t || "Object";
}
v.array = Array.isArray;
v.arrayOf = function(e, t) {
  return !v.array(e) && !v.function(t) ? !1 : e.every(function(r) {
    return t(r);
  });
};
v.asyncGeneratorFunction = function(e) {
  return Fr(e) === "AsyncGeneratorFunction";
};
v.asyncFunction = ze("AsyncFunction");
v.bigint = Mt("bigint");
v.boolean = function(e) {
  return e === !0 || e === !1;
};
v.date = ze("Date");
v.defined = function(e) {
  return !v.undefined(e);
};
v.domElement = function(e) {
  return v.object(e) && !v.plainObject(e) && e.nodeType === 1 && v.string(e.nodeName) && na.every(function(t) {
    return t in e;
  });
};
v.empty = function(e) {
  return v.string(e) && e.length === 0 || v.array(e) && e.length === 0 || v.object(e) && !v.map(e) && !v.set(e) && Object.keys(e).length === 0 || v.set(e) && e.size === 0 || v.map(e) && e.size === 0;
};
v.error = ze("Error");
v.function = Mt("function");
v.generator = function(e) {
  return v.iterable(e) && v.function(e.next) && v.function(e.throw);
};
v.generatorFunction = ze("GeneratorFunction");
v.instanceOf = function(e, t) {
  return !e || !t ? !1 : Object.getPrototypeOf(e) === t.prototype;
};
v.iterable = function(e) {
  return !v.nullOrUndefined(e) && v.function(e[Symbol.iterator]);
};
v.map = ze("Map");
v.nan = function(e) {
  return Number.isNaN(e);
};
v.null = function(e) {
  return e === null;
};
v.nullOrUndefined = function(e) {
  return v.null(e) || v.undefined(e);
};
v.number = function(e) {
  return Mt("number")(e) && !v.nan(e);
};
v.numericString = function(e) {
  return v.string(e) && e.length > 0 && !Number.isNaN(Number(e));
};
v.object = function(e) {
  return !v.nullOrUndefined(e) && (v.function(e) || typeof e == "object");
};
v.oneOf = function(e, t) {
  return v.array(e) ? e.indexOf(t) > -1 : !1;
};
v.plainFunction = ze("Function");
v.plainObject = function(e) {
  if (Fr(e) !== "Object")
    return !1;
  var t = Object.getPrototypeOf(e);
  return t === null || t === Object.getPrototypeOf({});
};
v.primitive = function(e) {
  return v.null(e) || aa(typeof e);
};
v.promise = ze("Promise");
v.propertyOf = function(e, t, r) {
  if (!v.object(e) || !t)
    return !1;
  var o = e[t];
  return v.function(r) ? r(o) : v.defined(o);
};
v.regexp = ze("RegExp");
v.set = ze("Set");
v.string = Mt("string");
v.symbol = Mt("symbol");
v.undefined = Mt("undefined");
v.weakMap = ze("WeakMap");
v.weakSet = ze("WeakSet");
function Vo(e) {
  return function(t) {
    return typeof t === e;
  };
}
var la = Vo("function"), ca = function(e) {
  return e === null;
}, Qn = function(e) {
  return Object.prototype.toString.call(e).slice(8, -1) === "RegExp";
}, eo = function(e) {
  return !ua(e) && !ca(e) && (la(e) || typeof e == "object");
}, ua = Vo("undefined"), cn = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], o = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && o >= e.length && (e = void 0), { value: e && e[o++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function fa(e, t) {
  var r = e.length;
  if (r !== t.length)
    return !1;
  for (var o = r; o-- !== 0; )
    if (!Ne(e[o], t[o]))
      return !1;
  return !0;
}
function pa(e, t) {
  if (e.byteLength !== t.byteLength)
    return !1;
  for (var r = new DataView(e.buffer), o = new DataView(t.buffer), n = e.byteLength; n--; )
    if (r.getUint8(n) !== o.getUint8(n))
      return !1;
  return !0;
}
function da(e, t) {
  var r, o, n, i;
  if (e.size !== t.size)
    return !1;
  try {
    for (var s = cn(e.entries()), a = s.next(); !a.done; a = s.next()) {
      var l = a.value;
      if (!t.has(l[0]))
        return !1;
    }
  } catch (c) {
    r = { error: c };
  } finally {
    try {
      a && !a.done && (o = s.return) && o.call(s);
    } finally {
      if (r) throw r.error;
    }
  }
  try {
    for (var f = cn(e.entries()), u = f.next(); !u.done; u = f.next()) {
      var l = u.value;
      if (!Ne(l[1], t.get(l[0])))
        return !1;
    }
  } catch (c) {
    n = { error: c };
  } finally {
    try {
      u && !u.done && (i = f.return) && i.call(f);
    } finally {
      if (n) throw n.error;
    }
  }
  return !0;
}
function ha(e, t) {
  var r, o;
  if (e.size !== t.size)
    return !1;
  try {
    for (var n = cn(e.entries()), i = n.next(); !i.done; i = n.next()) {
      var s = i.value;
      if (!t.has(s[0]))
        return !1;
    }
  } catch (a) {
    r = { error: a };
  } finally {
    try {
      i && !i.done && (o = n.return) && o.call(n);
    } finally {
      if (r) throw r.error;
    }
  }
  return !0;
}
function Ne(e, t) {
  if (e === t)
    return !0;
  if (e && eo(e) && t && eo(t)) {
    if (e.constructor !== t.constructor)
      return !1;
    if (Array.isArray(e) && Array.isArray(t))
      return fa(e, t);
    if (e instanceof Map && t instanceof Map)
      return da(e, t);
    if (e instanceof Set && t instanceof Set)
      return ha(e, t);
    if (ArrayBuffer.isView(e) && ArrayBuffer.isView(t))
      return pa(e, t);
    if (Qn(e) && Qn(t))
      return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf)
      return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString)
      return e.toString() === t.toString();
    var r = Object.keys(e), o = Object.keys(t);
    if (r.length !== o.length)
      return !1;
    for (var n = r.length; n-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, r[n]))
        return !1;
    for (var n = r.length; n-- !== 0; ) {
      var i = r[n];
      if (!(i === "_owner" && e.$$typeof) && !Ne(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return Number.isNaN(e) && Number.isNaN(t) ? !0 : e === t;
}
function ma() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return e.every(function(r) {
    return v.string(r) || v.array(r) || v.plainObject(r);
  });
}
function ya(e, t, r) {
  return Ko(e, t) ? [e, t].every(v.array) ? !e.some(io(r)) && t.some(io(r)) : [e, t].every(v.plainObject) ? !Object.entries(e).some(oo(r)) && Object.entries(t).some(oo(r)) : t === r : !1;
}
function to(e, t, r) {
  var o = r.actual, n = r.key, i = r.previous, s = r.type, a = Ke(e, n), l = Ke(t, n), f = [a, l].every(v.number) && (s === "increased" ? a < l : a > l);
  return v.undefined(o) || (f = f && l === o), v.undefined(i) || (f = f && a === i), f;
}
function ro(e, t, r) {
  var o = r.key, n = r.type, i = r.value, s = Ke(e, o), a = Ke(t, o), l = n === "added" ? s : a, f = n === "added" ? a : s;
  if (!v.nullOrUndefined(i)) {
    if (v.defined(l)) {
      if (v.array(l) || v.plainObject(l))
        return ya(l, f, i);
    } else
      return Ne(f, i);
    return !1;
  }
  return [s, a].every(v.array) ? !f.every(Tn(l)) : [s, a].every(v.plainObject) ? ga(Object.keys(l), Object.keys(f)) : ![s, a].every(function(u) {
    return v.primitive(u) && v.defined(u);
  }) && (n === "added" ? !v.defined(s) && v.defined(a) : v.defined(s) && !v.defined(a));
}
function no(e, t, r) {
  var o = r === void 0 ? {} : r, n = o.key, i = Ke(e, n), s = Ke(t, n);
  if (!Ko(i, s))
    throw new TypeError("Inputs have different types");
  if (!ma(i, s))
    throw new TypeError("Inputs don't have length");
  return [i, s].every(v.plainObject) && (i = Object.keys(i), s = Object.keys(s)), [i, s];
}
function oo(e) {
  return function(t) {
    var r = t[0], o = t[1];
    return v.array(e) ? Ne(e, o) || e.some(function(n) {
      return Ne(n, o) || v.array(o) && Tn(o)(n);
    }) : v.plainObject(e) && e[r] ? !!e[r] && Ne(e[r], o) : Ne(e, o);
  };
}
function ga(e, t) {
  return t.some(function(r) {
    return !e.includes(r);
  });
}
function io(e) {
  return function(t) {
    return v.array(e) ? e.some(function(r) {
      return Ne(r, t) || v.array(t) && Tn(t)(r);
    }) : Ne(e, t);
  };
}
function Yt(e, t) {
  return v.array(e) ? e.some(function(r) {
    return Ne(r, t);
  }) : Ne(e, t);
}
function Tn(e) {
  return function(t) {
    return e.some(function(r) {
      return Ne(r, t);
    });
  };
}
function Ko() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return e.every(v.array) || e.every(v.number) || e.every(v.plainObject) || e.every(v.string);
}
function Ke(e, t) {
  if (v.plainObject(e) || v.array(e)) {
    if (v.string(t)) {
      var r = t.split(".");
      return r.reduce(function(o, n) {
        return o && o[n];
      }, e);
    }
    return v.number(t) ? e[t] : e;
  }
  return e;
}
function va(e, t) {
  if ([e, t].some(v.nullOrUndefined))
    throw new Error("Missing required parameters");
  if (![e, t].every(function(c) {
    return v.plainObject(c) || v.array(c);
  }))
    throw new Error("Expected plain objects or array");
  var r = function(c, h) {
    try {
      return ro(e, t, { key: c, type: "added", value: h });
    } catch {
      return !1;
    }
  }, o = function(c, h, m) {
    try {
      var y = Ke(e, c), g = Ke(t, c), _ = v.defined(h), x = v.defined(m);
      if (_ || x) {
        var E = x ? Yt(m, y) : !Yt(h, y), F = Yt(h, g);
        return E && F;
      }
      return [y, g].every(v.array) || [y, g].every(v.plainObject) ? !Ne(y, g) : y !== g;
    } catch {
      return !1;
    }
  }, n = function(c, h, m) {
    if (!v.defined(c))
      return !1;
    try {
      var y = Ke(e, c), g = Ke(t, c), _ = v.defined(m);
      return Yt(h, y) && (_ ? Yt(m, g) : !_);
    } catch {
      return !1;
    }
  }, i = function(c, h) {
    return v.defined(c) ? (process.env.NODE_ENV === "development" && console.warn("`changedTo` is deprecated! Replace it with `change`"), o(c, h)) : !1;
  }, s = function(c, h, m) {
    if (!v.defined(c))
      return !1;
    try {
      return to(e, t, { key: c, actual: h, previous: m, type: "decreased" });
    } catch {
      return !1;
    }
  }, a = function(c) {
    try {
      var h = no(e, t, { key: c }), m = h[0], y = h[1];
      return !!m.length && !y.length;
    } catch {
      return !1;
    }
  }, l = function(c) {
    try {
      var h = no(e, t, { key: c }), m = h[0], y = h[1];
      return !m.length && !!y.length;
    } catch {
      return !1;
    }
  }, f = function(c, h, m) {
    if (!v.defined(c))
      return !1;
    try {
      return to(e, t, { key: c, actual: h, previous: m, type: "increased" });
    } catch {
      return !1;
    }
  }, u = function(c, h) {
    try {
      return ro(e, t, { key: c, type: "removed", value: h });
    } catch {
      return !1;
    }
  };
  return { added: r, changed: o, changedFrom: n, changedTo: i, decreased: s, emptied: a, filled: l, increased: f, removed: u };
}
function so(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function fe(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? so(Object(r), !0).forEach(function(o) {
      we(e, o, r[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : so(Object(r)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(r, o));
    });
  }
  return e;
}
function ur(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function ba(e, t) {
  for (var r = 0; r < t.length; r++) {
    var o = t[r];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, Jo(o.key), o);
  }
}
function fr(e, t, r) {
  return t && ba(e.prototype, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function we(e, t, r) {
  return t = Jo(t), t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function pr(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && un(e, t);
}
function Dr(e) {
  return Dr = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Dr(e);
}
function un(e, t) {
  return un = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(o, n) {
    return o.__proto__ = n, o;
  }, un(e, t);
}
function Ea() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Ta(e, t) {
  if (e == null) return {};
  var r = {}, o = Object.keys(e), n, i;
  for (i = 0; i < o.length; i++)
    n = o[i], !(t.indexOf(n) >= 0) && (r[n] = e[n]);
  return r;
}
function Xo(e, t) {
  if (e == null) return {};
  var r = Ta(e, t), o, n;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (n = 0; n < i.length; n++)
      o = i[n], !(t.indexOf(o) >= 0) && Object.prototype.propertyIsEnumerable.call(e, o) && (r[o] = e[o]);
  }
  return r;
}
function nt(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Oa(e, t) {
  if (t && (typeof t == "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return nt(e);
}
function dr(e) {
  var t = Ea();
  return function() {
    var o = Dr(e), n;
    if (t) {
      var i = Dr(this).constructor;
      n = Reflect.construct(o, arguments, i);
    } else
      n = o.apply(this, arguments);
    return Oa(this, n);
  };
}
function wa(e, t) {
  if (typeof e != "object" || e === null) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var o = r.call(e, t || "default");
    if (typeof o != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Jo(e) {
  var t = wa(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
var Sa = { flip: { padding: 20 }, preventOverflow: { padding: 10 } }, _a = "The typeValidator argument must be a function with the signature function(props, propName, componentName).", Ra = "The error message is optional, but must be a string if provided.";
function Pa(e, t, r, o) {
  return typeof e == "boolean" ? e : typeof e == "function" ? e(t, r, o) : e ? !!e : !1;
}
function Ca(e, t) {
  return Object.hasOwnProperty.call(e, t);
}
function xa(e, t, r, o) {
  return new Error("Required ".concat(e[t], " `").concat(t, "` was not specified in `").concat(r, "`."));
}
function Aa(e, t) {
  if (typeof e != "function")
    throw new TypeError(_a);
  if (t && typeof t != "string")
    throw new TypeError(Ra);
}
function ao(e, t, r) {
  return Aa(e, r), function(o, n, i) {
    for (var s = arguments.length, a = new Array(s > 3 ? s - 3 : 0), l = 3; l < s; l++)
      a[l - 3] = arguments[l];
    return Pa(t, o, n, i) ? Ca(o, n) ? e.apply(void 0, [o, n, i].concat(a)) : xa(o, n, i) : e.apply(void 0, [o, n, i].concat(a));
  };
}
var te = { INIT: "init", IDLE: "idle", OPENING: "opening", OPEN: "open", CLOSING: "closing", ERROR: "error" }, qt = Ar.createPortal !== void 0;
function Ye() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function Xr() {
  return "ontouchstart" in window && /Mobi/.test(navigator.userAgent);
}
function Rr(e) {
  var t = e.title, r = e.data, o = e.warn, n = o === void 0 ? !1 : o, i = e.debug, s = i === void 0 ? !1 : i, a = n ? console.warn || console.error : console.log;
  s && t && r && (console.groupCollapsed("%creact-floater: ".concat(t), "color: #9b00ff; font-weight: bold; font-size: 12px;"), Array.isArray(r) ? r.forEach(function(l) {
    v.plainObject(l) && l.key ? a.apply(console, [l.key, l.value]) : a.apply(console, [l]);
  }) : a.apply(console, [r]), console.groupEnd());
}
function Na(e, t, r) {
  var o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  e.addEventListener(t, r, o);
}
function Ia(e, t, r) {
  var o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  e.removeEventListener(t, r, o);
}
function ka(e, t, r) {
  var o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, n;
  n = function(s) {
    r(s), Ia(e, t, n);
  }, Na(e, t, n, o);
}
function lo() {
}
var Zo = /* @__PURE__ */ function(e) {
  pr(r, e);
  var t = dr(r);
  function r() {
    return ur(this, r), t.apply(this, arguments);
  }
  return fr(r, [{ key: "componentDidMount", value: function() {
    Ye() && (this.node || this.appendNode(), qt || this.renderPortal());
  } }, { key: "componentDidUpdate", value: function() {
    Ye() && (qt || this.renderPortal());
  } }, { key: "componentWillUnmount", value: function() {
    !Ye() || !this.node || (qt || Ar.unmountComponentAtNode(this.node), this.node && this.node.parentNode === document.body && (document.body.removeChild(this.node), this.node = void 0));
  } }, { key: "appendNode", value: function() {
    var n = this.props, i = n.id, s = n.zIndex;
    this.node || (this.node = document.createElement("div"), i && (this.node.id = i), s && (this.node.style.zIndex = s), document.body.appendChild(this.node));
  } }, { key: "renderPortal", value: function() {
    if (!Ye()) return null;
    var n = this.props, i = n.children, s = n.setRef;
    if (this.node || this.appendNode(), qt)
      return /* @__PURE__ */ Ar.createPortal(i, this.node);
    var a = Ar.unstable_renderSubtreeIntoContainer(this, i.length > 1 ? /* @__PURE__ */ z.createElement("div", null, i) : i[0], this.node);
    return s(a), null;
  } }, { key: "renderReact16", value: function() {
    var n = this.props, i = n.hasChildren, s = n.placement, a = n.target;
    return i ? this.renderPortal() : a || s === "center" ? this.renderPortal() : null;
  } }, { key: "render", value: function() {
    return qt ? this.renderReact16() : null;
  } }]), r;
}(z.Component);
we(Zo, "propTypes", { children: R.oneOfType([R.element, R.array]), hasChildren: R.bool, id: R.oneOfType([R.string, R.number]), placement: R.string, setRef: R.func.isRequired, target: R.oneOfType([R.object, R.string]), zIndex: R.number });
var Qo = /* @__PURE__ */ function(e) {
  pr(r, e);
  var t = dr(r);
  function r() {
    return ur(this, r), t.apply(this, arguments);
  }
  return fr(r, [{ key: "parentStyle", get: function() {
    var n = this.props, i = n.placement, s = n.styles, a = s.arrow.length, l = { pointerEvents: "none", position: "absolute", width: "100%" };
    return i.startsWith("top") ? (l.bottom = 0, l.left = 0, l.right = 0, l.height = a) : i.startsWith("bottom") ? (l.left = 0, l.right = 0, l.top = 0, l.height = a) : i.startsWith("left") ? (l.right = 0, l.top = 0, l.bottom = 0) : i.startsWith("right") && (l.left = 0, l.top = 0), l;
  } }, { key: "render", value: function() {
    var n = this.props, i = n.placement, s = n.setArrowRef, a = n.styles, l = a.arrow, f = l.color, u = l.display, c = l.length, h = l.margin, m = l.position, y = l.spread, g = { display: u, position: m }, _, x = y, E = c;
    return i.startsWith("top") ? (_ = "0,0 ".concat(x / 2, ",").concat(E, " ").concat(x, ",0"), g.bottom = 0, g.marginLeft = h, g.marginRight = h) : i.startsWith("bottom") ? (_ = "".concat(x, ",").concat(E, " ").concat(x / 2, ",0 0,").concat(E), g.top = 0, g.marginLeft = h, g.marginRight = h) : i.startsWith("left") ? (E = y, x = c, _ = "0,0 ".concat(x, ",").concat(E / 2, " 0,").concat(E), g.right = 0, g.marginTop = h, g.marginBottom = h) : i.startsWith("right") && (E = y, x = c, _ = "".concat(x, ",").concat(E, " ").concat(x, ",0 0,").concat(E / 2), g.left = 0, g.marginTop = h, g.marginBottom = h), /* @__PURE__ */ z.createElement("div", { className: "__floater__arrow", style: this.parentStyle }, /* @__PURE__ */ z.createElement("span", { ref: s, style: g }, /* @__PURE__ */ z.createElement("svg", { width: x, height: E, version: "1.1", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ z.createElement("polygon", { points: _, fill: f }))));
  } }]), r;
}(z.Component);
we(Qo, "propTypes", { placement: R.string.isRequired, setArrowRef: R.func.isRequired, styles: R.object.isRequired });
var La = ["color", "height", "width"];
function ei(e) {
  var t = e.handleClick, r = e.styles, o = r.color, n = r.height, i = r.width, s = Xo(r, La);
  return /* @__PURE__ */ z.createElement("button", { "aria-label": "close", onClick: t, style: s, type: "button" }, /* @__PURE__ */ z.createElement("svg", { width: "".concat(i, "px"), height: "".concat(n, "px"), viewBox: "0 0 18 18", version: "1.1", xmlns: "http://www.w3.org/2000/svg", preserveAspectRatio: "xMidYMid" }, /* @__PURE__ */ z.createElement("g", null, /* @__PURE__ */ z.createElement("path", { d: "M8.13911129,9.00268191 L0.171521827,17.0258467 C-0.0498027049,17.248715 -0.0498027049,17.6098394 0.171521827,17.8327545 C0.28204354,17.9443526 0.427188206,17.9998706 0.572051765,17.9998706 C0.71714958,17.9998706 0.862013139,17.9443526 0.972581703,17.8327545 L9.0000937,9.74924618 L17.0276057,17.8327545 C17.1384085,17.9443526 17.2832721,17.9998706 17.4281356,17.9998706 C17.5729992,17.9998706 17.718097,17.9443526 17.8286656,17.8327545 C18.0499901,17.6098862 18.0499901,17.2487618 17.8286656,17.0258467 L9.86135722,9.00268191 L17.8340066,0.973848225 C18.0553311,0.750979934 18.0553311,0.389855532 17.8340066,0.16694039 C17.6126821,-0.0556467968 17.254037,-0.0556467968 17.0329467,0.16694039 L9.00042166,8.25611765 L0.967006424,0.167268345 C0.745681892,-0.0553188426 0.387317931,-0.0553188426 0.165993399,0.167268345 C-0.0553311331,0.390136635 -0.0553311331,0.751261038 0.165993399,0.974176179 L8.13920499,9.00268191 L8.13911129,9.00268191 Z", fill: o }))));
}
ei.propTypes = { handleClick: R.func.isRequired, styles: R.object.isRequired };
function ti(e) {
  var t = e.content, r = e.footer, o = e.handleClick, n = e.open, i = e.positionWrapper, s = e.showCloseButton, a = e.title, l = e.styles, f = { content: /* @__PURE__ */ z.isValidElement(t) ? t : /* @__PURE__ */ z.createElement("div", { className: "__floater__content", style: l.content }, t) };
  return a && (f.title = /* @__PURE__ */ z.isValidElement(a) ? a : /* @__PURE__ */ z.createElement("div", { className: "__floater__title", style: l.title }, a)), r && (f.footer = /* @__PURE__ */ z.isValidElement(r) ? r : /* @__PURE__ */ z.createElement("div", { className: "__floater__footer", style: l.footer }, r)), (s || i) && !v.boolean(n) && (f.close = /* @__PURE__ */ z.createElement(ei, { styles: l.close, handleClick: o })), /* @__PURE__ */ z.createElement("div", { className: "__floater__container", style: l.container }, f.close, f.title, f.content, f.footer);
}
ti.propTypes = { content: R.node.isRequired, footer: R.node, handleClick: R.func.isRequired, open: R.bool, positionWrapper: R.bool.isRequired, showCloseButton: R.bool.isRequired, styles: R.object.isRequired, title: R.node };
var ri = /* @__PURE__ */ function(e) {
  pr(r, e);
  var t = dr(r);
  function r() {
    return ur(this, r), t.apply(this, arguments);
  }
  return fr(r, [{ key: "style", get: function() {
    var n = this.props, i = n.disableAnimation, s = n.component, a = n.placement, l = n.hideArrow, f = n.status, u = n.styles, c = u.arrow.length, h = u.floater, m = u.floaterCentered, y = u.floaterClosing, g = u.floaterOpening, _ = u.floaterWithAnimation, x = u.floaterWithComponent, E = {};
    return l || (a.startsWith("top") ? E.padding = "0 0 ".concat(c, "px") : a.startsWith("bottom") ? E.padding = "".concat(c, "px 0 0") : a.startsWith("left") ? E.padding = "0 ".concat(c, "px 0 0") : a.startsWith("right") && (E.padding = "0 0 0 ".concat(c, "px"))), [te.OPENING, te.OPEN].indexOf(f) !== -1 && (E = fe(fe({}, E), g)), f === te.CLOSING && (E = fe(fe({}, E), y)), f === te.OPEN && !i && (E = fe(fe({}, E), _)), a === "center" && (E = fe(fe({}, E), m)), s && (E = fe(fe({}, E), x)), fe(fe({}, h), E);
  } }, { key: "render", value: function() {
    var n = this.props, i = n.component, s = n.handleClick, a = n.hideArrow, l = n.setFloaterRef, f = n.status, u = {}, c = ["__floater"];
    return i ? /* @__PURE__ */ z.isValidElement(i) ? u.content = /* @__PURE__ */ z.cloneElement(i, { closeFn: s }) : u.content = i({ closeFn: s }) : u.content = /* @__PURE__ */ z.createElement(ti, this.props), f === te.OPEN && c.push("__floater__open"), a || (u.arrow = /* @__PURE__ */ z.createElement(Qo, this.props)), /* @__PURE__ */ z.createElement("div", { ref: l, className: c.join(" "), style: this.style }, /* @__PURE__ */ z.createElement("div", { className: "__floater__body" }, u.content, u.arrow));
  } }]), r;
}(z.Component);
we(ri, "propTypes", { component: R.oneOfType([R.func, R.element]), content: R.node, disableAnimation: R.bool.isRequired, footer: R.node, handleClick: R.func.isRequired, hideArrow: R.bool.isRequired, open: R.bool, placement: R.string.isRequired, positionWrapper: R.bool.isRequired, setArrowRef: R.func.isRequired, setFloaterRef: R.func.isRequired, showCloseButton: R.bool, status: R.string.isRequired, styles: R.object.isRequired, title: R.node });
var ni = /* @__PURE__ */ function(e) {
  pr(r, e);
  var t = dr(r);
  function r() {
    return ur(this, r), t.apply(this, arguments);
  }
  return fr(r, [{ key: "render", value: function() {
    var n = this.props, i = n.children, s = n.handleClick, a = n.handleMouseEnter, l = n.handleMouseLeave, f = n.setChildRef, u = n.setWrapperRef, c = n.style, h = n.styles, m;
    if (i)
      if (z.Children.count(i) === 1)
        if (!/* @__PURE__ */ z.isValidElement(i))
          m = /* @__PURE__ */ z.createElement("span", null, i);
        else {
          var y = v.function(i.type) ? "innerRef" : "ref";
          m = /* @__PURE__ */ z.cloneElement(z.Children.only(i), we({}, y, f));
        }
      else
        m = i;
    return m ? /* @__PURE__ */ z.createElement("span", { ref: u, style: fe(fe({}, h), c), onClick: s, onMouseEnter: a, onMouseLeave: l }, m) : null;
  } }]), r;
}(z.Component);
we(ni, "propTypes", { children: R.node, handleClick: R.func.isRequired, handleMouseEnter: R.func.isRequired, handleMouseLeave: R.func.isRequired, setChildRef: R.func.isRequired, setWrapperRef: R.func.isRequired, style: R.object, styles: R.object.isRequired });
var Ma = { zIndex: 100 };
function Da(e) {
  var t = $e(Ma, e.options || {});
  return { wrapper: { cursor: "help", display: "inline-flex", flexDirection: "column", zIndex: t.zIndex }, wrapperPosition: { left: -1e3, position: "absolute", top: -1e3, visibility: "hidden" }, floater: { display: "inline-block", filter: "drop-shadow(0 0 3px rgba(0, 0, 0, 0.3))", maxWidth: 300, opacity: 0, position: "relative", transition: "opacity 0.3s", visibility: "hidden", zIndex: t.zIndex }, floaterOpening: { opacity: 1, visibility: "visible" }, floaterWithAnimation: { opacity: 1, transition: "opacity 0.3s, transform 0.2s", visibility: "visible" }, floaterWithComponent: { maxWidth: "100%" }, floaterClosing: { opacity: 0, visibility: "visible" }, floaterCentered: { left: "50%", position: "fixed", top: "50%", transform: "translate(-50%, -50%)" }, container: { backgroundColor: "#fff", color: "#666", minHeight: 60, minWidth: 200, padding: 20, position: "relative", zIndex: 10 }, title: { borderBottom: "1px solid #555", color: "#555", fontSize: 18, marginBottom: 5, paddingBottom: 6, paddingRight: 18 }, content: { fontSize: 15 }, close: { backgroundColor: "transparent", border: 0, borderRadius: 0, color: "#555", fontSize: 0, height: 15, outline: "none", padding: 10, position: "absolute", right: 0, top: 0, width: 15, WebkitAppearance: "none" }, footer: { borderTop: "1px solid #ccc", fontSize: 13, marginTop: 10, paddingTop: 5 }, arrow: { color: "#fff", display: "inline-flex", length: 16, margin: 8, position: "absolute", spread: 32 }, options: t };
}
var ja = ["arrow", "flip", "offset"], Fa = ["position", "top", "right", "bottom", "left"], On = /* @__PURE__ */ function(e) {
  pr(r, e);
  var t = dr(r);
  function r(o) {
    var n;
    return ur(this, r), n = t.call(this, o), we(nt(n), "setArrowRef", function(i) {
      n.arrowRef = i;
    }), we(nt(n), "setChildRef", function(i) {
      n.childRef = i;
    }), we(nt(n), "setFloaterRef", function(i) {
      n.floaterRef = i;
    }), we(nt(n), "setWrapperRef", function(i) {
      n.wrapperRef = i;
    }), we(nt(n), "handleTransitionEnd", function() {
      var i = n.state.status, s = n.props.callback;
      n.wrapperPopper && n.wrapperPopper.instance.update(), n.setState({ status: i === te.OPENING ? te.OPEN : te.IDLE }, function() {
        var a = n.state.status;
        s(a === te.OPEN ? "open" : "close", n.props);
      });
    }), we(nt(n), "handleClick", function() {
      var i = n.props, s = i.event, a = i.open;
      if (!v.boolean(a)) {
        var l = n.state, f = l.positionWrapper, u = l.status;
        (n.event === "click" || n.event === "hover" && f) && (Rr({ title: "click", data: [{ event: s, status: u === te.OPEN ? "closing" : "opening" }], debug: n.debug }), n.toggle());
      }
    }), we(nt(n), "handleMouseEnter", function() {
      var i = n.props, s = i.event, a = i.open;
      if (!(v.boolean(a) || Xr())) {
        var l = n.state.status;
        n.event === "hover" && l === te.IDLE && (Rr({ title: "mouseEnter", data: [{ key: "originalEvent", value: s }], debug: n.debug }), clearTimeout(n.eventDelayTimeout), n.toggle());
      }
    }), we(nt(n), "handleMouseLeave", function() {
      var i = n.props, s = i.event, a = i.eventDelay, l = i.open;
      if (!(v.boolean(l) || Xr())) {
        var f = n.state, u = f.status, c = f.positionWrapper;
        n.event === "hover" && (Rr({ title: "mouseLeave", data: [{ key: "originalEvent", value: s }], debug: n.debug }), a ? [te.OPENING, te.OPEN].indexOf(u) !== -1 && !c && !n.eventDelayTimeout && (n.eventDelayTimeout = setTimeout(function() {
          delete n.eventDelayTimeout, n.toggle();
        }, a * 1e3)) : n.toggle(te.IDLE));
      }
    }), n.state = { currentPlacement: o.placement, needsUpdate: !1, positionWrapper: o.wrapperOptions.position && !!o.target, status: te.INIT, statusWrapper: te.INIT }, n._isMounted = !1, n.hasMounted = !1, Ye() && window.addEventListener("load", function() {
      n.popper && n.popper.instance.update(), n.wrapperPopper && n.wrapperPopper.instance.update();
    }), n;
  }
  return fr(r, [{ key: "componentDidMount", value: function() {
    if (Ye()) {
      var n = this.state.positionWrapper, i = this.props, s = i.children, a = i.open, l = i.target;
      this._isMounted = !0, Rr({ title: "init", data: { hasChildren: !!s, hasTarget: !!l, isControlled: v.boolean(a), positionWrapper: n, target: this.target, floater: this.floaterRef }, debug: this.debug }), this.hasMounted || (this.initPopper(), this.hasMounted = !0), !s && l && v.boolean(a);
    }
  } }, { key: "componentDidUpdate", value: function(n, i) {
    if (Ye()) {
      var s = this.props, a = s.autoOpen, l = s.open, f = s.target, u = s.wrapperOptions, c = va(i, this.state), h = c.changedFrom, m = c.changed;
      if (n.open !== l) {
        var y;
        v.boolean(l) && (y = l ? te.OPENING : te.CLOSING), this.toggle(y);
      }
      (n.wrapperOptions.position !== u.position || n.target !== f) && this.changeWrapperPosition(this.props), m("status", te.IDLE) && l ? this.toggle(te.OPEN) : h("status", te.INIT, te.IDLE) && a && this.toggle(te.OPEN), this.popper && m("status", te.OPENING) && this.popper.instance.update(), this.floaterRef && (m("status", te.OPENING) || m("status", te.CLOSING)) && ka(this.floaterRef, "transitionend", this.handleTransitionEnd), m("needsUpdate", !0) && this.rebuildPopper();
    }
  } }, { key: "componentWillUnmount", value: function() {
    Ye() && (this._isMounted = !1, this.popper && this.popper.instance.destroy(), this.wrapperPopper && this.wrapperPopper.instance.destroy());
  } }, { key: "initPopper", value: function() {
    var n = this, i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.target, s = this.state.positionWrapper, a = this.props, l = a.disableFlip, f = a.getPopper, u = a.hideArrow, c = a.offset, h = a.placement, m = a.wrapperOptions, y = h === "top" || h === "bottom" ? "flip" : ["right", "bottom-end", "top-end", "left", "top-start", "bottom-start"];
    if (h === "center")
      this.setState({ status: te.IDLE });
    else if (i && this.floaterRef) {
      var g = this.options, _ = g.arrow, x = g.flip, E = g.offset, F = Xo(g, ja);
      new or(i, this.floaterRef, { placement: h, modifiers: fe({ arrow: fe({ enabled: !u, element: this.arrowRef }, _), flip: fe({ enabled: !l, behavior: y }, x), offset: fe({ offset: "0, ".concat(c, "px") }, E) }, F), onCreate: function(W) {
        var q;
        if (n.popper = W, !((q = n.floaterRef) !== null && q !== void 0 && q.isConnected)) {
          n.setState({ needsUpdate: !0 });
          return;
        }
        f(W, "floater"), n._isMounted && n.setState({ currentPlacement: W.placement, status: te.IDLE }), h !== W.placement && setTimeout(function() {
          W.instance.update();
        }, 1);
      }, onUpdate: function(W) {
        n.popper = W;
        var q = n.state.currentPlacement;
        n._isMounted && W.placement !== q && n.setState({ currentPlacement: W.placement });
      } });
    }
    if (s) {
      var M = v.undefined(m.offset) ? 0 : m.offset;
      new or(this.target, this.wrapperRef, { placement: m.placement || h, modifiers: { arrow: { enabled: !1 }, offset: { offset: "0, ".concat(M, "px") }, flip: { enabled: !1 } }, onCreate: function(W) {
        n.wrapperPopper = W, n._isMounted && n.setState({ statusWrapper: te.IDLE }), f(W, "wrapper"), h !== W.placement && setTimeout(function() {
          W.instance.update();
        }, 1);
      } });
    }
  } }, { key: "rebuildPopper", value: function() {
    var n = this;
    this.floaterRefInterval = setInterval(function() {
      var i;
      (i = n.floaterRef) !== null && i !== void 0 && i.isConnected && (clearInterval(n.floaterRefInterval), n.setState({ needsUpdate: !1 }), n.initPopper());
    }, 50);
  } }, { key: "changeWrapperPosition", value: function(n) {
    var i = n.target, s = n.wrapperOptions;
    this.setState({ positionWrapper: s.position && !!i });
  } }, { key: "toggle", value: function(n) {
    var i = this.state.status, s = i === te.OPEN ? te.CLOSING : te.OPENING;
    v.undefined(n) || (s = n), this.setState({ status: s });
  } }, { key: "debug", get: function() {
    var n = this.props.debug;
    return n || Ye() && "ReactFloaterDebug" in window && !!window.ReactFloaterDebug;
  } }, { key: "event", get: function() {
    var n = this.props, i = n.disableHoverToClick, s = n.event;
    return s === "hover" && Xr() && !i ? "click" : s;
  } }, { key: "options", get: function() {
    var n = this.props.options;
    return $e(Sa, n || {});
  } }, { key: "styles", get: function() {
    var n = this, i = this.state, s = i.status, a = i.positionWrapper, l = i.statusWrapper, f = this.props.styles, u = $e(Da(f), f);
    if (a) {
      var c;
      [te.IDLE].indexOf(s) === -1 || [te.IDLE].indexOf(l) === -1 ? c = u.wrapperPosition : c = this.wrapperPopper.styles, u.wrapper = fe(fe({}, u.wrapper), c);
    }
    if (this.target) {
      var h = window.getComputedStyle(this.target);
      this.wrapperStyles ? u.wrapper = fe(fe({}, u.wrapper), this.wrapperStyles) : ["relative", "static"].indexOf(h.position) === -1 && (this.wrapperStyles = {}, a || (Fa.forEach(function(m) {
        n.wrapperStyles[m] = h[m];
      }), u.wrapper = fe(fe({}, u.wrapper), this.wrapperStyles), this.target.style.position = "relative", this.target.style.top = "auto", this.target.style.right = "auto", this.target.style.bottom = "auto", this.target.style.left = "auto"));
    }
    return u;
  } }, { key: "target", get: function() {
    if (!Ye()) return null;
    var n = this.props.target;
    return n ? v.domElement(n) ? n : document.querySelector(n) : this.childRef || this.wrapperRef;
  } }, { key: "render", value: function() {
    var n = this.state, i = n.currentPlacement, s = n.positionWrapper, a = n.status, l = this.props, f = l.children, u = l.component, c = l.content, h = l.disableAnimation, m = l.footer, y = l.hideArrow, g = l.id, _ = l.open, x = l.showCloseButton, E = l.style, F = l.target, M = l.title, O = /* @__PURE__ */ z.createElement(ni, { handleClick: this.handleClick, handleMouseEnter: this.handleMouseEnter, handleMouseLeave: this.handleMouseLeave, setChildRef: this.setChildRef, setWrapperRef: this.setWrapperRef, style: E, styles: this.styles.wrapper }, f), W = {};
    return s ? W.wrapperInPortal = O : W.wrapperAsChildren = O, /* @__PURE__ */ z.createElement("span", null, /* @__PURE__ */ z.createElement(Zo, { hasChildren: !!f, id: g, placement: i, setRef: this.setFloaterRef, target: F, zIndex: this.styles.options.zIndex }, /* @__PURE__ */ z.createElement(ri, { component: u, content: c, disableAnimation: h, footer: m, handleClick: this.handleClick, hideArrow: y || i === "center", open: _, placement: i, positionWrapper: s, setArrowRef: this.setArrowRef, setFloaterRef: this.setFloaterRef, showCloseButton: x, status: a, styles: this.styles, title: M }), W.wrapperInPortal), W.wrapperAsChildren);
  } }]), r;
}(z.Component);
we(On, "propTypes", { autoOpen: R.bool, callback: R.func, children: R.node, component: ao(R.oneOfType([R.func, R.element]), function(e) {
  return !e.content;
}), content: ao(R.node, function(e) {
  return !e.component;
}), debug: R.bool, disableAnimation: R.bool, disableFlip: R.bool, disableHoverToClick: R.bool, event: R.oneOf(["hover", "click"]), eventDelay: R.number, footer: R.node, getPopper: R.func, hideArrow: R.bool, id: R.oneOfType([R.string, R.number]), offset: R.number, open: R.bool, options: R.object, placement: R.oneOf(["top", "top-start", "top-end", "bottom", "bottom-start", "bottom-end", "left", "left-start", "left-end", "right", "right-start", "right-end", "auto", "center"]), showCloseButton: R.bool, style: R.object, styles: R.object, target: R.oneOfType([R.object, R.string]), title: R.node, wrapperOptions: R.shape({ offset: R.number, placement: R.oneOf(["top", "top-start", "top-end", "bottom", "bottom-start", "bottom-end", "left", "left-start", "left-end", "right", "right-start", "right-end", "auto"]), position: R.bool }) });
we(On, "defaultProps", { autoOpen: !1, callback: lo, debug: !1, disableAnimation: !1, disableFlip: !1, disableHoverToClick: !1, event: "click", eventDelay: 0.4, getPopper: lo, hideArrow: !1, offset: 15, placement: "bottom", showCloseButton: !1, styles: {}, target: null, wrapperOptions: { position: !1 } });
var Wa = Object.defineProperty, Ua = (e, t, r) => t in e ? Wa(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, L = (e, t, r) => Ua(e, typeof t != "symbol" ? t + "" : t, r), oe = {
  INIT: "init",
  START: "start",
  STOP: "stop",
  RESET: "reset",
  PREV: "prev",
  NEXT: "next",
  GO: "go",
  CLOSE: "close",
  SKIP: "skip",
  UPDATE: "update"
}, ke = {
  TOUR_START: "tour:start",
  STEP_BEFORE: "step:before",
  BEACON: "beacon",
  TOOLTIP: "tooltip",
  STEP_AFTER: "step:after",
  TOUR_END: "tour:end",
  TOUR_STATUS: "tour:status",
  TARGET_NOT_FOUND: "error:target_not_found",
  ERROR: "error"
}, G = {
  INIT: "init",
  READY: "ready",
  BEACON: "beacon",
  TOOLTIP: "tooltip",
  COMPLETE: "complete",
  ERROR: "error"
}, X = {
  IDLE: "idle",
  READY: "ready",
  WAITING: "waiting",
  RUNNING: "running",
  PAUSED: "paused",
  SKIPPED: "skipped",
  FINISHED: "finished",
  ERROR: "error"
};
function ut() {
  var e;
  return !!(typeof window < "u" && ((e = window.document) != null && e.createElement));
}
function oi(e) {
  return e ? e.getBoundingClientRect() : null;
}
function Ba(e = !1) {
  const { body: t, documentElement: r } = document;
  if (!t || !r)
    return 0;
  if (e) {
    const o = [
      t.scrollHeight,
      t.offsetHeight,
      r.clientHeight,
      r.scrollHeight,
      r.offsetHeight
    ].sort((i, s) => i - s), n = Math.floor(o.length / 2);
    return o.length % 2 === 0 ? (o[n - 1] + o[n]) / 2 : o[n];
  }
  return Math.max(
    t.scrollHeight,
    t.offsetHeight,
    r.clientHeight,
    r.scrollHeight,
    r.offsetHeight
  );
}
function ot(e) {
  if (typeof e == "string")
    try {
      return document.querySelector(e);
    } catch (t) {
      return process.env.NODE_ENV !== "production" && console.error(t), null;
    }
  return e;
}
function $a(e) {
  return !e || e.nodeType !== 1 ? null : getComputedStyle(e);
}
function ir(e, t, r) {
  if (!e)
    return vt();
  const o = xo(e);
  if (o) {
    if (o.isSameNode(vt()))
      return r ? document : vt();
    if (!(o.scrollHeight > o.offsetHeight) && !t)
      return o.style.overflow = "initial", vt();
  }
  return o;
}
function hr(e, t) {
  if (!e)
    return !1;
  const r = ir(e, t);
  return r ? !r.isSameNode(vt()) : !1;
}
function Ha(e) {
  return e.offsetParent !== document.body;
}
function It(e, t = "fixed") {
  if (!e || !(e instanceof HTMLElement))
    return !1;
  const { nodeName: r } = e, o = $a(e);
  return r === "BODY" || r === "HTML" ? !1 : o && o.position === t ? !0 : e.parentNode ? It(e.parentNode, t) : !1;
}
function za(e) {
  var t;
  if (!e)
    return !1;
  let r = e;
  for (; r && r !== document.body; ) {
    if (r instanceof HTMLElement) {
      const { display: o, visibility: n } = getComputedStyle(r);
      if (o === "none" || n === "hidden")
        return !1;
    }
    r = (t = r.parentElement) != null ? t : null;
  }
  return !0;
}
function Ga(e, t, r) {
  var o, n, i;
  const s = oi(e), a = ir(e, r), l = hr(e, r), f = It(e);
  let u = 0, c = (o = s == null ? void 0 : s.top) != null ? o : 0;
  if (l && f) {
    const h = (n = e == null ? void 0 : e.offsetTop) != null ? n : 0, m = (i = a == null ? void 0 : a.scrollTop) != null ? i : 0;
    c = h - m;
  } else a instanceof HTMLElement && (u = a.scrollTop, !l && !It(e) && (c += u), a.isSameNode(vt()) || (c += vt().scrollTop));
  return Math.floor(c - t);
}
function Ya(e, t, r) {
  var o;
  if (!e)
    return 0;
  const { offsetTop: n = 0, scrollTop: i = 0 } = (o = xo(e)) != null ? o : {};
  let s = e.getBoundingClientRect().top + i;
  n && (hr(e, r) || Ha(e)) && (s -= n);
  const a = Math.floor(s - t);
  return a < 0 ? 0 : a;
}
function vt() {
  var e;
  return (e = document.scrollingElement) != null ? e : document.documentElement;
}
function qa(e, t) {
  const { duration: r, element: o } = t;
  return new Promise((n, i) => {
    const { scrollTop: s } = o, a = e > s ? e - s : s - e;
    Yi.top(o, e, { duration: a < 100 ? 50 : r }, (l) => l && l.message !== "Element already at target scroll position" ? i(l) : n());
  });
}
var Vt = Ti !== void 0;
function ii(e = navigator.userAgent) {
  let t = e;
  return typeof window > "u" ? t = "node" : document.documentMode ? t = "ie" : /Edge/.test(e) ? t = "edge" : window.opera || e.includes(" OPR/") ? t = "opera" : typeof window.InstallTrigger < "u" ? t = "firefox" : window.chrome ? t = "chrome" : /(Version\/([\d._]+).*Safari|CriOS|FxiOS| Mobile\/)/.test(e) && (t = "safari"), t;
}
function Nr(e) {
  return Object.prototype.toString.call(e).slice(8, -1).toLowerCase();
}
function qe(e, t = {}) {
  const { defaultValue: r, step: o, steps: n } = t;
  let i = jn(e);
  if (i)
    (i.includes("{step}") || i.includes("{steps}")) && o && n && (i = i.replace("{step}", o.toString()).replace("{steps}", n.toString()));
  else if (_o(e) && !Object.values(e.props).length && Nr(e.type) === "function") {
    const s = e.type({});
    i = qe(s, t);
  } else
    i = jn(r);
  return i;
}
function Va(e, t) {
  return !k.plainObject(e) || !k.array(t) ? !1 : Object.keys(e).every((r) => t.includes(r));
}
function Ka(e) {
  const t = /^#?([\da-f])([\da-f])([\da-f])$/i, r = e.replace(t, (n, i, s, a) => i + i + s + s + a + a), o = /^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i.exec(r);
  return o ? [parseInt(o[1], 16), parseInt(o[2], 16), parseInt(o[3], 16)] : [];
}
function co(e) {
  return e.disableBeacon || e.placement === "center";
}
function uo() {
  return !["chrome", "safari", "firefox", "opera"].includes(ii());
}
function pt({ data: e, debug: t = !1, title: r, warn: o = !1 }) {
  const n = o ? console.warn || console.error : console.log;
  t && (r && e ? (console.groupCollapsed(
    `%creact-joyride: ${r}`,
    "color: #ff0044; font-weight: bold; font-size: 12px;"
  ), Array.isArray(e) ? e.forEach((i) => {
    k.plainObject(i) && i.key ? n.apply(console, [i.key, i.value]) : n.apply(console, [i]);
  }) : n.apply(console, [e]), console.groupEnd()) : console.error("Missing title or data props"));
}
function Xa(e) {
  return Object.keys(e);
}
function si(e, ...t) {
  if (!k.plainObject(e))
    throw new TypeError("Expected an object");
  const r = {};
  for (const o in e)
    ({}).hasOwnProperty.call(e, o) && (t.includes(o) || (r[o] = e[o]));
  return r;
}
function Ja(e, ...t) {
  if (!k.plainObject(e))
    throw new TypeError("Expected an object");
  if (!t.length)
    return e;
  const r = {};
  for (const o in e)
    ({}).hasOwnProperty.call(e, o) && t.includes(o) && (r[o] = e[o]);
  return r;
}
function fn(e, t, r) {
  const o = (i) => i.replace("{step}", String(t)).replace("{steps}", String(r));
  if (Nr(e) === "string")
    return o(e);
  if (!_o(e))
    return e;
  const { children: n } = e.props;
  if (Nr(n) === "string" && n.includes("{step}"))
    return _n(e, {
      children: o(n)
    });
  if (Array.isArray(n))
    return _n(e, {
      children: n.map((i) => typeof i == "string" ? o(i) : fn(i, t, r))
    });
  if (Nr(e.type) === "function" && !Object.values(e.props).length) {
    const i = e.type({});
    return fn(i, t, r);
  }
  return e;
}
function Za(e) {
  const { isFirstStep: t, lifecycle: r, previousLifecycle: o, scrollToFirstStep: n, step: i, target: s } = e;
  return !i.disableScrolling && (!t || n || r === G.TOOLTIP) && i.placement !== "center" && (!i.isFixed || !It(s)) && // fixed steps don't need to scroll
  o !== r && [G.BEACON, G.TOOLTIP].includes(r);
}
var Qa = {
  options: {
    preventOverflow: {
      boundariesElement: "scrollParent"
    }
  },
  wrapperOptions: {
    offset: -18,
    position: !0
  }
}, ai = {
  back: "Back",
  close: "Close",
  last: "Last",
  next: "Next",
  nextLabelWithProgress: "Next (Step {step} of {steps})",
  open: "Open the dialog",
  skip: "Skip"
}, el = {
  event: "click",
  placement: "bottom",
  offset: 10,
  disableBeacon: !1,
  disableCloseOnEsc: !1,
  disableOverlay: !1,
  disableOverlayClose: !1,
  disableScrollParentFix: !1,
  disableScrolling: !1,
  hideBackButton: !1,
  hideCloseButton: !1,
  hideFooter: !1,
  isFixed: !1,
  locale: ai,
  showProgress: !1,
  showSkipButton: !1,
  spotlightClicks: !1,
  spotlightPadding: 10
}, tl = {
  continuous: !1,
  debug: !1,
  disableCloseOnEsc: !1,
  disableOverlay: !1,
  disableOverlayClose: !1,
  disableScrolling: !1,
  disableScrollParentFix: !1,
  getHelpers: void 0,
  hideBackButton: !1,
  run: !0,
  scrollOffset: 20,
  scrollDuration: 300,
  scrollToFirstStep: !1,
  showSkipButton: !1,
  showProgress: !1,
  spotlightClicks: !1,
  spotlightPadding: 10,
  steps: []
}, rl = {
  arrowColor: "#fff",
  backgroundColor: "#fff",
  beaconSize: 36,
  overlayColor: "rgba(0, 0, 0, 0.5)",
  primaryColor: "#f04",
  spotlightShadow: "0 0 15px rgba(0, 0, 0, 0.5)",
  textColor: "#333",
  width: 380,
  zIndex: 100
}, Kt = {
  backgroundColor: "transparent",
  border: 0,
  borderRadius: 0,
  color: "#555",
  cursor: "pointer",
  fontSize: 16,
  lineHeight: 1,
  padding: 8,
  WebkitAppearance: "none"
}, fo = {
  borderRadius: 4,
  position: "absolute"
};
function nl(e, t) {
  var r, o, n, i, s;
  const { floaterProps: a, styles: l } = e, f = $e((r = t.floaterProps) != null ? r : {}, a ?? {}), u = $e(l ?? {}, (o = t.styles) != null ? o : {}), c = $e(rl, u.options || {}), h = t.placement === "center" || t.disableBeacon;
  let { width: m } = c;
  window.innerWidth > 480 && (m = 380), "width" in c && (m = typeof c.width == "number" && window.innerWidth < c.width ? window.innerWidth - 30 : c.width);
  const y = {
    bottom: 0,
    left: 0,
    overflow: "hidden",
    position: "absolute",
    right: 0,
    top: 0,
    zIndex: c.zIndex
  }, g = {
    beacon: {
      ...Kt,
      display: h ? "none" : "inline-block",
      height: c.beaconSize,
      position: "relative",
      width: c.beaconSize,
      zIndex: c.zIndex
    },
    beaconInner: {
      animation: "joyride-beacon-inner 1.2s infinite ease-in-out",
      backgroundColor: c.primaryColor,
      borderRadius: "50%",
      display: "block",
      height: "50%",
      left: "50%",
      opacity: 0.7,
      position: "absolute",
      top: "50%",
      transform: "translate(-50%, -50%)",
      width: "50%"
    },
    beaconOuter: {
      animation: "joyride-beacon-outer 1.2s infinite ease-in-out",
      backgroundColor: `rgba(${Ka(c.primaryColor).join(",")}, 0.2)`,
      border: `2px solid ${c.primaryColor}`,
      borderRadius: "50%",
      boxSizing: "border-box",
      display: "block",
      height: "100%",
      left: 0,
      opacity: 0.9,
      position: "absolute",
      top: 0,
      transformOrigin: "center",
      width: "100%"
    },
    tooltip: {
      backgroundColor: c.backgroundColor,
      borderRadius: 5,
      boxSizing: "border-box",
      color: c.textColor,
      fontSize: 16,
      maxWidth: "100%",
      padding: 15,
      position: "relative",
      width: m
    },
    tooltipContainer: {
      lineHeight: 1.4,
      textAlign: "center"
    },
    tooltipTitle: {
      fontSize: 18,
      margin: 0
    },
    tooltipContent: {
      padding: "20px 10px"
    },
    tooltipFooter: {
      alignItems: "center",
      display: "flex",
      justifyContent: "flex-end",
      marginTop: 15
    },
    tooltipFooterSpacer: {
      flex: 1
    },
    buttonNext: {
      ...Kt,
      backgroundColor: c.primaryColor,
      borderRadius: 4,
      color: "#fff"
    },
    buttonBack: {
      ...Kt,
      color: c.primaryColor,
      marginLeft: "auto",
      marginRight: 5
    },
    buttonClose: {
      ...Kt,
      color: c.textColor,
      height: 14,
      padding: 15,
      position: "absolute",
      right: 0,
      top: 0,
      width: 14
    },
    buttonSkip: {
      ...Kt,
      color: c.textColor,
      fontSize: 14
    },
    overlay: {
      ...y,
      backgroundColor: c.overlayColor,
      mixBlendMode: "hard-light"
    },
    overlayLegacy: {
      ...y
    },
    overlayLegacyCenter: {
      ...y,
      backgroundColor: c.overlayColor
    },
    spotlight: {
      ...fo,
      backgroundColor: "gray"
    },
    spotlightLegacy: {
      ...fo,
      boxShadow: `0 0 0 9999px ${c.overlayColor}, ${c.spotlightShadow}`
    },
    floaterStyles: {
      arrow: {
        color: (s = (i = (n = f == null ? void 0 : f.styles) == null ? void 0 : n.arrow) == null ? void 0 : i.color) != null ? s : c.arrowColor
      },
      options: {
        zIndex: c.zIndex + 100
      }
    },
    options: c
  };
  return $e(g, u);
}
function ol(e) {
  return Ja(
    e,
    "beaconComponent",
    "disableCloseOnEsc",
    "disableOverlay",
    "disableOverlayClose",
    "disableScrolling",
    "disableScrollParentFix",
    "floaterProps",
    "hideBackButton",
    "hideCloseButton",
    "locale",
    "showProgress",
    "showSkipButton",
    "spotlightClicks",
    "spotlightPadding",
    "styles",
    "tooltipComponent"
  );
}
function Pt(e, t) {
  var r, o, n, i, s, a;
  const l = t ?? {}, f = $e.all([el, ol(e), l], {
    isMergeableObject: k.plainObject
  }), u = nl(e, f), c = hr(
    ot(f.target),
    f.disableScrollParentFix
  ), h = $e.all([
    Qa,
    (r = e.floaterProps) != null ? r : {},
    (o = f.floaterProps) != null ? o : {}
  ]);
  return h.offset = f.offset, h.styles = $e((n = h.styles) != null ? n : {}, u.floaterStyles), h.offset += (s = (i = e.spotlightPadding) != null ? i : f.spotlightPadding) != null ? s : 0, f.placementBeacon && h.wrapperOptions && (h.wrapperOptions.placement = f.placementBeacon), c && h.options.preventOverflow && (h.options.preventOverflow.boundariesElement = "window"), {
    ...f,
    locale: $e.all([ai, (a = e.locale) != null ? a : {}, f.locale || {}]),
    floaterProps: h,
    styles: si(u, "floaterStyles")
  };
}
function li(e, t = !1) {
  return k.plainObject(e) ? e.target ? !0 : (pt({
    title: "validateStep",
    data: "target is missing from the step",
    warn: !0,
    debug: t
  }), !1) : (pt({
    title: "validateStep",
    data: "step must be an object",
    warn: !0,
    debug: t
  }), !1);
}
function po(e, t = !1) {
  return k.array(e) ? e.every((r) => li(r, t)) : (pt({
    title: "validateSteps",
    data: "steps must be an array",
    warn: !0,
    debug: t
  }), !1);
}
var ci = {
  action: "init",
  controlled: !1,
  index: 0,
  lifecycle: G.INIT,
  origin: null,
  size: 0,
  status: X.IDLE
}, ho = Xa(si(ci, "controlled", "size")), il = class {
  constructor(e) {
    L(this, "beaconPopper"), L(this, "tooltipPopper"), L(this, "data", /* @__PURE__ */ new Map()), L(this, "listener"), L(this, "store", /* @__PURE__ */ new Map()), L(this, "addListener", (n) => {
      this.listener = n;
    }), L(this, "setSteps", (n) => {
      const { size: i, status: s } = this.getState(), a = {
        size: n.length,
        status: s
      };
      this.data.set("steps", n), s === X.WAITING && !i && n.length && (a.status = X.RUNNING), this.setState(a);
    }), L(this, "getPopper", (n) => n === "beacon" ? this.beaconPopper : this.tooltipPopper), L(this, "setPopper", (n, i) => {
      n === "beacon" ? this.beaconPopper = i : this.tooltipPopper = i;
    }), L(this, "cleanupPoppers", () => {
      this.beaconPopper = null, this.tooltipPopper = null;
    }), L(this, "close", (n = null) => {
      const { index: i, status: s } = this.getState();
      s === X.RUNNING && this.setState({
        ...this.getNextState({ action: oe.CLOSE, index: i + 1, origin: n })
      });
    }), L(this, "go", (n) => {
      const { controlled: i, status: s } = this.getState();
      if (i || s !== X.RUNNING)
        return;
      const a = this.getSteps()[n];
      this.setState({
        ...this.getNextState({ action: oe.GO, index: n }),
        status: a ? s : X.FINISHED
      });
    }), L(this, "info", () => this.getState()), L(this, "next", () => {
      const { index: n, status: i } = this.getState();
      i === X.RUNNING && this.setState(this.getNextState({ action: oe.NEXT, index: n + 1 }));
    }), L(this, "open", () => {
      const { status: n } = this.getState();
      n === X.RUNNING && this.setState({
        ...this.getNextState({ action: oe.UPDATE, lifecycle: G.TOOLTIP })
      });
    }), L(this, "prev", () => {
      const { index: n, status: i } = this.getState();
      i === X.RUNNING && this.setState({
        ...this.getNextState({ action: oe.PREV, index: n - 1 })
      });
    }), L(this, "reset", (n = !1) => {
      const { controlled: i } = this.getState();
      i || this.setState({
        ...this.getNextState({ action: oe.RESET, index: 0 }),
        status: n ? X.RUNNING : X.READY
      });
    }), L(this, "skip", () => {
      const { status: n } = this.getState();
      n === X.RUNNING && this.setState({
        action: oe.SKIP,
        lifecycle: G.INIT,
        status: X.SKIPPED
      });
    }), L(this, "start", (n) => {
      const { index: i, size: s } = this.getState();
      this.setState({
        ...this.getNextState(
          {
            action: oe.START,
            index: k.number(n) ? n : i
          },
          !0
        ),
        status: s ? X.RUNNING : X.WAITING
      });
    }), L(this, "stop", (n = !1) => {
      const { index: i, status: s } = this.getState();
      [X.FINISHED, X.SKIPPED].includes(s) || this.setState({
        ...this.getNextState({ action: oe.STOP, index: i + (n ? 1 : 0) }),
        status: X.PAUSED
      });
    }), L(this, "update", (n) => {
      var i, s;
      if (!Va(n, ho))
        throw new Error(`State is not valid. Valid keys: ${ho.join(", ")}`);
      this.setState({
        ...this.getNextState(
          {
            ...this.getState(),
            ...n,
            action: (i = n.action) != null ? i : oe.UPDATE,
            origin: (s = n.origin) != null ? s : null
          },
          !0
        )
      });
    });
    const { continuous: t = !1, stepIndex: r, steps: o = [] } = e ?? {};
    this.setState(
      {
        action: oe.INIT,
        controlled: k.number(r),
        continuous: t,
        index: k.number(r) ? r : 0,
        lifecycle: G.INIT,
        origin: null,
        status: o.length ? X.READY : X.IDLE
      },
      !0
    ), this.beaconPopper = null, this.tooltipPopper = null, this.listener = null, this.setSteps(o);
  }
  getState() {
    return this.store.size ? {
      action: this.store.get("action") || "",
      controlled: this.store.get("controlled") || !1,
      index: parseInt(this.store.get("index"), 10),
      lifecycle: this.store.get("lifecycle") || "",
      origin: this.store.get("origin") || null,
      size: this.store.get("size") || 0,
      status: this.store.get("status") || ""
    } : { ...ci };
  }
  getNextState(e, t = !1) {
    var r, o, n, i, s;
    const { action: a, controlled: l, index: f, size: u, status: c } = this.getState(), h = k.number(e.index) ? e.index : f, m = l && !t ? f : Math.min(Math.max(h, 0), u);
    return {
      action: (r = e.action) != null ? r : a,
      controlled: l,
      index: m,
      lifecycle: (o = e.lifecycle) != null ? o : G.INIT,
      origin: (n = e.origin) != null ? n : null,
      size: (i = e.size) != null ? i : u,
      status: m === u ? X.FINISHED : (s = e.status) != null ? s : c
    };
  }
  getSteps() {
    const e = this.data.get("steps");
    return Array.isArray(e) ? e : [];
  }
  hasUpdatedState(e) {
    const t = JSON.stringify(e), r = JSON.stringify(this.getState());
    return t !== r;
  }
  setState(e, t = !1) {
    const r = this.getState(), {
      action: o,
      index: n,
      lifecycle: i,
      origin: s = null,
      size: a,
      status: l
    } = {
      ...r,
      ...e
    };
    this.store.set("action", o), this.store.set("index", n), this.store.set("lifecycle", i), this.store.set("origin", s), this.store.set("size", a), this.store.set("status", l), t && (this.store.set("controlled", e.controlled), this.store.set("continuous", e.continuous)), this.listener && this.hasUpdatedState(r) && this.listener(this.getState());
  }
  getHelpers() {
    return {
      close: this.close,
      go: this.go,
      info: this.info,
      next: this.next,
      open: this.open,
      prev: this.prev,
      reset: this.reset,
      skip: this.skip
    };
  }
};
function sl(e) {
  return new il(e);
}
function al({ styles: e }) {
  return /* @__PURE__ */ re.createElement(
    "div",
    {
      key: "JoyrideSpotlight",
      className: "react-joyride__spotlight",
      "data-test-id": "spotlight",
      style: e
    }
  );
}
var ll = al, cl = class extends re.Component {
  constructor() {
    super(...arguments), L(this, "isActive", !1), L(this, "resizeTimeout"), L(this, "scrollTimeout"), L(this, "scrollParent"), L(this, "state", {
      isScrolling: !1,
      mouseOverSpotlight: !1,
      showSpotlight: !0
    }), L(this, "hideSpotlight", () => {
      const { continuous: e, disableOverlay: t, lifecycle: r } = this.props, o = [
        G.INIT,
        G.BEACON,
        G.COMPLETE,
        G.ERROR
      ];
      return t || (e ? o.includes(r) : r !== G.TOOLTIP);
    }), L(this, "handleMouseMove", (e) => {
      const { mouseOverSpotlight: t } = this.state, { height: r, left: o, position: n, top: i, width: s } = this.spotlightStyles, a = n === "fixed" ? e.clientY : e.pageY, l = n === "fixed" ? e.clientX : e.pageX, f = a >= i && a <= i + r, c = l >= o && l <= o + s && f;
      c !== t && this.updateState({ mouseOverSpotlight: c });
    }), L(this, "handleScroll", () => {
      const { target: e } = this.props, t = ot(e);
      if (this.scrollParent !== document) {
        const { isScrolling: r } = this.state;
        r || this.updateState({ isScrolling: !0, showSpotlight: !1 }), clearTimeout(this.scrollTimeout), this.scrollTimeout = window.setTimeout(() => {
          this.updateState({ isScrolling: !1, showSpotlight: !0 });
        }, 50);
      } else It(t, "sticky") && this.updateState({});
    }), L(this, "handleResize", () => {
      clearTimeout(this.resizeTimeout), this.resizeTimeout = window.setTimeout(() => {
        this.isActive && this.forceUpdate();
      }, 100);
    });
  }
  componentDidMount() {
    const { debug: e, disableScrolling: t, disableScrollParentFix: r = !1, target: o } = this.props, n = ot(o);
    this.scrollParent = ir(n ?? document.body, r, !0), this.isActive = !0, process.env.NODE_ENV !== "production" && !t && hr(n, !0) && pt({
      title: "step has a custom scroll parent and can cause trouble with scrolling",
      data: [{ key: "parent", value: this.scrollParent }],
      debug: e
    }), window.addEventListener("resize", this.handleResize);
  }
  componentDidUpdate(e) {
    var t;
    const { disableScrollParentFix: r, lifecycle: o, spotlightClicks: n, target: i } = this.props, { changed: s } = kr(e, this.props);
    if (s("target") || s("disableScrollParentFix")) {
      const a = ot(i);
      this.scrollParent = ir(a ?? document.body, r, !0);
    }
    s("lifecycle", G.TOOLTIP) && ((t = this.scrollParent) == null || t.addEventListener("scroll", this.handleScroll, { passive: !0 }), setTimeout(() => {
      const { isScrolling: a } = this.state;
      a || this.updateState({ showSpotlight: !0 });
    }, 100)), (s("spotlightClicks") || s("disableOverlay") || s("lifecycle")) && (n && o === G.TOOLTIP ? window.addEventListener("mousemove", this.handleMouseMove, !1) : o !== G.TOOLTIP && window.removeEventListener("mousemove", this.handleMouseMove));
  }
  componentWillUnmount() {
    var e;
    this.isActive = !1, window.removeEventListener("mousemove", this.handleMouseMove), window.removeEventListener("resize", this.handleResize), clearTimeout(this.resizeTimeout), clearTimeout(this.scrollTimeout), (e = this.scrollParent) == null || e.removeEventListener("scroll", this.handleScroll);
  }
  get overlayStyles() {
    const { mouseOverSpotlight: e } = this.state, { disableOverlayClose: t, placement: r, styles: o } = this.props;
    let n = o.overlay;
    return uo() && (n = r === "center" ? o.overlayLegacyCenter : o.overlayLegacy), {
      cursor: t ? "default" : "pointer",
      height: Ba(),
      pointerEvents: e ? "none" : "auto",
      ...n
    };
  }
  get spotlightStyles() {
    var e, t, r;
    const { showSpotlight: o } = this.state, {
      disableScrollParentFix: n = !1,
      spotlightClicks: i,
      spotlightPadding: s = 0,
      styles: a,
      target: l
    } = this.props, f = ot(l), u = oi(f), c = It(f), h = Ga(f, s, n);
    return {
      ...uo() ? a.spotlightLegacy : a.spotlight,
      height: Math.round(((e = u == null ? void 0 : u.height) != null ? e : 0) + s * 2),
      left: Math.round(((t = u == null ? void 0 : u.left) != null ? t : 0) - s),
      opacity: o ? 1 : 0,
      pointerEvents: i ? "none" : "auto",
      position: c ? "fixed" : "absolute",
      top: h,
      transition: "opacity 0.2s",
      width: Math.round(((r = u == null ? void 0 : u.width) != null ? r : 0) + s * 2)
    };
  }
  updateState(e) {
    this.isActive && this.setState((t) => ({ ...t, ...e }));
  }
  render() {
    const { showSpotlight: e } = this.state, { onClickOverlay: t, placement: r } = this.props, { hideSpotlight: o, overlayStyles: n, spotlightStyles: i } = this;
    if (o())
      return null;
    let s = r !== "center" && e && /* @__PURE__ */ re.createElement(ll, { styles: i });
    if (ii() === "safari") {
      const { mixBlendMode: a, zIndex: l, ...f } = n;
      s = /* @__PURE__ */ re.createElement("div", { style: { ...f } }, s), delete n.backgroundColor;
    }
    return /* @__PURE__ */ re.createElement(
      "div",
      {
        className: "react-joyride__overlay",
        "data-test-id": "overlay",
        onClick: t,
        role: "presentation",
        style: n
      },
      s
    );
  }
}, ul = class extends re.Component {
  constructor() {
    super(...arguments), L(this, "node", null);
  }
  componentDidMount() {
    const { id: e } = this.props;
    ut() && (this.node = document.createElement("div"), this.node.id = e, document.body.appendChild(this.node), Vt || this.renderReact15());
  }
  componentDidUpdate() {
    ut() && (Vt || this.renderReact15());
  }
  componentWillUnmount() {
    !ut() || !this.node || (Vt || Br.unmountComponentAtNode(this.node), this.node.parentNode === document.body && (document.body.removeChild(this.node), this.node = null));
  }
  renderReact15() {
    if (!ut())
      return;
    const { children: e } = this.props;
    this.node && Br.unstable_renderSubtreeIntoContainer(this, e, this.node);
  }
  renderReact16() {
    if (!ut() || !Vt)
      return null;
    const { children: e } = this.props;
    return this.node ? Br.createPortal(e, this.node) : null;
  }
  render() {
    return Vt ? this.renderReact16() : null;
  }
}, fl = class {
  constructor(e, t) {
    if (L(this, "element"), L(this, "options"), L(this, "canBeTabbed", (r) => {
      const { tabIndex: o } = r;
      return o === null || o < 0 ? !1 : this.canHaveFocus(r);
    }), L(this, "canHaveFocus", (r) => {
      const o = /input|select|textarea|button|object/, n = r.nodeName.toLowerCase();
      return (o.test(n) && !r.getAttribute("disabled") || n === "a" && !!r.getAttribute("href")) && this.isVisible(r);
    }), L(this, "findValidTabElements", () => [].slice.call(this.element.querySelectorAll("*"), 0).filter(this.canBeTabbed)), L(this, "handleKeyDown", (r) => {
      const { code: o = "Tab" } = this.options;
      r.code === o && this.interceptTab(r);
    }), L(this, "interceptTab", (r) => {
      r.preventDefault();
      const o = this.findValidTabElements(), { shiftKey: n } = r;
      if (!o.length)
        return;
      let i = document.activeElement ? o.indexOf(document.activeElement) : 0;
      i === -1 || !n && i + 1 === o.length ? i = 0 : n && i === 0 ? i = o.length - 1 : i += n ? -1 : 1, o[i].focus();
    }), L(this, "isHidden", (r) => {
      const o = r.offsetWidth <= 0 && r.offsetHeight <= 0, n = window.getComputedStyle(r);
      return o && !r.innerHTML ? !0 : o && n.getPropertyValue("overflow") !== "visible" || n.getPropertyValue("display") === "none";
    }), L(this, "isVisible", (r) => {
      let o = r;
      for (; o; )
        if (o instanceof HTMLElement) {
          if (o === document.body)
            break;
          if (this.isHidden(o))
            return !1;
          o = o.parentNode;
        }
      return !0;
    }), L(this, "removeScope", () => {
      window.removeEventListener("keydown", this.handleKeyDown);
    }), L(this, "checkFocus", (r) => {
      document.activeElement !== r && (r.focus(), window.requestAnimationFrame(() => this.checkFocus(r)));
    }), L(this, "setFocus", () => {
      const { selector: r } = this.options;
      if (!r)
        return;
      const o = this.element.querySelector(r);
      o && window.requestAnimationFrame(() => this.checkFocus(o));
    }), !(e instanceof HTMLElement))
      throw new TypeError("Invalid parameter: element must be an HTMLElement");
    this.element = e, this.options = t, window.addEventListener("keydown", this.handleKeyDown, !1), this.setFocus();
  }
}, pl = class extends re.Component {
  constructor(e) {
    if (super(e), L(this, "beacon", null), L(this, "setBeaconRef", (n) => {
      this.beacon = n;
    }), e.beaconComponent)
      return;
    const t = document.head || document.getElementsByTagName("head")[0], r = document.createElement("style");
    r.id = "joyride-beacon-animation", e.nonce && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode(`
        @keyframes joyride-beacon-inner {
          20% {
            opacity: 0.9;
          }
        
          90% {
            opacity: 0.7;
          }
        }
        
        @keyframes joyride-beacon-outer {
          0% {
            transform: scale(1);
          }
        
          45% {
            opacity: 0.7;
            transform: scale(0.75);
          }
        
          100% {
            opacity: 0.9;
            transform: scale(1);
          }
        }
      `)), t.appendChild(r);
  }
  componentDidMount() {
    const { shouldFocus: e } = this.props;
    process.env.NODE_ENV !== "production" && (k.domElement(this.beacon) || console.warn("beacon is not a valid DOM element")), setTimeout(() => {
      k.domElement(this.beacon) && e && this.beacon.focus();
    }, 0);
  }
  componentWillUnmount() {
    const e = document.getElementById("joyride-beacon-animation");
    e != null && e.parentNode && e.parentNode.removeChild(e);
  }
  render() {
    const {
      beaconComponent: e,
      continuous: t,
      index: r,
      isLastStep: o,
      locale: n,
      onClickOrHover: i,
      size: s,
      step: a,
      styles: l
    } = this.props, f = qe(n.open), u = {
      "aria-label": f,
      onClick: i,
      onMouseEnter: i,
      ref: this.setBeaconRef,
      title: f
    };
    let c;
    if (e) {
      const h = e;
      c = /* @__PURE__ */ re.createElement(
        h,
        {
          continuous: t,
          index: r,
          isLastStep: o,
          size: s,
          step: a,
          ...u
        }
      );
    } else
      c = /* @__PURE__ */ re.createElement(
        "button",
        {
          key: "JoyrideBeacon",
          className: "react-joyride__beacon",
          "data-test-id": "button-beacon",
          style: l.beacon,
          type: "button",
          ...u
        },
        /* @__PURE__ */ re.createElement("span", { style: l.beaconInner }),
        /* @__PURE__ */ re.createElement("span", { style: l.beaconOuter })
      );
    return c;
  }
};
function dl({ styles: e, ...t }) {
  const { color: r, height: o, width: n, ...i } = e;
  return /* @__PURE__ */ z.createElement("button", { style: i, type: "button", ...t }, /* @__PURE__ */ z.createElement(
    "svg",
    {
      height: typeof o == "number" ? `${o}px` : o,
      preserveAspectRatio: "xMidYMid",
      version: "1.1",
      viewBox: "0 0 18 18",
      width: typeof n == "number" ? `${n}px` : n,
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ z.createElement("g", null, /* @__PURE__ */ z.createElement(
      "path",
      {
        d: "M8.13911129,9.00268191 L0.171521827,17.0258467 C-0.0498027049,17.248715 -0.0498027049,17.6098394 0.171521827,17.8327545 C0.28204354,17.9443526 0.427188206,17.9998706 0.572051765,17.9998706 C0.71714958,17.9998706 0.862013139,17.9443526 0.972581703,17.8327545 L9.0000937,9.74924618 L17.0276057,17.8327545 C17.1384085,17.9443526 17.2832721,17.9998706 17.4281356,17.9998706 C17.5729992,17.9998706 17.718097,17.9443526 17.8286656,17.8327545 C18.0499901,17.6098862 18.0499901,17.2487618 17.8286656,17.0258467 L9.86135722,9.00268191 L17.8340066,0.973848225 C18.0553311,0.750979934 18.0553311,0.389855532 17.8340066,0.16694039 C17.6126821,-0.0556467968 17.254037,-0.0556467968 17.0329467,0.16694039 L9.00042166,8.25611765 L0.967006424,0.167268345 C0.745681892,-0.0553188426 0.387317931,-0.0553188426 0.165993399,0.167268345 C-0.0553311331,0.390136635 -0.0553311331,0.751261038 0.165993399,0.974176179 L8.13920499,9.00268191 L8.13911129,9.00268191 Z",
        fill: r
      }
    ))
  ));
}
var hl = dl;
function ml(e) {
  const { backProps: t, closeProps: r, index: o, isLastStep: n, primaryProps: i, skipProps: s, step: a, tooltipProps: l } = e, { content: f, hideBackButton: u, hideCloseButton: c, hideFooter: h, showSkipButton: m, styles: y, title: g } = a, _ = {};
  return _.primary = /* @__PURE__ */ re.createElement(
    "button",
    {
      "data-test-id": "button-primary",
      style: y.buttonNext,
      type: "button",
      ...i
    }
  ), m && !n && (_.skip = /* @__PURE__ */ re.createElement(
    "button",
    {
      "aria-live": "off",
      "data-test-id": "button-skip",
      style: y.buttonSkip,
      type: "button",
      ...s
    }
  )), !u && o > 0 && (_.back = /* @__PURE__ */ re.createElement("button", { "data-test-id": "button-back", style: y.buttonBack, type: "button", ...t })), _.close = !c && /* @__PURE__ */ re.createElement(hl, { "data-test-id": "button-close", styles: y.buttonClose, ...r }), /* @__PURE__ */ re.createElement(
    "div",
    {
      key: "JoyrideTooltip",
      "aria-label": qe(g ?? f),
      className: "react-joyride__tooltip",
      style: y.tooltip,
      ...l
    },
    /* @__PURE__ */ re.createElement("div", { style: y.tooltipContainer }, g && /* @__PURE__ */ re.createElement("h1", { "aria-label": qe(g), style: y.tooltipTitle }, g), /* @__PURE__ */ re.createElement("div", { style: y.tooltipContent }, f)),
    !h && /* @__PURE__ */ re.createElement("div", { style: y.tooltipFooter }, /* @__PURE__ */ re.createElement("div", { style: y.tooltipFooterSpacer }, _.skip), _.back, _.primary),
    _.close
  );
}
var yl = ml, gl = class extends re.Component {
  constructor() {
    super(...arguments), L(this, "handleClickBack", (e) => {
      e.preventDefault();
      const { helpers: t } = this.props;
      t.prev();
    }), L(this, "handleClickClose", (e) => {
      e.preventDefault();
      const { helpers: t } = this.props;
      t.close("button_close");
    }), L(this, "handleClickPrimary", (e) => {
      e.preventDefault();
      const { continuous: t, helpers: r } = this.props;
      if (!t) {
        r.close("button_primary");
        return;
      }
      r.next();
    }), L(this, "handleClickSkip", (e) => {
      e.preventDefault();
      const { helpers: t } = this.props;
      t.skip();
    }), L(this, "getElementsProps", () => {
      const { continuous: e, index: t, isLastStep: r, setTooltipRef: o, size: n, step: i } = this.props, { back: s, close: a, last: l, next: f, nextLabelWithProgress: u, skip: c } = i.locale, h = qe(s), m = qe(a), y = qe(l), g = qe(f), _ = qe(c);
      let x = a, E = m;
      if (e) {
        if (x = f, E = g, i.showProgress && !r) {
          const F = qe(u, {
            step: t + 1,
            steps: n
          });
          x = fn(u, t + 1, n), E = F;
        }
        r && (x = l, E = y);
      }
      return {
        backProps: {
          "aria-label": h,
          children: s,
          "data-action": "back",
          onClick: this.handleClickBack,
          role: "button",
          title: h
        },
        closeProps: {
          "aria-label": m,
          children: a,
          "data-action": "close",
          onClick: this.handleClickClose,
          role: "button",
          title: m
        },
        primaryProps: {
          "aria-label": E,
          children: x,
          "data-action": "primary",
          onClick: this.handleClickPrimary,
          role: "button",
          title: E
        },
        skipProps: {
          "aria-label": _,
          children: c,
          "data-action": "skip",
          onClick: this.handleClickSkip,
          role: "button",
          title: _
        },
        tooltipProps: {
          "aria-modal": !0,
          ref: o,
          role: "alertdialog"
        }
      };
    });
  }
  render() {
    const { continuous: e, index: t, isLastStep: r, setTooltipRef: o, size: n, step: i } = this.props, { beaconComponent: s, tooltipComponent: a, ...l } = i;
    let f;
    if (a) {
      const u = {
        ...this.getElementsProps(),
        continuous: e,
        index: t,
        isLastStep: r,
        size: n,
        step: l,
        setTooltipRef: o
      }, c = a;
      f = /* @__PURE__ */ re.createElement(c, { ...u });
    } else
      f = /* @__PURE__ */ re.createElement(
        yl,
        {
          ...this.getElementsProps(),
          continuous: e,
          index: t,
          isLastStep: r,
          size: n,
          step: i
        }
      );
    return f;
  }
}, vl = class extends re.Component {
  constructor() {
    super(...arguments), L(this, "scope", null), L(this, "tooltip", null), L(this, "handleClickHoverBeacon", (e) => {
      const { step: t, store: r } = this.props;
      e.type === "mouseenter" && t.event !== "hover" || r.update({ lifecycle: G.TOOLTIP });
    }), L(this, "setTooltipRef", (e) => {
      this.tooltip = e;
    }), L(this, "setPopper", (e, t) => {
      var r;
      const { action: o, lifecycle: n, step: i, store: s } = this.props;
      t === "wrapper" ? s.setPopper("beacon", e) : s.setPopper("tooltip", e), s.getPopper("beacon") && (s.getPopper("tooltip") || i.placement === "center") && n === G.INIT && s.update({
        action: o,
        lifecycle: G.READY
      }), (r = i.floaterProps) != null && r.getPopper && i.floaterProps.getPopper(e, t);
    }), L(this, "renderTooltip", (e) => {
      const { continuous: t, helpers: r, index: o, size: n, step: i } = this.props;
      return /* @__PURE__ */ re.createElement(
        gl,
        {
          continuous: t,
          helpers: r,
          index: o,
          isLastStep: o + 1 === n,
          setTooltipRef: this.setTooltipRef,
          size: n,
          step: i,
          ...e
        }
      );
    });
  }
  componentDidMount() {
    const { debug: e, index: t } = this.props;
    pt({
      title: `step:${t}`,
      data: [{ key: "props", value: this.props }],
      debug: e
    });
  }
  componentDidUpdate(e) {
    var t;
    const {
      action: r,
      callback: o,
      continuous: n,
      controlled: i,
      debug: s,
      helpers: a,
      index: l,
      lifecycle: f,
      shouldScroll: u,
      status: c,
      step: h,
      store: m
    } = this.props, { changed: y, changedFrom: g } = kr(e, this.props), _ = a.info(), x = n && r !== oe.CLOSE && (l > 0 || r === oe.PREV), E = y("action") || y("index") || y("lifecycle") || y("status"), F = g("lifecycle", [G.TOOLTIP, G.INIT], G.INIT), M = y("action", [
      oe.NEXT,
      oe.PREV,
      oe.SKIP,
      oe.CLOSE
    ]), O = i && l === e.index;
    if (M && (F || O) && o({
      ..._,
      index: e.index,
      lifecycle: G.COMPLETE,
      step: e.step,
      type: ke.STEP_AFTER
    }), h.placement === "center" && c === X.RUNNING && y("index") && r !== oe.START && f === G.INIT && m.update({ lifecycle: G.READY }), E) {
      const W = ot(h.target), q = !!W;
      q && za(W) ? (g("status", X.READY, X.RUNNING) || g("lifecycle", G.INIT, G.READY)) && o({
        ..._,
        step: h,
        type: ke.STEP_BEFORE
      }) : (console.warn(q ? "Target not visible" : "Target not mounted", h), o({
        ..._,
        type: ke.TARGET_NOT_FOUND,
        step: h
      }), i || m.update({ index: l + (r === oe.PREV ? -1 : 1) }));
    }
    g("lifecycle", G.INIT, G.READY) && m.update({
      lifecycle: co(h) || x ? G.TOOLTIP : G.BEACON
    }), y("index") && pt({
      title: `step:${f}`,
      data: [{ key: "props", value: this.props }],
      debug: s
    }), y("lifecycle", G.BEACON) && o({
      ..._,
      step: h,
      type: ke.BEACON
    }), y("lifecycle", G.TOOLTIP) && (o({
      ..._,
      step: h,
      type: ke.TOOLTIP
    }), u && this.tooltip && (this.scope = new fl(this.tooltip, { selector: "[data-action=primary]" }), this.scope.setFocus())), g("lifecycle", [G.TOOLTIP, G.INIT], G.INIT) && ((t = this.scope) == null || t.removeScope(), m.cleanupPoppers());
  }
  componentWillUnmount() {
    var e;
    (e = this.scope) == null || e.removeScope();
  }
  get open() {
    const { lifecycle: e, step: t } = this.props;
    return co(t) || e === G.TOOLTIP;
  }
  render() {
    const { continuous: e, debug: t, index: r, nonce: o, shouldScroll: n, size: i, step: s } = this.props, a = ot(s.target);
    return !li(s) || !k.domElement(a) ? null : /* @__PURE__ */ re.createElement("div", { key: `JoyrideStep-${r}`, className: "react-joyride__step" }, /* @__PURE__ */ re.createElement(
      On,
      {
        ...s.floaterProps,
        component: this.renderTooltip,
        debug: t,
        getPopper: this.setPopper,
        id: `react-joyride-step-${r}`,
        open: this.open,
        placement: s.placement,
        target: s.target
      },
      /* @__PURE__ */ re.createElement(
        pl,
        {
          beaconComponent: s.beaconComponent,
          continuous: e,
          index: r,
          isLastStep: r + 1 === i,
          locale: s.locale,
          nonce: o,
          onClickOrHover: this.handleClickHoverBeacon,
          shouldFocus: n,
          size: i,
          step: s,
          styles: s.styles
        }
      )
    ));
  }
}, ui = class extends re.Component {
  constructor(e) {
    super(e), L(this, "helpers"), L(this, "store"), L(this, "callback", (s) => {
      const { callback: a } = this.props;
      k.function(a) && a(s);
    }), L(this, "handleKeyboard", (s) => {
      const { index: a, lifecycle: l } = this.state, { steps: f } = this.props, u = f[a];
      l === G.TOOLTIP && s.code === "Escape" && u && !u.disableCloseOnEsc && this.store.close("keyboard");
    }), L(this, "handleClickOverlay", () => {
      const { index: s } = this.state, { steps: a } = this.props;
      Pt(this.props, a[s]).disableOverlayClose || this.helpers.close("overlay");
    }), L(this, "syncState", (s) => {
      this.setState(s);
    });
    const { debug: t, getHelpers: r, run: o = !0, stepIndex: n } = e;
    this.store = sl({
      ...e,
      controlled: o && k.number(n)
    }), this.helpers = this.store.getHelpers();
    const { addListener: i } = this.store;
    pt({
      title: "init",
      data: [
        { key: "props", value: this.props },
        { key: "state", value: this.state }
      ],
      debug: t
    }), i(this.syncState), r && r(this.helpers), this.state = this.store.getState();
  }
  componentDidMount() {
    if (!ut())
      return;
    const { debug: e, disableCloseOnEsc: t, run: r, steps: o } = this.props, { start: n } = this.store;
    po(o, e) && r && n(), t || document.body.addEventListener("keydown", this.handleKeyboard, { passive: !0 });
  }
  componentDidUpdate(e, t) {
    if (!ut())
      return;
    const { action: r, controlled: o, index: n, status: i } = this.state, { debug: s, run: a, stepIndex: l, steps: f } = this.props, { stepIndex: u, steps: c } = e, { reset: h, setSteps: m, start: y, stop: g, update: _ } = this.store, { changed: x } = kr(e, this.props), { changed: E, changedFrom: F } = kr(t, this.state), M = Pt(this.props, f[n]), O = !Pe(c, f), W = k.number(l) && x("stepIndex"), q = ot(M.target);
    if (O && (po(f, s) ? m(f) : console.warn("Steps are not valid", f)), x("run") && (a ? y(l) : g()), W) {
      let he = k.number(u) && u < l ? oe.NEXT : oe.PREV;
      r === oe.STOP && (he = oe.START), [X.FINISHED, X.SKIPPED].includes(i) || _({
        action: r === oe.CLOSE ? oe.CLOSE : he,
        index: l,
        lifecycle: G.INIT
      });
    }
    !o && i === X.RUNNING && n === 0 && !q && (this.store.update({ index: n + 1 }), this.callback({
      ...this.state,
      type: ke.TARGET_NOT_FOUND,
      step: M
    }));
    const ve = {
      ...this.state,
      index: n,
      step: M
    };
    if (E("action", [
      oe.NEXT,
      oe.PREV,
      oe.SKIP,
      oe.CLOSE
    ]) && E("status", X.PAUSED)) {
      const he = Pt(this.props, f[t.index]);
      this.callback({
        ...ve,
        index: t.index,
        lifecycle: G.COMPLETE,
        step: he,
        type: ke.STEP_AFTER
      });
    }
    if (E("status", [X.FINISHED, X.SKIPPED])) {
      const he = Pt(this.props, f[t.index]);
      o || this.callback({
        ...ve,
        index: t.index,
        lifecycle: G.COMPLETE,
        step: he,
        type: ke.STEP_AFTER
      }), this.callback({
        ...ve,
        type: ke.TOUR_END,
        // Return the last step when the tour is finished
        step: he,
        index: t.index
      }), h();
    } else F("status", [X.IDLE, X.READY], X.RUNNING) ? this.callback({
      ...ve,
      type: ke.TOUR_START
    }) : (E("status") || E("action", oe.RESET)) && this.callback({
      ...ve,
      type: ke.TOUR_STATUS
    });
    this.scrollToStep(t);
  }
  componentWillUnmount() {
    const { disableCloseOnEsc: e } = this.props;
    e || document.body.removeEventListener("keydown", this.handleKeyboard);
  }
  scrollToStep(e) {
    const { index: t, lifecycle: r, status: o } = this.state, {
      debug: n,
      disableScrollParentFix: i = !1,
      scrollDuration: s,
      scrollOffset: a = 20,
      scrollToFirstStep: l = !1,
      steps: f
    } = this.props, u = Pt(this.props, f[t]), c = ot(u.target), h = Za({
      isFirstStep: t === 0,
      lifecycle: r,
      previousLifecycle: e.lifecycle,
      scrollToFirstStep: l,
      step: u,
      target: c
    });
    if (o === X.RUNNING && h) {
      const m = hr(c, i), y = ir(c, i);
      let g = Math.floor(Ya(c, a, i)) || 0;
      pt({
        title: "scrollToStep",
        data: [
          { key: "index", value: t },
          { key: "lifecycle", value: r },
          { key: "status", value: o }
        ],
        debug: n
      });
      const _ = this.store.getPopper("beacon"), x = this.store.getPopper("tooltip");
      if (r === G.BEACON && _) {
        const { offsets: E, placement: F } = _;
        !["bottom"].includes(F) && !m && (g = Math.floor(E.popper.top - a));
      } else if (r === G.TOOLTIP && x) {
        const { flipped: E, offsets: F, placement: M } = x;
        ["top", "right", "left"].includes(M) && !E && !m ? g = Math.floor(F.popper.top - a) : g -= u.spotlightPadding;
      }
      g = g >= 0 ? g : 0, o === X.RUNNING && qa(g, { element: y, duration: s }).then(
        () => {
          setTimeout(() => {
            var E;
            (E = this.store.getPopper("tooltip")) == null || E.instance.update();
          }, 10);
        }
      );
    }
  }
  render() {
    if (!ut())
      return null;
    const { index: e, lifecycle: t, status: r } = this.state, {
      continuous: o = !1,
      debug: n = !1,
      nonce: i,
      scrollToFirstStep: s = !1,
      steps: a
    } = this.props, l = r === X.RUNNING, f = {};
    if (l && a[e]) {
      const u = Pt(this.props, a[e]);
      f.step = /* @__PURE__ */ re.createElement(
        vl,
        {
          ...this.state,
          callback: this.callback,
          continuous: o,
          debug: n,
          helpers: this.helpers,
          nonce: i,
          shouldScroll: !u.disableScrolling && (e !== 0 || s),
          step: u,
          store: this.store
        }
      ), f.overlay = /* @__PURE__ */ re.createElement(ul, { id: "react-joyride-portal" }, /* @__PURE__ */ re.createElement(
        cl,
        {
          ...u,
          continuous: o,
          debug: n,
          lifecycle: t,
          onClickOverlay: this.handleClickOverlay
        }
      ));
    }
    return /* @__PURE__ */ re.createElement("div", { className: "react-joyride" }, f.step, f.overlay);
  }
};
L(ui, "defaultProps", tl);
var fi = ui;
function bl(e) {
  switch (e) {
    case "integration-internal":
      return "https://api-protected-internal-domain.internal.integration.smp-paas.com/feedback/tours";
    case "preproduction-internal":
      return "https://api-protected-internal.internal.preproduction.smp-paas.com/feedback/tours";
    case "production-internal":
      return "https://api-internal.internal.production.smp-paas.com/feedback/tours";
    default:
      return `https://api-private.${e}.smp-paas.com/feedback/tours`;
  }
}
const El = async (e, t) => {
  const r = {
    method: "GET",
    headers: {
      Authorization: `${e.accessToken}`,
      "x-api-key": `${e.apiKey}`,
      psid: `${e.psid}`,
      "Content-Type": "application/json"
    },
    signal: t
  };
  return await (await fetch(
    `${bl(e.environment)}/${e.tourId}`,
    r
  )).json();
};
/*! @license DOMPurify 3.2.1 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.1/LICENSE */
const {
  entries: pi,
  setPrototypeOf: mo,
  isFrozen: Tl,
  getPrototypeOf: Ol,
  getOwnPropertyDescriptor: wl
} = Object;
let {
  freeze: Ce,
  seal: je,
  create: di
} = Object, {
  apply: pn,
  construct: dn
} = typeof Reflect < "u" && Reflect;
Ce || (Ce = function(t) {
  return t;
});
je || (je = function(t) {
  return t;
});
pn || (pn = function(t, r, o) {
  return t.apply(r, o);
});
dn || (dn = function(t, r) {
  return new t(...r);
});
const Pr = Le(Array.prototype.forEach), yo = Le(Array.prototype.pop), Xt = Le(Array.prototype.push), Ir = Le(String.prototype.toLowerCase), Jr = Le(String.prototype.toString), go = Le(String.prototype.match), Jt = Le(String.prototype.replace), Sl = Le(String.prototype.indexOf), _l = Le(String.prototype.trim), Be = Le(Object.prototype.hasOwnProperty), Re = Le(RegExp.prototype.test), Zt = Rl(TypeError);
function Le(e) {
  return function(t) {
    for (var r = arguments.length, o = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++)
      o[n - 1] = arguments[n];
    return pn(e, t, o);
  };
}
function Rl(e) {
  return function() {
    for (var t = arguments.length, r = new Array(t), o = 0; o < t; o++)
      r[o] = arguments[o];
    return dn(e, r);
  };
}
function Q(e, t) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Ir;
  mo && mo(e, null);
  let o = t.length;
  for (; o--; ) {
    let n = t[o];
    if (typeof n == "string") {
      const i = r(n);
      i !== n && (Tl(t) || (t[o] = i), n = i);
    }
    e[n] = !0;
  }
  return e;
}
function Pl(e) {
  for (let t = 0; t < e.length; t++)
    Be(e, t) || (e[t] = null);
  return e;
}
function gt(e) {
  const t = di(null);
  for (const [r, o] of pi(e))
    Be(e, r) && (Array.isArray(o) ? t[r] = Pl(o) : o && typeof o == "object" && o.constructor === Object ? t[r] = gt(o) : t[r] = o);
  return t;
}
function Qt(e, t) {
  for (; e !== null; ) {
    const o = wl(e, t);
    if (o) {
      if (o.get)
        return Le(o.get);
      if (typeof o.value == "function")
        return Le(o.value);
    }
    e = Ol(e);
  }
  function r() {
    return null;
  }
  return r;
}
const vo = Ce(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), Zr = Ce(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), Qr = Ce(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), Cl = Ce(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), en = Ce(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), xl = Ce(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), bo = Ce(["#text"]), Eo = Ce(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), tn = Ce(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), To = Ce(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), Cr = Ce(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), Al = je(/\{\{[\w\W]*|[\w\W]*\}\}/gm), Nl = je(/<%[\w\W]*|[\w\W]*%>/gm), Il = je(/\${[\w\W]*}/gm), kl = je(/^data-[\-\w.\u00B7-\uFFFF]/), Ll = je(/^aria-[\-\w]+$/), hi = je(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), Ml = je(/^(?:\w+script|data):/i), Dl = je(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), mi = je(/^html$/i), jl = je(/^[a-z][.\w]*(-[.\w]+)+$/i);
var Oo = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: Ll,
  ATTR_WHITESPACE: Dl,
  CUSTOM_ELEMENT: jl,
  DATA_ATTR: kl,
  DOCTYPE_NAME: mi,
  ERB_EXPR: Nl,
  IS_ALLOWED_URI: hi,
  IS_SCRIPT_OR_DATA: Ml,
  MUSTACHE_EXPR: Al,
  TMPLIT_EXPR: Il
});
const er = {
  element: 1,
  attribute: 2,
  text: 3,
  cdataSection: 4,
  entityReference: 5,
  // Deprecated
  entityNode: 6,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9,
  documentType: 10,
  documentFragment: 11,
  notation: 12
  // Deprecated
}, Fl = function() {
  return typeof window > "u" ? null : window;
}, Wl = function(t, r) {
  if (typeof t != "object" || typeof t.createPolicy != "function")
    return null;
  let o = null;
  const n = "data-tt-policy-suffix";
  r && r.hasAttribute(n) && (o = r.getAttribute(n));
  const i = "dompurify" + (o ? "#" + o : "");
  try {
    return t.createPolicy(i, {
      createHTML(s) {
        return s;
      },
      createScriptURL(s) {
        return s;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + i + " could not be created."), null;
  }
};
function yi() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Fl();
  const t = (w) => yi(w);
  if (t.version = "3.2.1", t.removed = [], !e || !e.document || e.document.nodeType !== er.document)
    return t.isSupported = !1, t;
  let {
    document: r
  } = e;
  const o = r, n = o.currentScript, {
    DocumentFragment: i,
    HTMLTemplateElement: s,
    Node: a,
    Element: l,
    NodeFilter: f,
    NamedNodeMap: u = e.NamedNodeMap || e.MozNamedAttrMap,
    HTMLFormElement: c,
    DOMParser: h,
    trustedTypes: m
  } = e, y = l.prototype, g = Qt(y, "cloneNode"), _ = Qt(y, "remove"), x = Qt(y, "nextSibling"), E = Qt(y, "childNodes"), F = Qt(y, "parentNode");
  if (typeof s == "function") {
    const w = r.createElement("template");
    w.content && w.content.ownerDocument && (r = w.content.ownerDocument);
  }
  let M, O = "";
  const {
    implementation: W,
    createNodeIterator: q,
    createDocumentFragment: ve,
    getElementsByTagName: Se
  } = r, {
    importNode: he
  } = o;
  let pe = {};
  t.isSupported = typeof pi == "function" && typeof F == "function" && W && W.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: Ee,
    ERB_EXPR: me,
    TMPLIT_EXPR: be,
    DATA_ATTR: Fe,
    ARIA_ATTR: _e,
    IS_SCRIPT_OR_DATA: Me,
    ATTR_WHITESPACE: Ge,
    CUSTOM_ELEMENT: it
  } = Oo;
  let {
    IS_ALLOWED_URI: S
  } = Oo, P = null;
  const Y = Q({}, [...vo, ...Zr, ...Qr, ...en, ...bo]);
  let D = null;
  const $ = Q({}, [...Eo, ...tn, ...To, ...Cr]);
  let j = Object.seal(di(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), B = null, H = null, V = !0, J = !0, K = !1, ge = !0, A = !1, Oe = !0, xe = !1, We = !1, Xe = !1, Je = !1, dt = !1, Ze = !1, mr = !0, yr = !1;
  const Dt = "user-content-";
  let jt = !0, ht = !1, Qe = {}, et = null;
  const st = Q({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let gr = null;
  const Ft = Q({}, ["audio", "video", "img", "source", "image", "track"]);
  let Et = null;
  const Tt = Q({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), Ot = "http://www.w3.org/1998/Math/MathML", wt = "http://www.w3.org/2000/svg", Ue = "http://www.w3.org/1999/xhtml";
  let at = Ue, Wt = !1, Ut = null;
  const Wr = Q({}, [Ot, wt, Ue], Jr);
  let lt = Q({}, ["mi", "mo", "mn", "ms", "mtext"]), mt = Q({}, ["annotation-xml"]);
  const ct = Q({}, ["title", "style", "font", "a", "script"]);
  let tt = null;
  const Bt = ["application/xhtml+xml", "text/html"], vr = "text/html";
  let ye = null, rt = null;
  const Ur = r.createElement("form"), $t = function(d) {
    return d instanceof RegExp || d instanceof Function;
  }, St = function() {
    let d = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(rt && rt === d)) {
      if ((!d || typeof d != "object") && (d = {}), d = gt(d), tt = // eslint-disable-next-line unicorn/prefer-includes
      Bt.indexOf(d.PARSER_MEDIA_TYPE) === -1 ? vr : d.PARSER_MEDIA_TYPE, ye = tt === "application/xhtml+xml" ? Jr : Ir, P = Be(d, "ALLOWED_TAGS") ? Q({}, d.ALLOWED_TAGS, ye) : Y, D = Be(d, "ALLOWED_ATTR") ? Q({}, d.ALLOWED_ATTR, ye) : $, Ut = Be(d, "ALLOWED_NAMESPACES") ? Q({}, d.ALLOWED_NAMESPACES, Jr) : Wr, Et = Be(d, "ADD_URI_SAFE_ATTR") ? Q(gt(Tt), d.ADD_URI_SAFE_ATTR, ye) : Tt, gr = Be(d, "ADD_DATA_URI_TAGS") ? Q(gt(Ft), d.ADD_DATA_URI_TAGS, ye) : Ft, et = Be(d, "FORBID_CONTENTS") ? Q({}, d.FORBID_CONTENTS, ye) : st, B = Be(d, "FORBID_TAGS") ? Q({}, d.FORBID_TAGS, ye) : {}, H = Be(d, "FORBID_ATTR") ? Q({}, d.FORBID_ATTR, ye) : {}, Qe = Be(d, "USE_PROFILES") ? d.USE_PROFILES : !1, V = d.ALLOW_ARIA_ATTR !== !1, J = d.ALLOW_DATA_ATTR !== !1, K = d.ALLOW_UNKNOWN_PROTOCOLS || !1, ge = d.ALLOW_SELF_CLOSE_IN_ATTR !== !1, A = d.SAFE_FOR_TEMPLATES || !1, Oe = d.SAFE_FOR_XML !== !1, xe = d.WHOLE_DOCUMENT || !1, Je = d.RETURN_DOM || !1, dt = d.RETURN_DOM_FRAGMENT || !1, Ze = d.RETURN_TRUSTED_TYPE || !1, Xe = d.FORCE_BODY || !1, mr = d.SANITIZE_DOM !== !1, yr = d.SANITIZE_NAMED_PROPS || !1, jt = d.KEEP_CONTENT !== !1, ht = d.IN_PLACE || !1, S = d.ALLOWED_URI_REGEXP || hi, at = d.NAMESPACE || Ue, lt = d.MATHML_TEXT_INTEGRATION_POINTS || lt, mt = d.HTML_INTEGRATION_POINTS || mt, j = d.CUSTOM_ELEMENT_HANDLING || {}, d.CUSTOM_ELEMENT_HANDLING && $t(d.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (j.tagNameCheck = d.CUSTOM_ELEMENT_HANDLING.tagNameCheck), d.CUSTOM_ELEMENT_HANDLING && $t(d.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (j.attributeNameCheck = d.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), d.CUSTOM_ELEMENT_HANDLING && typeof d.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (j.allowCustomizedBuiltInElements = d.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), A && (J = !1), dt && (Je = !0), Qe && (P = Q({}, bo), D = [], Qe.html === !0 && (Q(P, vo), Q(D, Eo)), Qe.svg === !0 && (Q(P, Zr), Q(D, tn), Q(D, Cr)), Qe.svgFilters === !0 && (Q(P, Qr), Q(D, tn), Q(D, Cr)), Qe.mathMl === !0 && (Q(P, en), Q(D, To), Q(D, Cr))), d.ADD_TAGS && (P === Y && (P = gt(P)), Q(P, d.ADD_TAGS, ye)), d.ADD_ATTR && (D === $ && (D = gt(D)), Q(D, d.ADD_ATTR, ye)), d.ADD_URI_SAFE_ATTR && Q(Et, d.ADD_URI_SAFE_ATTR, ye), d.FORBID_CONTENTS && (et === st && (et = gt(et)), Q(et, d.FORBID_CONTENTS, ye)), jt && (P["#text"] = !0), xe && Q(P, ["html", "head", "body"]), P.table && (Q(P, ["tbody"]), delete B.tbody), d.TRUSTED_TYPES_POLICY) {
        if (typeof d.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw Zt('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof d.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw Zt('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        M = d.TRUSTED_TYPES_POLICY, O = M.createHTML("");
      } else
        M === void 0 && (M = Wl(m, n)), M !== null && typeof O == "string" && (O = M.createHTML(""));
      Ce && Ce(d), rt = d;
    }
  }, br = Q({}, [...Zr, ...Qr, ...Cl]), Er = Q({}, [...en, ...xl]), Tr = function(d) {
    let b = F(d);
    (!b || !b.tagName) && (b = {
      namespaceURI: at,
      tagName: "template"
    });
    const C = Ir(d.tagName), Z = Ir(b.tagName);
    return Ut[d.namespaceURI] ? d.namespaceURI === wt ? b.namespaceURI === Ue ? C === "svg" : b.namespaceURI === Ot ? C === "svg" && (Z === "annotation-xml" || lt[Z]) : !!br[C] : d.namespaceURI === Ot ? b.namespaceURI === Ue ? C === "math" : b.namespaceURI === wt ? C === "math" && mt[Z] : !!Er[C] : d.namespaceURI === Ue ? b.namespaceURI === wt && !mt[Z] || b.namespaceURI === Ot && !lt[Z] ? !1 : !Er[C] && (ct[C] || !br[C]) : !!(tt === "application/xhtml+xml" && Ut[d.namespaceURI]) : !1;
  }, Ie = function(d) {
    Xt(t.removed, {
      element: d
    });
    try {
      F(d).removeChild(d);
    } catch {
      _(d);
    }
  }, _t = function(d, b) {
    try {
      Xt(t.removed, {
        attribute: b.getAttributeNode(d),
        from: b
      });
    } catch {
      Xt(t.removed, {
        attribute: null,
        from: b
      });
    }
    if (b.removeAttribute(d), d === "is" && !D[d])
      if (Je || dt)
        try {
          Ie(b);
        } catch {
        }
      else
        try {
          b.setAttribute(d, "");
        } catch {
        }
  }, Or = function(d) {
    let b = null, C = null;
    if (Xe)
      d = "<remove></remove>" + d;
    else {
      const ce = go(d, /^[\r\n\t ]+/);
      C = ce && ce[0];
    }
    tt === "application/xhtml+xml" && at === Ue && (d = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + d + "</body></html>");
    const Z = M ? M.createHTML(d) : d;
    if (at === Ue)
      try {
        b = new h().parseFromString(Z, tt);
      } catch {
      }
    if (!b || !b.documentElement) {
      b = W.createDocument(at, "template", null);
      try {
        b.documentElement.innerHTML = Wt ? O : Z;
      } catch {
      }
    }
    const de = b.body || b.documentElement;
    return d && C && de.insertBefore(r.createTextNode(C), de.childNodes[0] || null), at === Ue ? Se.call(b, xe ? "html" : "body")[0] : xe ? b.documentElement : de;
  }, wr = function(d) {
    return q.call(
      d.ownerDocument || d,
      d,
      // eslint-disable-next-line no-bitwise
      f.SHOW_ELEMENT | f.SHOW_COMMENT | f.SHOW_TEXT | f.SHOW_PROCESSING_INSTRUCTION | f.SHOW_CDATA_SECTION,
      null
    );
  }, Sr = function(d) {
    return d instanceof c && (typeof d.nodeName != "string" || typeof d.textContent != "string" || typeof d.removeChild != "function" || !(d.attributes instanceof u) || typeof d.removeAttribute != "function" || typeof d.setAttribute != "function" || typeof d.namespaceURI != "string" || typeof d.insertBefore != "function" || typeof d.hasChildNodes != "function");
  }, p = function(d) {
    return typeof a == "function" && d instanceof a;
  };
  function T(w, d, b) {
    pe[w] && Pr(pe[w], (C) => {
      C.call(t, d, b, rt);
    });
  }
  const N = function(d) {
    let b = null;
    if (T("beforeSanitizeElements", d, null), Sr(d))
      return Ie(d), !0;
    const C = ye(d.nodeName);
    if (T("uponSanitizeElement", d, {
      tagName: C,
      allowedTags: P
    }), d.hasChildNodes() && !p(d.firstElementChild) && Re(/<[/\w]/g, d.innerHTML) && Re(/<[/\w]/g, d.textContent) || d.nodeType === er.progressingInstruction || Oe && d.nodeType === er.comment && Re(/<[/\w]/g, d.data))
      return Ie(d), !0;
    if (!P[C] || B[C]) {
      if (!B[C] && ne(C) && (j.tagNameCheck instanceof RegExp && Re(j.tagNameCheck, C) || j.tagNameCheck instanceof Function && j.tagNameCheck(C)))
        return !1;
      if (jt && !et[C]) {
        const Z = F(d) || d.parentNode, de = E(d) || d.childNodes;
        if (de && Z) {
          const ce = de.length;
          for (let le = ce - 1; le >= 0; --le) {
            const Ae = g(de[le], !0);
            Ae.__removalCount = (d.__removalCount || 0) + 1, Z.insertBefore(Ae, x(d));
          }
        }
      }
      return Ie(d), !0;
    }
    return d instanceof l && !Tr(d) || (C === "noscript" || C === "noembed" || C === "noframes") && Re(/<\/no(script|embed|frames)/i, d.innerHTML) ? (Ie(d), !0) : (A && d.nodeType === er.text && (b = d.textContent, Pr([Ee, me, be], (Z) => {
      b = Jt(b, Z, " ");
    }), d.textContent !== b && (Xt(t.removed, {
      element: d.cloneNode()
    }), d.textContent = b)), T("afterSanitizeElements", d, null), !1);
  }, U = function(d, b, C) {
    if (mr && (b === "id" || b === "name") && (C in r || C in Ur))
      return !1;
    if (!(J && !H[b] && Re(Fe, b))) {
      if (!(V && Re(_e, b))) {
        if (!D[b] || H[b]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !(ne(d) && (j.tagNameCheck instanceof RegExp && Re(j.tagNameCheck, d) || j.tagNameCheck instanceof Function && j.tagNameCheck(d)) && (j.attributeNameCheck instanceof RegExp && Re(j.attributeNameCheck, b) || j.attributeNameCheck instanceof Function && j.attributeNameCheck(b)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            b === "is" && j.allowCustomizedBuiltInElements && (j.tagNameCheck instanceof RegExp && Re(j.tagNameCheck, C) || j.tagNameCheck instanceof Function && j.tagNameCheck(C)))
          ) return !1;
        } else if (!Et[b]) {
          if (!Re(S, Jt(C, Ge, ""))) {
            if (!((b === "src" || b === "xlink:href" || b === "href") && d !== "script" && Sl(C, "data:") === 0 && gr[d])) {
              if (!(K && !Re(Me, Jt(C, Ge, "")))) {
                if (C)
                  return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, ne = function(d) {
    return d !== "annotation-xml" && go(d, it);
  }, ie = function(d) {
    T("beforeSanitizeAttributes", d, null);
    const {
      attributes: b
    } = d;
    if (!b)
      return;
    const C = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: D,
      forceKeepAttr: void 0
    };
    let Z = b.length;
    for (; Z--; ) {
      const de = b[Z], {
        name: ce,
        namespaceURI: le,
        value: Ae
      } = de, yt = ye(ce);
      let Te = ce === "value" ? Ae : _l(Ae);
      if (C.attrName = yt, C.attrValue = Te, C.keepAttr = !0, C.forceKeepAttr = void 0, T("uponSanitizeAttribute", d, C), Te = C.attrValue, yr && (yt === "id" || yt === "name") && (_t(ce, d), Te = Dt + Te), Oe && Re(/((--!?|])>)|<\/(style|title)/i, Te)) {
        _t(ce, d);
        continue;
      }
      if (C.forceKeepAttr || (_t(ce, d), !C.keepAttr))
        continue;
      if (!ge && Re(/\/>/i, Te)) {
        _t(ce, d);
        continue;
      }
      A && Pr([Ee, me, be], (Sn) => {
        Te = Jt(Te, Sn, " ");
      });
      const wn = ye(d.nodeName);
      if (U(wn, yt, Te)) {
        if (M && typeof m == "object" && typeof m.getAttributeType == "function" && !le)
          switch (m.getAttributeType(wn, yt)) {
            case "TrustedHTML": {
              Te = M.createHTML(Te);
              break;
            }
            case "TrustedScriptURL": {
              Te = M.createScriptURL(Te);
              break;
            }
          }
        try {
          le ? d.setAttributeNS(le, ce, Te) : d.setAttribute(ce, Te), Sr(d) ? Ie(d) : yo(t.removed);
        } catch {
        }
      }
    }
    T("afterSanitizeAttributes", d, null);
  }, ee = function w(d) {
    let b = null;
    const C = wr(d);
    for (T("beforeSanitizeShadowDOM", d, null); b = C.nextNode(); )
      T("uponSanitizeShadowNode", b, null), !N(b) && (b.content instanceof i && w(b.content), ie(b));
    T("afterSanitizeShadowDOM", d, null);
  };
  return t.sanitize = function(w) {
    let d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, b = null, C = null, Z = null, de = null;
    if (Wt = !w, Wt && (w = "<!-->"), typeof w != "string" && !p(w))
      if (typeof w.toString == "function") {
        if (w = w.toString(), typeof w != "string")
          throw Zt("dirty is not a string, aborting");
      } else
        throw Zt("toString is not a function");
    if (!t.isSupported)
      return w;
    if (We || St(d), t.removed = [], typeof w == "string" && (ht = !1), ht) {
      if (w.nodeName) {
        const Ae = ye(w.nodeName);
        if (!P[Ae] || B[Ae])
          throw Zt("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (w instanceof a)
      b = Or("<!---->"), C = b.ownerDocument.importNode(w, !0), C.nodeType === er.element && C.nodeName === "BODY" || C.nodeName === "HTML" ? b = C : b.appendChild(C);
    else {
      if (!Je && !A && !xe && // eslint-disable-next-line unicorn/prefer-includes
      w.indexOf("<") === -1)
        return M && Ze ? M.createHTML(w) : w;
      if (b = Or(w), !b)
        return Je ? null : Ze ? O : "";
    }
    b && Xe && Ie(b.firstChild);
    const ce = wr(ht ? w : b);
    for (; Z = ce.nextNode(); )
      N(Z) || (Z.content instanceof i && ee(Z.content), ie(Z));
    if (ht)
      return w;
    if (Je) {
      if (dt)
        for (de = ve.call(b.ownerDocument); b.firstChild; )
          de.appendChild(b.firstChild);
      else
        de = b;
      return (D.shadowroot || D.shadowrootmode) && (de = he.call(o, de, !0)), de;
    }
    let le = xe ? b.outerHTML : b.innerHTML;
    return xe && P["!doctype"] && b.ownerDocument && b.ownerDocument.doctype && b.ownerDocument.doctype.name && Re(mi, b.ownerDocument.doctype.name) && (le = "<!DOCTYPE " + b.ownerDocument.doctype.name + `>
` + le), A && Pr([Ee, me, be], (Ae) => {
      le = Jt(le, Ae, " ");
    }), M && Ze ? M.createHTML(le) : le;
  }, t.setConfig = function() {
    let w = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    St(w), We = !0;
  }, t.clearConfig = function() {
    rt = null, We = !1;
  }, t.isValidAttribute = function(w, d, b) {
    rt || St({});
    const C = ye(w), Z = ye(d);
    return U(C, Z, b);
  }, t.addHook = function(w, d) {
    typeof d == "function" && (pe[w] = pe[w] || [], Xt(pe[w], d));
  }, t.removeHook = function(w) {
    if (pe[w])
      return yo(pe[w]);
  }, t.removeHooks = function(w) {
    pe[w] && (pe[w] = []);
  }, t.removeAllHooks = function() {
    pe = {};
  }, t;
}
var wo = yi();
const gi = ({
  index: e,
  step: t,
  backProps: { onClick: r, ...o },
  skipProps: { onClick: n, ...i },
  primaryProps: { onClick: s, ...a },
  tooltipProps: l,
  size: f,
  logger: u,
  jumpToStep: c,
  type: h,
  isLastStep: m,
  hideLastButton: y,
  hideFirstPrevButton: g
}) => {
  const _ = (W) => {
    var q;
    (q = u == null ? void 0 : u.current) == null || q.logMessage("prev click"), r(W);
  }, x = (W) => {
    var q;
    (q = u == null ? void 0 : u.current) == null || q.logMessage("close click"), n(W);
  }, E = (W) => {
    var q;
    (q = u == null ? void 0 : u.current) == null || q.logMessage("next click"), s(W);
  }, F = (W) => {
    var q;
    (q = u == null ? void 0 : u.current) == null || q.logMessage(`jump to step ${W}`), c && c(W);
  }, M = h === "Web" ? /* @__PURE__ */ ue.jsx(
    "div",
    {
      className: "lib-tooltip-text",
      dangerouslySetInnerHTML: {
        __html: wo.sanitize(t.title)
      }
    }
  ) : /* @__PURE__ */ ue.jsx("h1", { className: "lib-tooltip-text lib-tooltip-title", children: t.title }), O = h === "Web" ? /* @__PURE__ */ ue.jsx(
    "div",
    {
      className: "lib-tooltip-text mb-4",
      dangerouslySetInnerHTML: {
        __html: wo.sanitize(t.content)
      }
    }
  ) : /* @__PURE__ */ ue.jsx("div", { className: "lib-tooltip-text mb-4", children: t.content });
  return /* @__PURE__ */ ue.jsxs("div", { className: "d-flex flex-column", ...l, children: [
    /* @__PURE__ */ ue.jsxs("div", { className: "position-relative lib-tooltip-header", children: [
      M,
      /* @__PURE__ */ ue.jsx(
        "button",
        {
          className: "position-absolute btn-text lib-skipbutton",
          onClick: x,
          ...i,
          children: /* @__PURE__ */ ue.jsx(
            "svg",
            {
              xmlns: "http://www.w3.org/2000/svg",
              width: "16",
              height: "16",
              viewBox: "0 0 16 16",
              fill: "none",
              children: /* @__PURE__ */ ue.jsx("g", { opacity: "0.4", children: /* @__PURE__ */ ue.jsx(
                "path",
                {
                  d: "M4 12L12 4M4 4L12 12",
                  stroke: "#323232",
                  strokeWidth: "1.5",
                  strokeLinecap: "round",
                  strokeLinejoin: "round"
                }
              ) })
            }
          )
        }
      )
    ] }),
    O,
    /* @__PURE__ */ ue.jsxs("div", { className: "d-flex justify-content-between align-items-center", children: [
      /* @__PURE__ */ ue.jsx("div", { children: /* @__PURE__ */ ue.jsx("div", { className: "lib-bullets pe-5", children: /* @__PURE__ */ ue.jsx("div", { "aria-label": "Slide controls", children: Array.from({ length: f }).map((W, q) => /* @__PURE__ */ ue.jsx(
        "button",
        {
          className: "pagination-indicator-button",
          onClick: () => F(q),
          children: /* @__PURE__ */ ue.jsx(
            "span",
            {
              className: `pagination-indicator ${e === q ? "active" : ""}`
            }
          )
        },
        `key-${q}`
      )) }) }) }),
      /* @__PURE__ */ ue.jsxs("div", { className: "gap-2", children: [
        !(g && e === 0) && /* @__PURE__ */ ue.jsx(
          "button",
          {
            className: "btn btn-sm btn-text",
            disabled: e === 0,
            onClick: _,
            ...o
          }
        ),
        !(m && y) && /* @__PURE__ */ ue.jsx(
          "button",
          {
            className: "btn btn-sm btn-primary",
            onClick: E,
            ...a
          }
        )
      ] })
    ] })
  ] });
}, Ul = ({
  run: e,
  steps: t,
  logger: r,
  type: o,
  callback: n,
  ...i
}) => {
  const [s, a] = tr(!1), [l, f] = tr(0), [u, c] = tr(null);
  rn(() => {
    a(!!e);
  }, [e]);
  const h = (g) => {
    if (c(g), g === 0) {
      let _ = (l + 1) % t.length;
      for (; _ === 0 || _ === l; )
        _ = (_ + 1) % t.length;
      f(_);
    } else f(-1);
  }, m = (g) => {
    const { action: _, index: x, status: E, type: F } = g;
    if ([X.FINISHED, X.SKIPPED].includes(E))
      a(!1), f(0);
    else if ([ke.STEP_AFTER, ke.TARGET_NOT_FOUND].includes(F)) {
      let M = x + (_ === oe.PREV ? -1 : 1);
      u !== null && (M = u, c(null)), f(M);
    }
    n == null || n(g);
  }, y = { back: "Previous", ...i.locale };
  return /* @__PURE__ */ ue.jsx(
    fi,
    {
      steps: t,
      run: s,
      callback: m,
      stepIndex: l,
      disableOverlayClose: !0,
      tooltipComponent: (g) => /* @__PURE__ */ ue.jsx(
        gi,
        {
          logger: r,
          jumpToStep: h,
          type: o,
          hideLastButton: i.hideLastButton,
          hideFirstPrevButton: i.hideFirstPrevButton,
          ...g
        }
      ),
      locale: y,
      ...i
    }
  );
};
class xr {
  constructor(t, r, o, n, i) {
    Rt(this, "_logger");
    Rt(this, "_appName");
    Rt(this, "_hrId");
    Rt(this, "_tourId");
    Rt(this, "_analyticMetrics");
    this._logger = t, this._appName = r, this._hrId = o, this._tourId = n, this._analyticMetrics = i;
  }
  logMessage(t, r) {
    this._logger && this._logger.info(t, {
      appName: this._appName,
      hrId: globalThis.btoa(this._hrId),
      tourId: this._tourId,
      analyticMetrics: this._analyticMetrics,
      ...r
    });
  }
  logError(t, r) {
    if (this._logger) {
      const o = r instanceof Error ? { name: r.name, message: r.message, stack: r.stack } : r;
      this._logger.error(t, {
        appName: this._appName,
        hrId: globalThis.btoa(this._hrId),
        tourId: this._tourId,
        analyticMetrics: this._analyticMetrics,
        ...o
      });
    }
  }
}
const Bl = "0.2.0-preview-13";
function So(e) {
  return {
    clientToken: "pub5138ae73bbde80d8092051c256b4c31b",
    service: "bcg-react-tour",
    site: "datadoghq.com",
    forwardErrorsToLogs: !1,
    sessionSampleRate: 100,
    env: e,
    version: Bl
  };
}
async function $l(e, t, r, o, n) {
  if (window.DD_LOGS) {
    const i = window.DD_LOGS;
    return await import("./main-CGaR1OQy.js").then((s) => (s == null || s.datadogLogs.init(So(t)), window.DD_LOGS = i, new xr(
      s == null ? void 0 : s.datadogLogs.logger,
      e,
      r,
      o,
      n
    ))).catch((s) => (console.log(s), new xr(null, e, r, o, n)));
  } else
    return await import("./main-CGaR1OQy.js").then((i) => (i == null || i.datadogLogs.init(So(t)), window.DD_LOGS = null, new xr(
      i == null ? void 0 : i.datadogLogs.logger,
      e,
      r,
      o,
      n
    ))).catch((i) => (console.log(i), new xr(null, e, r, o, n)));
}
const Yl = ({
  publisherId: e,
  tourId: t,
  appName: r,
  hrId: o,
  apiKey: n,
  psid: i,
  environment: s,
  accessToken: a,
  run: l = !0,
  disableBeacon: f = !0,
  enableControlledMode: u = !1,
  ...c
}) => {
  const [h, m] = tr([]), [y, g] = tr("Web"), { steps: _, ...x } = c, E = Ei();
  if (!r || typeof r != "string" || r.trim() === "")
    throw new Error(
      "appName is a required property and cannot be empty. So please pass it as an attribute or property to the component."
    );
  rn(() => {
    (async () => {
      var q, ve;
      const O = (q = c.analyticMetric) == null ? void 0 : q.reduce((Se, he) => (Se[he.key] = he.value, Se), {});
      E.current = await $l(
        r,
        s,
        o,
        t ?? "",
        O
      );
      const W = {
        tourId: t,
        disableBeacon: f,
        enableControlledMode: u
      };
      (ve = E == null ? void 0 : E.current) == null || ve.logMessage("component loaded", W);
    })();
  }, []), rn(() => {
    let O = !0;
    const W = new AbortController(), q = W.signal;
    return (async () => {
      var Se, he;
      try {
        if (t) {
          const pe = await El(
            { tourId: t, environment: s, accessToken: a, psid: i, apiKey: n },
            q
          );
          O && (m(
            (Se = pe.steps) == null ? void 0 : Se.map((Ee, me) => ({
              target: Ee.selector,
              content: Ee.description,
              title: Ee.title,
              placement: Ee.placement ? Ee.placement.toLowerCase() : "auto",
              disableBeacon: me === 0 ? f : !0,
              //disableBeacon for first step
              isStepDisabled: Ee.isStepDisabled || !1
            }))
          ), g(pe.onboardingType));
        }
      } catch (pe) {
        q.aborted || (console.error("Failed to fetch steps:", pe), (he = E == null ? void 0 : E.current) == null || he.logError("Failed to fetch steps:", pe));
      }
    })(), () => {
      O = !1, W.abort();
    };
  }, [t, s, a, i, n]);
  const F = (O) => O == null ? void 0 : O.filter((W) => !W.isStepDisabled), M = { back: "Previous", ...c.locale };
  return /* @__PURE__ */ ue.jsx("div", { children: u ? /* @__PURE__ */ ue.jsx(
    Ul,
    {
      run: l,
      steps: F(t ? h : _),
      logger: E,
      type: t ? y : c.type ?? "Web",
      locale: M,
      ...x
    }
  ) : /* @__PURE__ */ ue.jsx(
    fi,
    {
      run: l,
      steps: F(t ? h : _),
      tooltipComponent: (O) => /* @__PURE__ */ ue.jsx(
        gi,
        {
          logger: E,
          type: t ? y : c.type ?? "Web",
          hideLastButton: x == null ? void 0 : x.hideLastButton,
          hideFirstPrevButton: x == null ? void 0 : x.hideFirstPrevButton,
          ...O
        }
      ),
      locale: M,
      ...x
    }
  ) });
};
export {
  Yl as default
};
